export const speakerColors = {
  0:'red',
  1:'orange',
  2:'yellow',
  3:'green',
  4:'#2e2eb9',
  5:'purple',
  6:'purple',
  7:'black',
  8:'gold',
}

export const inupiaqSpeakerIDs = {
"Aglu (Whittier Williams Jr.)":0,
"I'yiiqpak (Gladys Pungowiyi)":1,
"Kapniaq (Lorena Williams)":2,
"Maqik (Mary Schaeffer)":3,
"Mumigaaluk (James Nageak)":4,
"Paniattaaq (Dr. Edna Ahgeak MacLean)":5,
"Taġġaq (Lawrence Kaplan)":6,
"Uyuġuluk (Marilyn Koezuna-Irelan)":7,
"Yaayuk (Bernadette Alvanna-Stimpfle)":8,    
}


export const popularVerbsOptative = [
{'englishnorm': 'eat', 'yupikword': "ner'uq", 'inf_preverb': 'eat', 'past_preverb': 'ate', 'fsts': ['nere'], 'fstsDisplay': 'nere-', 'key': 'nere-', 'englishtenses': ['eat', 'ate', 'eats', 'eating', 'eaten'], 'properties': [], 'englishmain': '!is! eating', 'englishraw': '\u27e8eat\u27e9', 'base_case': 'is eating', 'ger_preverb': 'eating', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'come in', 'yupikword': 'itertuq', 'inf_preverb': 'come in', 'past_preverb': 'came in', 'fsts': ['iter'], 'fstsDisplay': 'iter-', 'key': 'iter-', 'englishtenses': ['come', 'came', 'comes', 'coming', 'come'], 'properties': [], 'englishmain': 'came in', 'englishraw': '\u27e8come\u27e9 in', 'base_case': 'came in', 'ger_preverb': 'coming in', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'go out', 'yupikword': "an'uq", 'inf_preverb': 'go out', 'past_preverb': 'went out', 'fsts': ['ane'], 'fstsDisplay': 'ane-', 'key': 'ane-', 'englishtenses': ['go', 'went', 'goes', 'going', 'gone'], 'properties': [], 'englishmain': 'went out', 'englishraw': '\u27e8go\u27e9 out', 'base_case': 'went out', 'ger_preverb': 'going out', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'sit down', 'yupikword': 'aqumuq', 'inf_preverb': 'sit down', 'past_preverb': 'sat down', 'fsts': ['aqume'], 'fstsDisplay': 'aqume-', 'key': 'aqume-', 'englishtenses': ['sit', 'sat', 'sits', 'sitting', 'sat'], 'properties': [], 'englishmain': 'sat down', 'englishraw': '\u27e8sit\u27e9 down', 'base_case': 'sat down', 'ger_preverb': 'sitting down', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'lay down', 'yupikword': 'inartuq', 'inf_preverb': 'lay down', 'past_preverb': 'laid down', 'fsts': ['inarte'], 'fstsDisplay': 'inarte-', 'key': 'inarte-', 'englishtenses': ['lay', 'laid', 'lays', 'laying', 'laid'], 'properties': [], 'englishmain': 'lay down', 'englishraw': '\u27e8lay\u27e9 down', 'base_case': 'lay down', 'ger_preverb': 'laying down', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'work', 'yupikword': 'caliuq', 'inf_preverb': 'work', 'past_preverb': 'worked', 'fsts': ['cali'], 'fstsDisplay': 'cali-', 'key': 'cali-', 'englishtenses': ['work', 'worked', 'works', 'working', 'worked'], 'properties': [], 'englishmain': '!is! working', 'englishraw': '\u27e8work\u27e9', 'base_case': 'is working', 'ger_preverb': 'working', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'get up', 'yupikword': 'maktuq', 'inf_preverb': 'get up', 'past_preverb': 'got up', 'fsts': ['makte'], 'fstsDisplay': 'makte-', 'key': 'makte-', 'englishtenses': ['get', 'got', 'gets', 'getting', 'got'], 'properties': [], 'englishmain': 'got up', 'englishraw': '\u27e8get\u27e9 up', 'base_case': 'got up', 'ger_preverb': 'getting up', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'listen', 'yupikword': 'niicugniuq', 'inf_preverb': 'listen', 'past_preverb': 'listened', 'fsts': ['niicugni'], 'fstsDisplay': 'niicugni-', 'key': 'niicugni-', 'englishtenses': ['listen', 'listened', 'listens', 'listening', 'listened'], 'properties': [], 'englishmain': '!is! listening', 'englishraw': '\u27e8listen\u27e9', 'base_case': 'is listening', 'ger_preverb': 'listening', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'answer', 'yupikword': 'kiugaa', 'inf_preverb': 'answer <him>', 'past_preverb': 'answered <him>', 'fsts': ['ki'], 'fstsDisplay': 'kiu-', 'key': 'kiu-', 'englishtenses': ['answer', 'answered', 'answers', 'answering', 'answered'], 'properties': [], 'englishmain': 'answered <him>', 'englishraw': '\u27e8answer\u27e9 <him>', 'base_case': 'answered him', 'ger_preverb': 'answering <him>', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'try', 'yupikword': 'naspaagaa', 'inf_preverb': 'try <it>', 'past_preverb': 'tried <it>', 'fsts': ['naspaa'], 'fstsDisplay': 'naspaa-', 'key': 'naspaa-', 'englishtenses': ['try', 'tried', 'tries', 'trying', 'tried'], 'properties': [], 'englishmain': '!is! trying <it>', 'englishraw': '\u27e8try\u27e9 <it>', 'base_case': 'is trying it', 'ger_preverb': 'trying <it>', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'own', 'yupikword': 'pikaa', 'inf_preverb': 'own <it>', 'past_preverb': 'owned <it>', 'fsts': ['pike'], 'fstsDisplay': 'pike-', 'key': 'pike-', 'englishtenses': ['own', 'owned', 'owns', 'owning', 'owned'], 'properties': [], 'englishmain': 'owns <it>', 'englishraw': '\u27e8own\u27e9 <it>', 'base_case': 'owns it', 'ger_preverb': 'owning <it>', 'usageIndex': 0, 'type': 't'},
{'englishnorm': 'give to someone', 'yupikword': 'tunaa', 'inf_preverb': 'give <it> to someone', 'past_preverb': 'gave <it> to someone', 'fsts': ['tune'], 'fstsDisplay': 'tune-', 'key': 'tune-', 'englishtenses': ['give', 'gave', 'gives', 'giving', 'given'], 'properties': [], 'englishmain': 'gave <it> to someone', 'englishraw': '\u27e8give\u27e9 <it> to someone', 'base_case': 'gave it to someone', 'ger_preverb': 'giving <it> to someone', 'usageIndex': 4, 'type': 't'},
{'englishnorm': 'use', 'yupikword': 'aturaa', 'inf_preverb': 'use <it>', 'past_preverb': 'used <it>', 'fsts': ['atur'], 'fstsDisplay': 'atur-', 'key': 'atuq,atur-', 'englishtenses': ['use', 'used', 'uses', 'using', 'used'], 'properties': [], 'englishmain': '!is! using <it>', 'englishraw': '\u27e8use\u27e9 <it>', 'base_case': 'is using it', 'ger_preverb': 'using <it>', 'usageIndex': 3, 'type': 't'},
{'englishnorm': 'open', 'yupikword': 'ikirtaa', 'inf_preverb': 'open <it>', 'past_preverb': 'opened <it>', 'fsts': ['ikirte'], 'fstsDisplay': 'ikirte-', 'key': 'ikirte-', 'englishtenses': ['open', 'opened', 'opens', 'opening', 'opened'], 'properties': [], 'englishmain': 'opened <it>', 'englishraw': '\u27e8open\u27e9 <it>', 'base_case': 'opened it', 'ger_preverb': 'opening <it>', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'buy', 'yupikword': 'kiputaa', 'inf_preverb': 'buy <it>', 'past_preverb': 'bought <it>', 'fsts': ['kipute'], 'fstsDisplay': 'kipute-', 'key': 'kipute-', 'englishtenses': ['buy', 'bought', 'buys', 'buying', 'bought'], 'properties': [], 'englishmain': 'bought <it>', 'englishraw': '\u27e8buy\u27e9 <it>', 'base_case': 'bought it', 'ger_preverb': 'buying <it>', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'wash', 'yupikword': 'eruraa', 'inf_preverb': 'wash <it>', 'past_preverb': 'washed <it>', 'fsts': ['erur'], 'fstsDisplay': 'erur-', 'key': 'erur-', 'englishtenses': ['wash', 'washed', 'washes', 'washing', 'washed'], 'properties': [], 'englishmain': '!is! washing <it>', 'englishraw': '\u27e8wash\u27e9 <it>', 'base_case': 'is washing it', 'ger_preverb': 'washing <it>', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'pass over', 'yupikword': 'taitaa', 'inf_preverb': 'pass <it> over', 'past_preverb': 'passed <it> over', 'fsts': ['taite\xb9'], 'fstsDisplay': 'taite\xb9-', 'key': 'taite\xb9-', 'englishtenses': ['pass', 'passed', 'passes', 'passing', 'passed'], 'properties': [], 'englishmain': 'passed <it> over', 'englishraw': '\u27e8pass\u27e9 <it> over', 'base_case': 'passed it over', 'ger_preverb': 'passing <it> over', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'go with', 'yupikword': 'maligtaa', 'inf_preverb': 'go with <her*>', 'past_preverb': 'went with <her*>', 'fsts': ['maligte'], 'fstsDisplay': 'maligte-', 'key': 'maligte-', 'englishtenses': ['go', 'went', 'goes', 'going', 'gone'], 'properties': [], 'englishmain': '!is! going with <her*>', 'englishraw': '\u27e8go\u27e9 with <her*>', 'base_case': 'is going with her*', 'ger_preverb': 'going with <her*>', 'usageIndex': 0, 'type': 't'},
{'englishnorm': 'eat', 'yupikword': 'neraa', 'inf_preverb': 'eat <it>', 'past_preverb': 'ate <it>', 'fsts': ['nere'], 'fstsDisplay': 'nere-', 'key': 'nere-', 'englishtenses': ['eat', 'ate', 'eats', 'eating', 'eaten'], 'properties': [], 'englishmain': '!is! eating <it>', 'englishraw': '\u27e8eat\u27e9 <it>', 'base_case': 'is eating it', 'ger_preverb': 'eating <it>', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'ask', 'yupikword': 'aptaa', 'inf_preverb': 'ask <her*>', 'past_preverb': 'asked <her*>', 'fsts': ['apte'], 'fstsDisplay': 'apte-', 'key': 'apte-', 'englishtenses': ['ask', 'asked', 'asks', 'asking', 'asked'], 'properties': [], 'englishmain': 'asked <her*>', 'englishraw': '\u27e8ask\u27e9 <her*>', 'base_case': 'asked her*', 'ger_preverb': 'asking <her*>', 'usageIndex': 2, 'type': 't'},
]

export const popularNounsDescriptors = [
{'englishnorm': 'new thing, fresh thing, fresh fish', 'yupikword': 'nutaraq', 'fsts': ['nutarar'], 'fstsDisplay': 'nutarar-', 'key': 'nutaraq', 'englishtenses': [['thing', 'things'], ['thing', 'things'], ['fish', 'fish']], 'properties': [], 'englishmain': ['new \u27e8thing\u27e9', 'fresh \u27e8thing\u27e9', 'fresh \u27e8fish\u27e9'], 'englishraw': 'new \u27e8thing\u27e9, fresh \u27e8thing\u27e9, fresh \u27e8fish\u27e9', 'base_case': 'new thing, fresh thing, fresh fish', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'old thing, thing of the past', 'yupikword': "ak'allaq", 'fsts': ["ak'allar"], 'fstsDisplay': "ak'allar-", 'key': "ak'allaq", 'englishtenses': [['thing', 'things'], ['thing', 'things']], 'properties': [], 'englishmain': ['old \u27e8thing\u27e9', '\u27e8thing\u27e9 of the past'], 'englishraw': 'old \u27e8thing\u27e9, \u27e8thing\u27e9 of the past', 'base_case': 'old thing, thing of the past', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'big thing', 'yupikword': 'angtuaq', 'fsts': ['angtuar'], 'fstsDisplay': 'angtuar-', 'key': 'angtuaq', 'englishtenses': [['thing', 'things']], 'properties': [], 'englishmain': ['big \u27e8thing\u27e9'], 'englishraw': 'big \u27e8thing\u27e9', 'base_case': 'big thing', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'white person, Caucasian, priest, especially Russian Orthodox priest', 'yupikword': "kass'aq", 'fsts': ["kass'ar"], 'fstsDisplay': "kass'ar-", 'key': "kass'aq", 'englishtenses': [['person', 'people'], ['Caucasian', 'Caucasians'], ['priest', 'priests'], ['priest', 'priests']], 'properties': [], 'englishmain': ['white \u27e8person\u27e9', '\u27e8Caucasian\u27e9', '\u27e8priest\u27e9', 'especially Russian Orthodox \u27e8priest\u27e9'], 'englishraw': 'white \u27e8person\u27e9, \u27e8Caucasian\u27e9, \u27e8priest\u27e9, especially Russian Orthodox \u27e8priest\u27e9', 'base_case': 'white person, Caucasian, priest, especially Russian Orthodox priest', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'red thing, low-bush cranberry (Vaccinium vitis-idaea)', 'yupikword': 'kavirliq', 'fsts': ['kavirlir'], 'fstsDisplay': 'kavirlir-', 'key': 'kavirliq', 'englishtenses': [['thing', 'things'], ['cranberry', 'cranberries']], 'properties': [], 'englishmain': ['red \u27e8thing\u27e9', 'low-bush \u27e8cranberry\u27e9 (Vaccinium vitis-idaea)'], 'englishraw': 'red \u27e8thing\u27e9, low-bush \u27e8cranberry\u27e9 (Vaccinium vitis-idaea)', 'base_case': 'red thing, low-bush cranberry (Vaccinium vitis-idaea)', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'black thing', 'yupikword': 'tungulria', 'fsts': ['tungulria'], 'fstsDisplay': 'tungulria-', 'key': 'tungulria', 'englishtenses': [['thing', 'things']], 'properties': [], 'englishmain': ['black \u27e8thing\u27e9'], 'englishraw': 'black \u27e8thing\u27e9', 'base_case': 'black thing', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'white thing, the color white', 'yupikword': 'qatellria', 'fsts': ['qatellria', 'qatelria'], 'fstsDisplay': 'qatellria-, qatelria-', 'key': 'qatellria,qatelria', 'englishtenses': [['thing', 'things']], 'properties': [], 'englishmain': ['white \u27e8thing\u27e9, the color white'], 'englishraw': 'white \u27e8thing\u27e9, the color white', 'base_case': 'white thing, the color white', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'green thing', 'yupikword': 'cungagliq', 'fsts': ['cungaglir'], 'fstsDisplay': 'cungaglir-', 'key': 'cungagliq', 'englishtenses': [['thing', 'things']], 'properties': [], 'englishmain': ['green \u27e8thing\u27e9'], 'englishraw': 'green \u27e8thing\u27e9', 'base_case': 'green thing', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'yellow thing', 'yupikword': 'esirliq', 'fsts': ['esirlir', 'esirngalngur*'], 'fstsDisplay': 'esirlir-, esirngalngur*-', 'key': 'esirliq,esirngalnguq*', 'englishtenses': [['thing', 'things']], 'properties': [], 'englishmain': ['yellow \u27e8thing\u27e9'], 'englishraw': 'yellow \u27e8thing\u27e9', 'base_case': 'yellow thing', 'usageIndex': 0, 'type': 'n'},
]

export const popularVerbs = [
{'englishnorm': 'eat', 'yupikword': "ner'uq", 'fsts': ['nere'], 'fstsDisplay': 'nere-', 'key': 'nere-', 'englishtenses': ['eat', 'ate', 'eats', 'eating', 'eaten'], 'properties': [], 'englishmain': '!is! eating', 'englishraw': '\u27e8eat\u27e9', 'base_case': 'eat', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'eat', 'yupikword': "ner'uq", 'fsts': ['nere'], 'fstsDisplay': 'nere-', 'key': 'nere-', 'englishtenses': ['eat', 'ate', 'eats', 'eating', 'eaten'], 'properties': [], 'englishmain': '!is! eating <something>', 'englishraw': '\u27e8eat\u27e9 <something>', 'base_case': 'eat', 'usageIndex': 1, 'type': 'it'},
{'englishnorm': 'eat', 'yupikword': 'neraa', 'fsts': ['nere'], 'fstsDisplay': 'nere-', 'key': 'nere-', 'englishtenses': ['eat', 'ate', 'eats', 'eating', 'eaten'], 'properties': [], 'englishmain': '!is! eating <it>', 'englishraw': '\u27e8eat\u27e9 <it>', 'base_case': 'eat', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'hunt', 'yupikword': 'pissurtuq', 'fsts': ['pissur'], 'fstsDisplay': 'pissur-', 'key': 'pissur-', 'englishtenses': ['hunt', 'hunted', 'hunts', 'hunting', 'hunted'], 'properties': [], 'englishmain': '!is! hunting <something>', 'englishraw': '\u27e8hunt\u27e9 <something>', 'base_case': 'hunt', 'usageIndex': 1, 'type': 'it'},
{'englishnorm': 'hunt', 'yupikword': 'pissuraa', 'fsts': ['pissur'], 'fstsDisplay': 'pissur-', 'key': 'pissur-', 'englishtenses': ['hunt', 'hunted', 'hunts', 'hunting', 'hunted'], 'properties': [], 'englishmain': '!is! hunting <it>', 'englishraw': '\u27e8hunt\u27e9 <it>', 'base_case': 'hunt', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'leave', 'yupikword': 'ayagtuq', 'fsts': ['ayag\xb9'], 'fstsDisplay': 'ayag\xb9-', 'key': 'ayag\xb9-', 'englishtenses': ['leave', 'left', 'leaves', 'leaving', 'left'], 'properties': [], 'englishmain': 'left', 'englishraw': '\u27e8leave\u27e9', 'base_case': 'leave', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'come here', 'yupikword': 'taiguq', 'fsts': ['tai'], 'fstsDisplay': 'tai-', 'key': 'tai-', 'englishtenses': ['come', 'came', 'comes', 'coming', 'come'], 'properties': [], 'englishmain': 'came here', 'englishraw': '\u27e8come\u27e9 here', 'base_case': 'come here', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'come in', 'yupikword': 'itertuq', 'fsts': ['iter'], 'fstsDisplay': 'iter-', 'key': 'iter-', 'englishtenses': ['come', 'came', 'comes', 'coming', 'come'], 'properties': [], 'englishmain': 'came in', 'englishraw': '\u27e8come\u27e9 in', 'base_case': 'come in', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'go out', 'yupikword': "an'uq", 'fsts': ['ane'], 'fstsDisplay': 'ane-', 'key': 'ane-', 'englishtenses': ['go', 'went', 'goes', 'going', 'gone'], 'properties': [], 'englishmain': 'went out', 'englishraw': '\u27e8go\u27e9 out', 'base_case': 'go out', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'buy', 'yupikword': 'kiputaa', 'fsts': ['kipute'], 'fstsDisplay': 'kipute-', 'key': 'kipute-', 'englishtenses': ['buy', 'bought', 'buys', 'buying', 'bought'], 'properties': [], 'englishmain': 'bought <it>', 'englishraw': '\u27e8buy\u27e9 <it>', 'base_case': 'buy', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'open', 'yupikword': 'ikirtaa', 'fsts': ['ikirte'], 'fstsDisplay': 'ikirte-', 'key': 'ikirte-', 'englishtenses': ['open', 'opened', 'opens', 'opening', 'opened'], 'properties': [], 'englishmain': 'opened <it>', 'englishraw': '\u27e8open\u27e9 <it>', 'base_case': 'open', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'sit down', 'yupikword': 'aqumuq', 'fsts': ['aqume'], 'fstsDisplay': 'aqume-', 'key': 'aqume-', 'englishtenses': ['sit', 'sat', 'sits', 'sitting', 'sat'], 'properties': [], 'englishmain': 'sat down', 'englishraw': '\u27e8sit\u27e9 down', 'base_case': 'sit down', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'stand up', 'yupikword': 'nangertuq', 'fsts': ['nangerte'], 'fstsDisplay': 'nangerte-', 'key': 'nangerte-', 'englishtenses': ['stand', 'stood', 'stands', 'standing', 'stood'], 'properties': [], 'englishmain': 'stood up', 'englishraw': '\u27e8stand\u27e9 up', 'base_case': 'stand up', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'be well', 'yupikword': 'assirtuq', 'fsts': ['assir'], 'fstsDisplay': 'assir-', 'key': 'assir-', 'englishtenses': ['be', 'was', 'is', 'being', 'been'], 'properties': [], 'englishmain': '!is! well', 'englishraw': '\u27e8be\u27e9 well', 'base_case': 'be well', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'be bad', 'yupikword': 'assiituq', 'fsts': ['assiite'], 'fstsDisplay': 'assiite-', 'key': 'assiite-', 'englishtenses': ['be', 'was', 'is', 'being', 'been'], 'properties': [], 'englishmain': '!is! bad', 'englishraw': '\u27e8be\u27e9 bad', 'base_case': 'be bad', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'be thankful, glad', 'yupikword': 'quyauq', 'fsts': ['quya'], 'fstsDisplay': 'quya-', 'key': 'quya-', 'englishtenses': ['be', 'was', 'is', 'being', 'been'], 'properties': [], 'englishmain': '!is! thankful, glad', 'englishraw': '\u27e8be\u27e9 thankful, glad', 'base_case': 'be thankful, glad', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'act', 'yupikword': 'piuq', 'fsts': ['pi'], 'fstsDisplay': 'pi-', 'key': 'pi,pi-', 'englishtenses': ['act', 'acted', 'acts', 'acting', 'acted'], 'properties': [], 'englishmain': '!is! acting', 'englishraw': '\u27e8act\u27e9', 'base_case': 'act', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'drink coffee', 'yupikword': 'kuuvviartuq', 'fsts': ['kuuvviar'], 'fstsDisplay': 'kuuvviar-', 'key': 'kuuvviaq,kuuvviar-', 'englishtenses': ['drink', 'drank', 'drinks', 'drinking', 'drunk'], 'properties': [], 'englishmain': '!is! drinking coffee', 'englishraw': '\u27e8drink\u27e9 coffee', 'base_case': 'drink coffee', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'speak', 'yupikword': 'qanertuq', 'fsts': ['qaner'], 'fstsDisplay': 'qaner-', 'key': 'qaneq,qaner-', 'englishtenses': ['speak', 'spoke', 'speaks', 'speaking', 'spoken'], 'properties': [], 'englishmain': '!is! speaking', 'englishraw': '\u27e8speak\u27e9', 'base_case': 'speak', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'tell', 'yupikword': 'qanrutaa', 'fsts': ['qanrute'], 'fstsDisplay': 'qanrute-', 'key': 'qanrute-', 'englishtenses': ['tell', 'told', 'tells', 'telling', 'told'], 'properties': [], 'englishmain': 'told <him>', 'englishraw': '\u27e8tell\u27e9 <him>', 'base_case': 'tell', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'ask', 'yupikword': 'aptuq', 'fsts': ['apte'], 'fstsDisplay': 'apte-', 'key': 'apte-', 'englishtenses': ['ask', 'asked', 'asks', 'asking', 'asked'], 'properties': [], 'englishmain': 'asked', 'englishraw': '\u27e8ask\u27e9', 'base_case': 'ask', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'sleep', 'yupikword': 'qavartuq', 'fsts': ['qavar'], 'fstsDisplay': 'qavar-', 'key': 'qavaq,qavar-', 'englishtenses': ['sleep', 'slept', 'sleeps', 'sleeping', 'slept'], 'properties': [], 'englishmain': '!is! sleeping', 'englishraw': '\u27e8sleep\u27e9', 'base_case': 'sleep', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'lay down', 'yupikword': 'inartuq', 'fsts': ['inarte'], 'fstsDisplay': 'inarte-', 'key': 'inarte-', 'englishtenses': ['lay', 'laid', 'lays', 'laying', 'laid'], 'properties': [], 'englishmain': 'lay down', 'englishraw': '\u27e8lay\u27e9 down', 'base_case': 'lay down', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'get up', 'yupikword': 'maktuq', 'fsts': ['makte'], 'fstsDisplay': 'makte-', 'key': 'makte-', 'englishtenses': ['get', 'got', 'gets', 'getting', 'got'], 'properties': [], 'englishmain': 'got up', 'englishraw': '\u27e8get\u27e9 up', 'base_case': 'get up', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'hear', 'yupikword': 'niituq', 'fsts': ['niite'], 'fstsDisplay': 'niite-', 'key': 'niite-', 'englishtenses': ['hear', 'heard', 'hears', 'hearing', 'heard'], 'properties': [], 'englishmain': 'hears <someone or something>', 'englishraw': '\u27e8hear\u27e9 <someone or something>', 'base_case': 'hear', 'usageIndex': 1, 'type': 'it'},
{'englishnorm': 'listen', 'yupikword': 'niicugniuq', 'fsts': ['niicugni'], 'fstsDisplay': 'niicugni-', 'key': 'niicugni-', 'englishtenses': ['listen', 'listened', 'listens', 'listening', 'listened'], 'properties': [], 'englishmain': '!is! listening', 'englishraw': '\u27e8listen\u27e9', 'base_case': 'listen', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'wash', 'yupikword': 'eruraa', 'fsts': ['erur'], 'fstsDisplay': 'erur-', 'key': 'erur-', 'englishtenses': ['wash', 'washed', 'washes', 'washing', 'washed'], 'properties': [], 'englishmain': '!is! washing <it>', 'englishraw': '\u27e8wash\u27e9 <it>', 'base_case': 'wash', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'walk', 'yupikword': 'piyuaguq', 'fsts': ['piyua'], 'fstsDisplay': 'piyua-', 'key': 'piyua-', 'englishtenses': ['walk', 'walked', 'walks', 'walking', 'walked'], 'properties': [], 'englishmain': '!is! walking', 'englishraw': '\u27e8walk\u27e9', 'base_case': 'walk', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'run', 'yupikword': 'aqvaqurtuq', 'fsts': ['aqvaqur'], 'fstsDisplay': 'aqvaqur-', 'key': 'aqvaqur-', 'englishtenses': ['run', 'ran', 'runs', 'running', 'run'], 'properties': [], 'englishmain': '!is! running', 'englishraw': '\u27e8run\u27e9', 'base_case': 'run', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'dance', 'yupikword': 'yurartuq', 'fsts': ['yurar\xb9'], 'fstsDisplay': 'yurar\xb9-', 'key': 'yuraq,yurar\xb9-', 'englishtenses': ['dance', 'danced', 'dances', 'dancing', 'danced'], 'properties': [], 'englishmain': '!is! dancing', 'englishraw': '\u27e8dance\u27e9', 'base_case': 'dance', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'hook for fish', 'yupikword': 'manartuq', 'fsts': ['manar'], 'fstsDisplay': 'manar-', 'key': 'manaq,manar-', 'englishtenses': ['hook', 'hooked', 'hooks', 'hooking', 'hooked'], 'properties': [], 'englishmain': '!is! hooking for fish', 'englishraw': '\u27e8hook\u27e9 for fish', 'base_case': 'hook for fish', 'usageIndex': 1, 'type': 'i'},
]

export const popularVerbsIT = [
{'englishnorm': 'eat', 'yupikword': "ner'uq", 'fsts': ['nere'], 'fstsDisplay': 'nere-', 'key': 'nere-', 'englishtenses': ['eat', 'ate', 'eats', 'eating', 'eaten'], 'properties': [], 'englishmain': '!is! eating', 'englishraw': '\u27e8eat\u27e9', 'base_case': 'eat', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'eat', 'yupikword': "ner'uq", 'fsts': ['nere'], 'fstsDisplay': 'nere-', 'key': 'nere-', 'englishtenses': ['eat', 'ate', 'eats', 'eating', 'eaten'], 'properties': [], 'englishmain': '!is! eating <something>', 'englishraw': '\u27e8eat\u27e9 <something>', 'base_case': 'eat', 'usageIndex': 1, 'type': 'it'},
{'englishnorm': 'eat', 'yupikword': 'neraa', 'fsts': ['nere'], 'fstsDisplay': 'nere-', 'key': 'nere-', 'englishtenses': ['eat', 'ate', 'eats', 'eating', 'eaten'], 'properties': [], 'englishmain': '!is! eating <it>', 'englishraw': '\u27e8eat\u27e9 <it>', 'base_case': 'eat', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'hunt', 'yupikword': 'pissurtuq', 'fsts': ['pissur'], 'fstsDisplay': 'pissur-', 'key': 'pissur-', 'englishtenses': ['hunt', 'hunted', 'hunts', 'hunting', 'hunted'], 'properties': [], 'englishmain': '!is! hunting <something>', 'englishraw': '\u27e8hunt\u27e9 <something>', 'base_case': 'hunt', 'usageIndex': 1, 'type': 'it'},
{'englishnorm': 'hunt', 'yupikword': 'pissuraa', 'fsts': ['pissur'], 'fstsDisplay': 'pissur-', 'key': 'pissur-', 'englishtenses': ['hunt', 'hunted', 'hunts', 'hunting', 'hunted'], 'properties': [], 'englishmain': '!is! hunting <it>', 'englishraw': '\u27e8hunt\u27e9 <it>', 'base_case': 'hunt', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'leave', 'yupikword': 'ayagtuq', 'fsts': ['ayag\xb9'], 'fstsDisplay': 'ayag\xb9-', 'key': 'ayag\xb9-', 'englishtenses': ['leave', 'left', 'leaves', 'leaving', 'left'], 'properties': [], 'englishmain': 'left', 'englishraw': '\u27e8leave\u27e9', 'base_case': 'leave', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'come here', 'yupikword': 'taiguq', 'fsts': ['tai'], 'fstsDisplay': 'tai-', 'key': 'tai-', 'englishtenses': ['come', 'came', 'comes', 'coming', 'come'], 'properties': [], 'englishmain': 'came here', 'englishraw': '\u27e8come\u27e9 here', 'base_case': 'come here', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'come in', 'yupikword': 'itertuq', 'fsts': ['iter'], 'fstsDisplay': 'iter-', 'key': 'iter-', 'englishtenses': ['come', 'came', 'comes', 'coming', 'come'], 'properties': [], 'englishmain': 'came in', 'englishraw': '\u27e8come\u27e9 in', 'base_case': 'come in', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'go out', 'yupikword': "an'uq", 'fsts': ['ane'], 'fstsDisplay': 'ane-', 'key': 'ane-', 'englishtenses': ['go', 'went', 'goes', 'going', 'gone'], 'properties': [], 'englishmain': 'went out', 'englishraw': '\u27e8go\u27e9 out', 'base_case': 'go out', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'buy', 'yupikword': 'kiputaa', 'fsts': ['kipute'], 'fstsDisplay': 'kipute-', 'key': 'kipute-', 'englishtenses': ['buy', 'bought', 'buys', 'buying', 'bought'], 'properties': [], 'englishmain': 'bought <it>', 'englishraw': '\u27e8buy\u27e9 <it>', 'base_case': 'buy', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'open', 'yupikword': 'ikirtaa', 'fsts': ['ikirte'], 'fstsDisplay': 'ikirte-', 'key': 'ikirte-', 'englishtenses': ['open', 'opened', 'opens', 'opening', 'opened'], 'properties': [], 'englishmain': 'opened <it>', 'englishraw': '\u27e8open\u27e9 <it>', 'base_case': 'open', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'sit down', 'yupikword': 'aqumuq', 'fsts': ['aqume'], 'fstsDisplay': 'aqume-', 'key': 'aqume-', 'englishtenses': ['sit', 'sat', 'sits', 'sitting', 'sat'], 'properties': [], 'englishmain': 'sat down', 'englishraw': '\u27e8sit\u27e9 down', 'base_case': 'sit down', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'stand up', 'yupikword': 'nangertuq', 'fsts': ['nangerte'], 'fstsDisplay': 'nangerte-', 'key': 'nangerte-', 'englishtenses': ['stand', 'stood', 'stands', 'standing', 'stood'], 'properties': [], 'englishmain': 'stood up', 'englishraw': '\u27e8stand\u27e9 up', 'base_case': 'stand up', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'be well', 'yupikword': 'assirtuq', 'fsts': ['assir'], 'fstsDisplay': 'assir-', 'key': 'assir-', 'englishtenses': ['be', 'was', 'is', 'being', 'been'], 'properties': [], 'englishmain': '!is! well', 'englishraw': '\u27e8be\u27e9 well', 'base_case': 'be well', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'be bad', 'yupikword': 'assiituq', 'fsts': ['assiite'], 'fstsDisplay': 'assiite-', 'key': 'assiite-', 'englishtenses': ['be', 'was', 'is', 'being', 'been'], 'properties': [], 'englishmain': '!is! bad', 'englishraw': '\u27e8be\u27e9 bad', 'base_case': 'be bad', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'be thankful, glad', 'yupikword': 'quyauq', 'fsts': ['quya'], 'fstsDisplay': 'quya-', 'key': 'quya-', 'englishtenses': ['be', 'was', 'is', 'being', 'been'], 'properties': [], 'englishmain': '!is! thankful, glad', 'englishraw': '\u27e8be\u27e9 thankful, glad', 'base_case': 'be thankful, glad', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'act', 'yupikword': 'piuq', 'fsts': ['pi'], 'fstsDisplay': 'pi-', 'key': 'pi,pi-', 'englishtenses': ['act', 'acted', 'acts', 'acting', 'acted'], 'properties': [], 'englishmain': '!is! acting', 'englishraw': '\u27e8act\u27e9', 'base_case': 'act', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'drink coffee', 'yupikword': 'kuuvviartuq', 'fsts': ['kuuvviar'], 'fstsDisplay': 'kuuvviar-', 'key': 'kuuvviaq,kuuvviar-', 'englishtenses': ['drink', 'drank', 'drinks', 'drinking', 'drunk'], 'properties': [], 'englishmain': '!is! drinking coffee', 'englishraw': '\u27e8drink\u27e9 coffee', 'base_case': 'drink coffee', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'speak', 'yupikword': 'qanertuq', 'fsts': ['qaner'], 'fstsDisplay': 'qaner-', 'key': 'qaneq,qaner-', 'englishtenses': ['speak', 'spoke', 'speaks', 'speaking', 'spoken'], 'properties': [], 'englishmain': '!is! speaking', 'englishraw': '\u27e8speak\u27e9', 'base_case': 'speak', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'tell', 'yupikword': 'qanrutaa', 'fsts': ['qanrute'], 'fstsDisplay': 'qanrute-', 'key': 'qanrute-', 'englishtenses': ['tell', 'told', 'tells', 'telling', 'told'], 'properties': [], 'englishmain': 'told <him>', 'englishraw': '\u27e8tell\u27e9 <him>', 'base_case': 'tell', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'ask', 'yupikword': 'aptuq', 'fsts': ['apte'], 'fstsDisplay': 'apte-', 'key': 'apte-', 'englishtenses': ['ask', 'asked', 'asks', 'asking', 'asked'], 'properties': [], 'englishmain': 'asked', 'englishraw': '\u27e8ask\u27e9', 'base_case': 'ask', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'sleep', 'yupikword': 'qavartuq', 'fsts': ['qavar'], 'fstsDisplay': 'qavar-', 'key': 'qavaq,qavar-', 'englishtenses': ['sleep', 'slept', 'sleeps', 'sleeping', 'slept'], 'properties': [], 'englishmain': '!is! sleeping', 'englishraw': '\u27e8sleep\u27e9', 'base_case': 'sleep', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'lay down', 'yupikword': 'inartuq', 'fsts': ['inarte'], 'fstsDisplay': 'inarte-', 'key': 'inarte-', 'englishtenses': ['lay', 'laid', 'lays', 'laying', 'laid'], 'properties': [], 'englishmain': 'lay down', 'englishraw': '\u27e8lay\u27e9 down', 'base_case': 'lay down', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'get up', 'yupikword': 'maktuq', 'fsts': ['makte'], 'fstsDisplay': 'makte-', 'key': 'makte-', 'englishtenses': ['get', 'got', 'gets', 'getting', 'got'], 'properties': [], 'englishmain': 'got up', 'englishraw': '\u27e8get\u27e9 up', 'base_case': 'get up', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'hear', 'yupikword': 'niituq', 'fsts': ['niite'], 'fstsDisplay': 'niite-', 'key': 'niite-', 'englishtenses': ['hear', 'heard', 'hears', 'hearing', 'heard'], 'properties': [], 'englishmain': 'hears <someone or something>', 'englishraw': '\u27e8hear\u27e9 <someone or something>', 'base_case': 'hear', 'usageIndex': 1, 'type': 'it'},
{'englishnorm': 'listen', 'yupikword': 'niicugniuq', 'fsts': ['niicugni'], 'fstsDisplay': 'niicugni-', 'key': 'niicugni-', 'englishtenses': ['listen', 'listened', 'listens', 'listening', 'listened'], 'properties': [], 'englishmain': '!is! listening', 'englishraw': '\u27e8listen\u27e9', 'base_case': 'listen', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'wash', 'yupikword': 'eruraa', 'fsts': ['erur'], 'fstsDisplay': 'erur-', 'key': 'erur-', 'englishtenses': ['wash', 'washed', 'washes', 'washing', 'washed'], 'properties': [], 'englishmain': '!is! washing <it>', 'englishraw': '\u27e8wash\u27e9 <it>', 'base_case': 'wash', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'walk', 'yupikword': 'piyuaguq', 'fsts': ['piyua'], 'fstsDisplay': 'piyua-', 'key': 'piyua-', 'englishtenses': ['walk', 'walked', 'walks', 'walking', 'walked'], 'properties': [], 'englishmain': '!is! walking', 'englishraw': '\u27e8walk\u27e9', 'base_case': 'walk', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'run', 'yupikword': 'aqvaqurtuq', 'fsts': ['aqvaqur'], 'fstsDisplay': 'aqvaqur-', 'key': 'aqvaqur-', 'englishtenses': ['run', 'ran', 'runs', 'running', 'run'], 'properties': [], 'englishmain': '!is! running', 'englishraw': '\u27e8run\u27e9', 'base_case': 'run', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'dance', 'yupikword': 'yurartuq', 'fsts': ['yurar\xb9'], 'fstsDisplay': 'yurar\xb9-', 'key': 'yuraq,yurar\xb9-', 'englishtenses': ['dance', 'danced', 'dances', 'dancing', 'danced'], 'properties': [], 'englishmain': '!is! dancing', 'englishraw': '\u27e8dance\u27e9', 'base_case': 'dance', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'hook for fish', 'yupikword': 'manartuq', 'fsts': ['manar'], 'fstsDisplay': 'manar-', 'key': 'manaq,manar-', 'englishtenses': ['hook', 'hooked', 'hooks', 'hooking', 'hooked'], 'properties': [], 'englishmain': '!is! hooking for fish', 'englishraw': '\u27e8hook\u27e9 for fish', 'base_case': 'hook for fish', 'usageIndex': 1, 'type': 'i'},
]

export const popularVerbsI = [
{'englishnorm': 'eat', 'yupikword': "ner'uq", 'fsts': ['nere'], 'fstsDisplay': 'nere-', 'key': 'nere-', 'englishtenses': ['eat', 'ate', 'eats', 'eating', 'eaten'], 'properties': [], 'englishmain': '!is! eating', 'englishraw': '\u27e8eat\u27e9', 'base_case': 'eat', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'leave', 'yupikword': 'ayagtuq', 'fsts': ['ayag\xb9'], 'fstsDisplay': 'ayag\xb9-', 'key': 'ayag\xb9-', 'englishtenses': ['leave', 'left', 'leaves', 'leaving', 'left'], 'properties': [], 'englishmain': 'left', 'englishraw': '\u27e8leave\u27e9', 'base_case': 'leave', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'come here', 'yupikword': 'taiguq', 'fsts': ['tai'], 'fstsDisplay': 'tai-', 'key': 'tai-', 'englishtenses': ['come', 'came', 'comes', 'coming', 'come'], 'properties': [], 'englishmain': 'came here', 'englishraw': '\u27e8come\u27e9 here', 'base_case': 'come here', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'come in', 'yupikword': 'itertuq', 'fsts': ['iter'], 'fstsDisplay': 'iter-', 'key': 'iter-', 'englishtenses': ['come', 'came', 'comes', 'coming', 'come'], 'properties': [], 'englishmain': 'came in', 'englishraw': '\u27e8come\u27e9 in', 'base_case': 'come in', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'go out', 'yupikword': "an'uq", 'fsts': ['ane'], 'fstsDisplay': 'ane-', 'key': 'ane-', 'englishtenses': ['go', 'went', 'goes', 'going', 'gone'], 'properties': [], 'englishmain': 'went out', 'englishraw': '\u27e8go\u27e9 out', 'base_case': 'go out', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'sit down', 'yupikword': 'aqumuq', 'fsts': ['aqume'], 'fstsDisplay': 'aqume-', 'key': 'aqume-', 'englishtenses': ['sit', 'sat', 'sits', 'sitting', 'sat'], 'properties': [], 'englishmain': 'sat down', 'englishraw': '\u27e8sit\u27e9 down', 'base_case': 'sit down', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'stand up', 'yupikword': 'nangertuq', 'fsts': ['nangerte'], 'fstsDisplay': 'nangerte-', 'key': 'nangerte-', 'englishtenses': ['stand', 'stood', 'stands', 'standing', 'stood'], 'properties': [], 'englishmain': 'stood up', 'englishraw': '\u27e8stand\u27e9 up', 'base_case': 'stand up', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'be well', 'yupikword': 'assirtuq', 'fsts': ['assir'], 'fstsDisplay': 'assir-', 'key': 'assir-', 'englishtenses': ['be', 'was', 'is', 'being', 'been'], 'properties': [], 'englishmain': '!is! well', 'englishraw': '\u27e8be\u27e9 well', 'base_case': 'be well', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'be bad', 'yupikword': 'assiituq', 'fsts': ['assiite'], 'fstsDisplay': 'assiite-', 'key': 'assiite-', 'englishtenses': ['be', 'was', 'is', 'being', 'been'], 'properties': [], 'englishmain': '!is! bad', 'englishraw': '\u27e8be\u27e9 bad', 'base_case': 'be bad', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'be thankful, glad', 'yupikword': 'quyauq', 'fsts': ['quya'], 'fstsDisplay': 'quya-', 'key': 'quya-', 'englishtenses': ['be', 'was', 'is', 'being', 'been'], 'properties': [], 'englishmain': '!is! thankful, glad', 'englishraw': '\u27e8be\u27e9 thankful, glad', 'base_case': 'be thankful, glad', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'act', 'yupikword': 'piuq', 'fsts': ['pi'], 'fstsDisplay': 'pi-', 'key': 'pi,pi-', 'englishtenses': ['act', 'acted', 'acts', 'acting', 'acted'], 'properties': [], 'englishmain': '!is! acting', 'englishraw': '\u27e8act\u27e9', 'base_case': 'act', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'drink coffee', 'yupikword': 'kuuvviartuq', 'fsts': ['kuuvviar'], 'fstsDisplay': 'kuuvviar-', 'key': 'kuuvviaq,kuuvviar-', 'englishtenses': ['drink', 'drank', 'drinks', 'drinking', 'drunk'], 'properties': [], 'englishmain': '!is! drinking coffee', 'englishraw': '\u27e8drink\u27e9 coffee', 'base_case': 'drink coffee', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'speak', 'yupikword': 'qanertuq', 'fsts': ['qaner'], 'fstsDisplay': 'qaner-', 'key': 'qaneq,qaner-', 'englishtenses': ['speak', 'spoke', 'speaks', 'speaking', 'spoken'], 'properties': [], 'englishmain': '!is! speaking', 'englishraw': '\u27e8speak\u27e9', 'base_case': 'speak', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'ask', 'yupikword': 'aptuq', 'fsts': ['apte'], 'fstsDisplay': 'apte-', 'key': 'apte-', 'englishtenses': ['ask', 'asked', 'asks', 'asking', 'asked'], 'properties': [], 'englishmain': 'asked', 'englishraw': '\u27e8ask\u27e9', 'base_case': 'ask', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'sleep', 'yupikword': 'qavartuq', 'fsts': ['qavar'], 'fstsDisplay': 'qavar-', 'key': 'qavaq,qavar-', 'englishtenses': ['sleep', 'slept', 'sleeps', 'sleeping', 'slept'], 'properties': [], 'englishmain': '!is! sleeping', 'englishraw': '\u27e8sleep\u27e9', 'base_case': 'sleep', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'lay down', 'yupikword': 'inartuq', 'fsts': ['inarte'], 'fstsDisplay': 'inarte-', 'key': 'inarte-', 'englishtenses': ['lay', 'laid', 'lays', 'laying', 'laid'], 'properties': [], 'englishmain': 'lay down', 'englishraw': '\u27e8lay\u27e9 down', 'base_case': 'lay down', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'get up', 'yupikword': 'maktuq', 'fsts': ['makte'], 'fstsDisplay': 'makte-', 'key': 'makte-', 'englishtenses': ['get', 'got', 'gets', 'getting', 'got'], 'properties': [], 'englishmain': 'got up', 'englishraw': '\u27e8get\u27e9 up', 'base_case': 'get up', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'listen', 'yupikword': 'niicugniuq', 'fsts': ['niicugni'], 'fstsDisplay': 'niicugni-', 'key': 'niicugni-', 'englishtenses': ['listen', 'listened', 'listens', 'listening', 'listened'], 'properties': [], 'englishmain': '!is! listening', 'englishraw': '\u27e8listen\u27e9', 'base_case': 'listen', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'walk', 'yupikword': 'piyuaguq', 'fsts': ['piyua'], 'fstsDisplay': 'piyua-', 'key': 'piyua-', 'englishtenses': ['walk', 'walked', 'walks', 'walking', 'walked'], 'properties': [], 'englishmain': '!is! walking', 'englishraw': '\u27e8walk\u27e9', 'base_case': 'walk', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'run', 'yupikword': 'aqvaqurtuq', 'fsts': ['aqvaqur'], 'fstsDisplay': 'aqvaqur-', 'key': 'aqvaqur-', 'englishtenses': ['run', 'ran', 'runs', 'running', 'run'], 'properties': [], 'englishmain': '!is! running', 'englishraw': '\u27e8run\u27e9', 'base_case': 'run', 'usageIndex': 0, 'type': 'i'},
{'englishnorm': 'dance', 'yupikword': 'yurartuq', 'fsts': ['yurar\xb9'], 'fstsDisplay': 'yurar\xb9-', 'key': 'yuraq,yurar\xb9-', 'englishtenses': ['dance', 'danced', 'dances', 'dancing', 'danced'], 'properties': [], 'englishmain': '!is! dancing', 'englishraw': '\u27e8dance\u27e9', 'base_case': 'dance', 'usageIndex': 1, 'type': 'i'},
{'englishnorm': 'hook for fish', 'yupikword': 'manartuq', 'fsts': ['manar'], 'fstsDisplay': 'manar-', 'key': 'manaq,manar-', 'englishtenses': ['hook', 'hooked', 'hooks', 'hooking', 'hooked'], 'properties': [], 'englishmain': '!is! hooking for fish', 'englishraw': '\u27e8hook\u27e9 for fish', 'base_case': 'hook for fish', 'usageIndex': 1, 'type': 'i'},
]

export const popularVerbsT = [
{'englishnorm': 'eat', 'yupikword': "ner'uq", 'fsts': ['nere'], 'fstsDisplay': 'nere-', 'key': 'nere-', 'englishtenses': ['eat', 'ate', 'eats', 'eating', 'eaten'], 'properties': [], 'englishmain': '!is! eating <something>', 'englishraw': '\u27e8eat\u27e9 <something>', 'base_case': 'eat', 'usageIndex': 1, 'type': 'it'},
{'englishnorm': 'eat', 'yupikword': 'neraa', 'fsts': ['nere'], 'fstsDisplay': 'nere-', 'key': 'nere-', 'englishtenses': ['eat', 'ate', 'eats', 'eating', 'eaten'], 'properties': [], 'englishmain': '!is! eating <it>', 'englishraw': '\u27e8eat\u27e9 <it>', 'base_case': 'eat', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'hunt', 'yupikword': 'pissurtuq', 'fsts': ['pissur'], 'fstsDisplay': 'pissur-', 'key': 'pissur-', 'englishtenses': ['hunt', 'hunted', 'hunts', 'hunting', 'hunted'], 'properties': [], 'englishmain': '!is! hunting <something>', 'englishraw': '\u27e8hunt\u27e9 <something>', 'base_case': 'hunt', 'usageIndex': 1, 'type': 'it'},
{'englishnorm': 'hunt', 'yupikword': 'pissuraa', 'fsts': ['pissur'], 'fstsDisplay': 'pissur-', 'key': 'pissur-', 'englishtenses': ['hunt', 'hunted', 'hunts', 'hunting', 'hunted'], 'properties': [], 'englishmain': '!is! hunting <it>', 'englishraw': '\u27e8hunt\u27e9 <it>', 'base_case': 'hunt', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'buy', 'yupikword': 'kiputaa', 'fsts': ['kipute'], 'fstsDisplay': 'kipute-', 'key': 'kipute-', 'englishtenses': ['buy', 'bought', 'buys', 'buying', 'bought'], 'properties': [], 'englishmain': 'bought <it>', 'englishraw': '\u27e8buy\u27e9 <it>', 'base_case': 'buy', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'open', 'yupikword': 'ikirtaa', 'fsts': ['ikirte'], 'fstsDisplay': 'ikirte-', 'key': 'ikirte-', 'englishtenses': ['open', 'opened', 'opens', 'opening', 'opened'], 'properties': [], 'englishmain': 'opened <it>', 'englishraw': '\u27e8open\u27e9 <it>', 'base_case': 'open', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'tell', 'yupikword': 'qanrutaa', 'fsts': ['qanrute'], 'fstsDisplay': 'qanrute-', 'key': 'qanrute-', 'englishtenses': ['tell', 'told', 'tells', 'telling', 'told'], 'properties': [], 'englishmain': 'told <him>', 'englishraw': '\u27e8tell\u27e9 <him>', 'base_case': 'tell', 'usageIndex': 2, 'type': 't'},
{'englishnorm': 'hear', 'yupikword': 'niituq', 'fsts': ['niite'], 'fstsDisplay': 'niite-', 'key': 'niite-', 'englishtenses': ['hear', 'heard', 'hears', 'hearing', 'heard'], 'properties': [], 'englishmain': 'hears <someone or something>', 'englishraw': '\u27e8hear\u27e9 <someone or something>', 'base_case': 'hear', 'usageIndex': 1, 'type': 'it'},
{'englishnorm': 'wash', 'yupikword': 'eruraa', 'fsts': ['erur'], 'fstsDisplay': 'erur-', 'key': 'erur-', 'englishtenses': ['wash', 'washed', 'washes', 'washing', 'washed'], 'properties': [], 'englishmain': '!is! washing <it>', 'englishraw': '\u27e8wash\u27e9 <it>', 'base_case': 'wash', 'usageIndex': 2, 'type': 't'},
]

export const popularNounsBeings = [
{'englishnorm': 'woman, female human, queen in cards', 'yupikword': 'arnaq', 'fsts': ['arnar'], 'fstsDisplay': 'arnar-', 'key': 'arnaq', 'englishtenses': [['woman', 'women'], ['human', 'humans'], ['queen', 'queens']], 'properties': [], 'englishmain': ['\u27e8woman\u27e9', 'female \u27e8human\u27e9', '\u27e8queen\u27e9 in cards'], 'englishraw': '\u27e8woman\u27e9, female \u27e8human\u27e9, \u27e8queen\u27e9 in cards', 'base_case': 'woman, female human, queen in cards', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'male human, man', 'yupikword': 'angun', 'fsts': ['angute'], 'fstsDisplay': 'angute-', 'key': 'angun', 'englishtenses': [['human', 'humans'], ['man', 'men']], 'properties': [], 'englishmain': ['male \u27e8human\u27e9', '\u27e8man\u27e9'], 'englishraw': 'male \u27e8human\u27e9, \u27e8man\u27e9', 'base_case': 'male human, man', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'mother', 'yupikword': 'aana', 'fsts': ['aana'], 'fstsDisplay': 'aana-', 'key': 'aana', 'englishtenses': [['mother', 'mothers']], 'properties': [], 'englishmain': ['\u27e8mother\u27e9'], 'englishraw': '\u27e8mother\u27e9', 'base_case': 'mother', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'father', 'yupikword': 'aata', 'fsts': ['aate'], 'fstsDisplay': 'aate-', 'key': 'aata', 'englishtenses': [['father', 'fathers']], 'properties': [], 'englishmain': ['\u27e8father\u27e9'], 'englishraw': '\u27e8father\u27e9', 'base_case': 'father', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'elder', 'yupikword': 'tegganeq', 'fsts': ['tegganer'], 'fstsDisplay': 'tegganer-', 'key': 'tegganeq', 'englishtenses': [['elder', 'elders']], 'properties': [], 'englishmain': ['\u27e8elder\u27e9'], 'englishraw': '\u27e8elder\u27e9', 'base_case': 'elder', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'child, little one', 'yupikword': 'mikelnguq', 'fsts': ['mikelngur*'], 'fstsDisplay': 'mikelngur*-', 'key': 'mikelnguq*', 'englishtenses': [['child', 'children'], ['little', 'littles']], 'properties': [], 'englishmain': ['\u27e8child\u27e9', '\u27e8little\u27e9 one'], 'englishraw': '\u27e8child\u27e9, \u27e8little\u27e9 one', 'base_case': 'child, little one', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'baby', 'yupikword': 'piipiq', 'fsts': ['piipir'], 'fstsDisplay': 'piipir-', 'key': 'piipiq', 'englishtenses': [['baby', 'babies']], 'properties': [], 'englishmain': ['\u27e8baby\u27e9'], 'englishraw': '\u27e8baby\u27e9', 'base_case': 'baby', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'bird, duck, fowl, angel', 'yupikword': 'yaqulek', 'fsts': ['yaquleg'], 'fstsDisplay': 'yaquleg-', 'key': 'yaqulek', 'englishtenses': [['bird', 'birds'], ['duck', 'ducks'], ['fowl', 'fowls'], ['angel', 'angels']], 'properties': [], 'englishmain': ['\u27e8bird\u27e9', '\u27e8duck\u27e9', '\u27e8fowl\u27e9', '\u27e8angel\u27e9'], 'englishraw': '\u27e8bird\u27e9, \u27e8duck\u27e9, \u27e8fowl\u27e9, \u27e8angel\u27e9', 'base_case': 'bird, duck, fowl, angel', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'caribou (Rangifer tarandus), reindeer', 'yupikword': 'tuntu', 'fsts': ['tuntu'], 'fstsDisplay': 'tuntu-', 'key': 'tuntu', 'englishtenses': [['caribou', 'caribous'], ['reindeer', 'reindeers']], 'properties': [], 'englishmain': ['\u27e8caribou\u27e9 (Rangifer tarandus)', '\u27e8reindeer\u27e9'], 'englishraw': '\u27e8caribou\u27e9 (Rangifer tarandus), \u27e8reindeer\u27e9', 'base_case': 'caribou (Rangifer tarandus), reindeer', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'moose (Alces alces)', 'yupikword': 'tuntuvak', 'fsts': ['tuntuvag'], 'fstsDisplay': 'tuntuvag-', 'key': 'tuntuvak', 'englishtenses': [['moose', 'moose']], 'properties': [], 'englishmain': ['\u27e8moose\u27e9 (Alces alces)'], 'englishraw': '\u27e8moose\u27e9 (Alces alces)', 'base_case': 'moose (Alces alces)', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'bearded seal in its first year', 'yupikword': 'maklaaq', 'fsts': ['maklaar'], 'fstsDisplay': 'maklaar-', 'key': 'maklaaq', 'englishtenses': [['seal', 'seals']], 'properties': [], 'englishmain': ['bearded \u27e8seal\u27e9 in its first year'], 'englishraw': 'bearded \u27e8seal\u27e9 in its first year', 'base_case': 'bearded seal in its first year', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'spotted seal (Phoca largha), harbor seal (Phoca vitulina)', 'yupikword': 'issuriq', 'fsts': ['issurir', 'issuri'], 'fstsDisplay': 'issurir-, issuri-', 'key': 'issuriq,issuri', 'englishtenses': [['seal', 'seals'], ['seal', 'seals']], 'properties': [], 'englishmain': ['spotted \u27e8seal\u27e9 (Phoca largha)', 'harbor \u27e8seal\u27e9 (Phoca vitulina)'], 'englishraw': 'spotted \u27e8seal\u27e9 (Phoca largha), harbor \u27e8seal\u27e9 (Phoca vitulina)', 'base_case': 'spotted seal (Phoca largha), harbor seal (Phoca vitulina)', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'food, fish', 'yupikword': 'neqa\u1d49', 'fsts': ['neqe'], 'fstsDisplay': 'neqe-', 'key': 'neqa\u1d49', 'englishtenses': [['food', 'food'], ['fish', 'fish']], 'properties': [], 'englishmain': ['\u27e8food\u27e9', '\u27e8fish\u27e9'], 'englishraw': '\u27e8food\u27e9, \u27e8fish\u27e9', 'base_case': 'food, fish', 'usageIndex': 0, 'type': 'n'},
]

export const popularNounsThings = [
{'englishnorm': 'coffee', 'yupikword': 'kuuvviaq', 'fsts': ['kuuvviar'], 'fstsDisplay': 'kuuvviar-', 'key': 'kuuvviaq,kuuvviar-', 'englishtenses': [['coffee', 'coffees']], 'properties': [], 'englishmain': ['\u27e8coffee\u27e9'], 'englishraw': '\u27e8coffee\u27e9', 'base_case': 'coffee', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'tea (either the leaves or the liquid)', 'yupikword': 'saayuq', 'fsts': ['saayur'], 'fstsDisplay': 'saayur-', 'key': 'saayuq,saayur-', 'englishtenses': [['tea', 'tea']], 'properties': [], 'englishmain': ['\u27e8tea\u27e9 (either the leaves or the liquid)'], 'englishraw': '\u27e8tea\u27e9 (either the leaves or the liquid)', 'base_case': 'tea (either the leaves or the liquid)', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'table', 'yupikword': 'estuuluq', 'fsts': ['estuulur'], 'fstsDisplay': 'estuulur-', 'key': 'estuuluq', 'englishtenses': [['table', 'tables']], 'properties': [], 'englishmain': ['\u27e8table\u27e9'], 'englishraw': '\u27e8table\u27e9', 'base_case': 'table', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'chair, seat', 'yupikword': 'aqumlleq', 'fsts': ['aqumller'], 'fstsDisplay': 'aqumller-', 'key': 'aqumlleq', 'englishtenses': [['chair', 'chairs'], ['seat', 'seats']], 'properties': [], 'englishmain': ['\u27e8chair\u27e9', '\u27e8seat\u27e9'], 'englishraw': '\u27e8chair\u27e9, \u27e8seat\u27e9', 'base_case': 'chair, seat', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'door, entranceway', 'yupikword': 'amiik', 'fsts': ['amiig'], 'fstsDisplay': 'amiig-', 'key': 'amiik', 'englishtenses': [['door', 'doors'], ['entranceway', 'entranceways']], 'properties': [], 'englishmain': ['\u27e8door\u27e9', '\u27e8entranceway\u27e9'], 'englishraw': '\u27e8door\u27e9, \u27e8entranceway\u27e9', 'base_case': 'door, entranceway', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'floor, flooring', 'yupikword': 'nateq', 'fsts': ['nater'], 'fstsDisplay': 'nater-', 'key': 'nateq', 'englishtenses': [['floor', 'floors'], ['flooring', 'floorings']], 'properties': [], 'englishmain': ['\u27e8floor\u27e9', '\u27e8flooring\u27e9'], 'englishraw': '\u27e8floor\u27e9, \u27e8flooring\u27e9', 'base_case': 'floor, flooring', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'clothing, bedding, merchandise, fitting(s), accouterment, possession(s)', 'yupikword': 'akl', 'fsts': ['akl', 'aklur'], 'fstsDisplay': 'aklu-, aklur-', 'key': 'aklu,akluq,aklu-', 'englishtenses': [['clothing', 'clothings'], ['bedding', 'beddings'], ['merchandise', 'merchandises'], ['fitting', 'fittings'], ['accouterment', 'accouterments'], ['possession', 'possessions']], 'properties': [], 'englishmain': ['\u27e8clothing\u27e9', '\u27e8bedding\u27e9', '\u27e8merchandise\u27e9', '\u27e8fitting\u27e9(s)', '\u27e8accouterment\u27e9', '\u27e8possession\u27e9(s)'], 'englishraw': '\u27e8clothing\u27e9, \u27e8bedding\u27e9, \u27e8merchandise\u27e9, \u27e8fitting\u27e9(s), \u27e8accouterment\u27e9, \u27e8possession\u27e9(s)', 'base_case': 'clothing, bedding, merchandise, fitting(s), accouterment, possession(s)', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'mixture, \u201cEskimo ice cream\u201d', 'yupikword': 'akutaq', 'fsts': ['akutar'], 'fstsDisplay': 'akutar-', 'key': 'akutaq', 'englishtenses': [['mixture', 'mixtures'], ['cream', 'creams']], 'properties': [], 'englishmain': ['\u27e8mixture\u27e9', '\u201cEskimo ice \u27e8cream\u27e9\u201d'], 'englishraw': '\u27e8mixture\u27e9, \u201cEskimo ice \u27e8cream\u27e9\u201d', 'base_case': 'mixture, \u201cEskimo ice cream\u201d', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'soup, stew-like soup served as a main course', 'yupikword': 'suupaq', 'fsts': ['suupar'], 'fstsDisplay': 'suupar-', 'key': 'suupaq', 'englishtenses': [['soup', 'soup'], ['soup', 'soup']], 'properties': [], 'englishmain': ['\u27e8soup\u27e9', 'stew-like \u27e8soup\u27e9 served as a main course'], 'englishraw': '\u27e8soup\u27e9, stew-like \u27e8soup\u27e9 served as a main course', 'base_case': 'soup, stew-like soup served as a main course', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'smoked dried fish (particularly salmon)', 'yupikword': 'neqerrluk', 'fsts': ['neqerrlug', 'neqerrluar'], 'fstsDisplay': 'neqerrlug-, neqerrluar-', 'key': 'neqerrluk,neqerrluaq', 'englishtenses': [['fish', 'fish']], 'properties': [], 'englishmain': ['smoked dried \u27e8fish\u27e9 (particularly salmon)'], 'englishraw': 'smoked dried \u27e8fish\u27e9 (particularly salmon)', 'base_case': 'smoked dried fish (particularly salmon)', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'berry, fruit, nut, cloudberry (Rubus chamaemorus)', 'yupikword': 'atsaq', 'fsts': ['atsar'], 'fstsDisplay': 'atsar-', 'key': 'atsaq', 'englishtenses': [['berry', 'berries'], ['fruit', 'fruit'], ['nut', 'nuts'], ['cloudberry', 'cloudberries']], 'properties': [], 'englishmain': ['\u27e8berry\u27e9', '\u27e8fruit\u27e9', '\u27e8nut\u27e9', '\u27e8cloudberry\u27e9 (Rubus chamaemorus)'], 'englishraw': '\u27e8berry\u27e9, \u27e8fruit\u27e9, \u27e8nut\u27e9, \u27e8cloudberry\u27e9 (Rubus chamaemorus)', 'base_case': 'berry, fruit, nut, cloudberry (Rubus chamaemorus)', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'boat', 'yupikword': 'angyaq', 'fsts': ['angyar'], 'fstsDisplay': 'angyar-', 'key': 'angyaq,angyar-', 'englishtenses': [['boat', 'boats']], 'properties': [], 'englishmain': ['\u27e8boat\u27e9'], 'englishraw': '\u27e8boat\u27e9', 'base_case': 'boat', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'sled, dogsled, by extension: snow machine, automobile, truck, taxi', 'yupikword': 'ikamraq', 'fsts': ['ikamrar'], 'fstsDisplay': 'ikamrar-', 'key': 'ikamraq,ikamrar-', 'englishtenses': [['sled', 'sleds'], ['dogsled', 'dogsleds'], ['extension', 'extensions'], ['automobile', 'automobiles'], ['truck', 'trucks'], ['taxi', 'taxis']], 'properties': [], 'englishmain': ['\u27e8sled\u27e9', '\u27e8dogsled\u27e9', 'by \u27e8extension\u27e9: snow machine', '\u27e8automobile\u27e9', '\u27e8truck\u27e9', '\u27e8taxi\u27e9'], 'englishraw': '\u27e8sled\u27e9, \u27e8dogsled\u27e9, by \u27e8extension\u27e9: snow machine, \u27e8automobile\u27e9, \u27e8truck\u27e9, \u27e8taxi\u27e9', 'base_case': 'sled, dogsled, by extension: snow machine, automobile, truck, taxi', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'world, outdoor, weather, sky, universe, awareness, sense', 'yupikword': 'ella', 'fsts': ['ella'], 'fstsDisplay': 'ella-', 'key': 'ella', 'englishtenses': [['world', 'worlds'], ['outdoor', 'outdoors'], ['weather', 'weather'], ['sky', 'skies'], ['universe', 'universes'], ['awareness', 'awarenesses'], ['sense', 'senses']], 'properties': [], 'englishmain': ['\u27e8world\u27e9', '\u27e8outdoor\u27e9', '\u27e8weather\u27e9', '\u27e8sky\u27e9', '\u27e8universe\u27e9', '\u27e8awareness\u27e9', '\u27e8sense\u27e9'], 'englishraw': '\u27e8world\u27e9, \u27e8outdoor\u27e9, \u27e8weather\u27e9, \u27e8sky\u27e9, \u27e8universe\u27e9, \u27e8awareness\u27e9, \u27e8sense\u27e9', 'base_case': 'world, outdoor, weather, sky, universe, awareness, sense', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'ocean, sea', 'yupikword': 'imarpik', 'fsts': ['imarpig', 'imarpag'], 'fstsDisplay': 'imarpig-, imarpag-', 'key': 'imarpik,imarpak', 'englishtenses': [['ocean', 'oceans']], 'properties': [], 'englishmain': ['\u27e8ocean\u27e9, sea'], 'englishraw': '\u27e8ocean\u27e9, sea', 'base_case': 'ocean, sea', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'maxim, saying, proverb, wise word, teaching', 'yupikword': 'qanruyun', 'fsts': ['qanruyute'], 'fstsDisplay': 'qanruyute-', 'key': 'qanruyun', 'englishtenses': [['maxim', 'maxims'], ['saying', 'sayings'], ['proverb', 'proverbs'], ['word', 'words'], ['teaching', 'teachings']], 'properties': [], 'englishmain': ['\u27e8maxim\u27e9', '\u27e8saying\u27e9', '\u27e8proverb\u27e9', 'wise \u27e8word\u27e9', '\u27e8teaching\u27e9'], 'englishraw': '\u27e8maxim\u27e9, \u27e8saying\u27e9, \u27e8proverb\u27e9, wise \u27e8word\u27e9, \u27e8teaching\u27e9', 'base_case': 'maxim, saying, proverb, wise word, teaching', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'story, factual account', 'yupikword': 'qanemci', 'fsts': ['qanemci', 'qanemcir'], 'fstsDisplay': 'qanemci-, qanemcir-', 'key': 'qanemci,qanemciq,qanemci-', 'englishtenses': [['story', 'stories'], ['account', 'accounts']], 'properties': [], 'englishmain': ['\u27e8story\u27e9', 'factual \u27e8account\u27e9'], 'englishraw': '\u27e8story\u27e9, factual \u27e8account\u27e9', 'base_case': 'story, factual account', 'usageIndex': 0, 'type': 'n'},

]

export const popularNounsPlaces = [
{'englishnorm': 'school, schoolhouse', 'yupikword': 'elitnaurvik', 'fsts': ['elitnaurvig'], 'fstsDisplay': 'elitnaurvig-', 'key': 'elitnaurvik', 'englishtenses': [['school', 'schools'], ['schoolhouse', 'schoolhouses']], 'properties': [], 'englishmain': ['\u27e8school\u27e9', '\u27e8schoolhouse\u27e9'], 'englishraw': '\u27e8school\u27e9, \u27e8schoolhouse\u27e9', 'base_case': 'school, schoolhouse', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'land, place, soil, earth, ground, village, country, vicinity (in space or time)', 'yupikword': 'nuna', 'fsts': ['nuna'], 'fstsDisplay': 'nuna-', 'key': 'nuna', 'englishtenses': [['land', 'lands'], ['place', 'places'], ['soil', 'soil'], ['earth', 'earths'], ['ground', 'grounds'], ['village', 'villages'], ['country', 'countries'], ['vicinity', 'vicinities']], 'properties': [], 'englishmain': ['\u27e8land\u27e9', '\u27e8place\u27e9', '\u27e8soil\u27e9', '\u27e8earth\u27e9', '\u27e8ground\u27e9', '\u27e8village\u27e9', '\u27e8country\u27e9', '\u27e8vicinity\u27e9 (in space or time)'], 'englishraw': '\u27e8land\u27e9, \u27e8place\u27e9, \u27e8soil\u27e9, \u27e8earth\u27e9, \u27e8ground\u27e9, \u27e8village\u27e9, \u27e8country\u27e9, \u27e8vicinity\u27e9 (in space or time)', 'base_case': 'land, place, soil, earth, ground, village, country, vicinity (in space or time)', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'store', 'yupikword': 'kipusvik', 'fsts': ['kipusvig', 'kipuyvig'], 'fstsDisplay': 'kipusvig-, kipuyvig-', 'key': 'kipusvik,kipuyvik', 'englishtenses': [['store', 'stores']], 'properties': [], 'englishmain': ['\u27e8store\u27e9'], 'englishraw': '\u27e8store\u27e9', 'base_case': 'store', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'steambath house', 'yupikword': 'maqivik', 'fsts': ['maqivig'], 'fstsDisplay': 'maqivig-', 'key': 'maqivik', 'englishtenses': [['house', 'houses']], 'properties': [], 'englishmain': ['steambath \u27e8house\u27e9'], 'englishraw': 'steambath \u27e8house\u27e9', 'base_case': 'steambath house', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'house, place', 'yupikword': '[e]na\u1d49', 'fsts': ['[e]ne', 'ene'], 'fstsDisplay': '[e]ne-, ene-', 'key': '[e]na\u1d49,ena\u1d49', 'englishtenses': [['house', 'houses'], ['place', 'places']], 'properties': [], 'englishmain': ['\u27e8house\u27e9', '\u27e8place\u27e9'], 'englishraw': '\u27e8house\u27e9, \u27e8place\u27e9', 'base_case': 'house, place', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'river', 'yupikword': 'kuik', 'fsts': ['kuig'], 'fstsDisplay': 'kuig-', 'key': 'kuik', 'englishtenses': [['river', 'rivers']], 'properties': [], 'englishmain': ['\u27e8river\u27e9'], 'englishraw': '\u27e8river\u27e9', 'base_case': 'river', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'lake, pond', 'yupikword': 'nanvaq', 'fsts': ['nanvar'], 'fstsDisplay': 'nanvar-', 'key': 'nanvaq', 'englishtenses': [['lake', 'lakes'], ['pond', 'ponds']], 'properties': [], 'englishmain': ['\u27e8lake\u27e9', '\u27e8pond\u27e9'], 'englishraw': '\u27e8lake\u27e9, \u27e8pond\u27e9', 'base_case': 'lake, pond', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'ocean, sea', 'yupikword': 'imarpik', 'fsts': ['imarpig', 'imarpag'], 'fstsDisplay': 'imarpig-, imarpag-', 'key': 'imarpik,imarpak', 'englishtenses': [['ocean', 'oceans']], 'properties': [], 'englishmain': ['\u27e8ocean\u27e9, sea'], 'englishraw': '\u27e8ocean\u27e9, sea', 'base_case': 'ocean, sea', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'tundra, patch of tundra, flat mound on tundra', 'yupikword': 'nunapik', 'fsts': ['nunapig'], 'fstsDisplay': 'nunapig-', 'key': 'nunapik', 'englishtenses': [['tundra', 'tundras'], ['patch', 'patches'], ['mound', 'mounds']], 'properties': [], 'englishmain': ['\u27e8tundra\u27e9', '\u27e8patch\u27e9 of tundra', 'flat \u27e8mound\u27e9 on tundra'], 'englishraw': '\u27e8tundra\u27e9, \u27e8patch\u27e9 of tundra, flat \u27e8mound\u27e9 on tundra', 'base_case': 'tundra, patch of tundra, flat mound on tundra', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'mountain', 'yupikword': 'ingriq', 'fsts': ['ingrir', 'ingri'], 'fstsDisplay': 'ingrir-, ingri-', 'key': 'ingriq,ingri', 'englishtenses': [['mountain', 'mountains']], 'properties': [], 'englishmain': ['\u27e8mountain\u27e9'], 'englishraw': '\u27e8mountain\u27e9', 'base_case': 'mountain', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'Bethel', 'yupikword': 'Mamterilleq', 'fsts': ['Mamteriller'], 'fstsDisplay': 'Mamteriller-', 'key': 'Mamterilleq', 'englishtenses': [['Bethel', 'Bethels']], 'properties': [], 'englishmain': ['\u27e8Bethel\u27e9'], 'englishraw': '\u27e8Bethel\u27e9', 'base_case': 'Bethel', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'Dillingham', 'yupikword': 'Curyuk', 'fsts': ['Curyug', 'Curyung'], 'fstsDisplay': 'Curyug-, Curyung-', 'key': 'Curyuk,Curyung', 'englishtenses': [['Dillingham', 'Dillinghams']], 'properties': [], 'englishmain': ['\u27e8Dillingham\u27e9'], 'englishraw': '\u27e8Dillingham\u27e9', 'base_case': 'Dillingham', 'usageIndex': 0, 'type': 'n'},
]

export const popularNounsVialis = [
{'englishnorm': 'boat', 'yupikword': 'angyaq', 'fsts': ['angyar'], 'fstsDisplay': 'angyar-', 'key': 'angyaq,angyar-', 'englishtenses': [['boat', 'boats']], 'properties': [], 'englishmain': ['\u27e8boat\u27e9'], 'englishraw': '\u27e8boat\u27e9', 'base_case': 'boat', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'sled, dogsled, by extension: snow machine, automobile, truck, taxi', 'yupikword': 'ikamraq', 'fsts': ['ikamrar'], 'fstsDisplay': 'ikamrar-', 'key': 'ikamraq,ikamrar-', 'englishtenses': [['sled', 'sleds'], ['dogsled', 'dogsleds'], ['extension', 'extensions'], ['automobile', 'automobiles'], ['truck', 'trucks'], ['taxi', 'taxis']], 'properties': [], 'englishmain': ['\u27e8sled\u27e9', '\u27e8dogsled\u27e9', 'by \u27e8extension\u27e9: snow machine', '\u27e8automobile\u27e9', '\u27e8truck\u27e9', '\u27e8taxi\u27e9'], 'englishraw': '\u27e8sled\u27e9, \u27e8dogsled\u27e9, by \u27e8extension\u27e9: snow machine, \u27e8automobile\u27e9, \u27e8truck\u27e9, \u27e8taxi\u27e9', 'base_case': 'sled, dogsled, by extension: snow machine, automobile, truck, taxi', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'airplane', 'yupikword': 'tengssuun', 'fsts': ['tengssuute'], 'fstsDisplay': 'tengssuute-', 'key': 'tengssuun', 'englishtenses': [['airplane', 'airplanes']], 'properties': [], 'englishmain': ['\u27e8airplane\u27e9'], 'englishraw': '\u27e8airplane\u27e9', 'base_case': 'airplane', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'river', 'yupikword': 'kuik', 'fsts': ['kuig'], 'fstsDisplay': 'kuig-', 'key': 'kuik', 'englishtenses': [['river', 'rivers']], 'properties': [], 'englishmain': ['\u27e8river\u27e9'], 'englishraw': '\u27e8river\u27e9', 'base_case': 'river', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'land, place, soil, earth, ground, village, country, vicinity (in space or time)', 'yupikword': 'nuna', 'fsts': ['nuna'], 'fstsDisplay': 'nuna-', 'key': 'nuna', 'englishtenses': [['land', 'lands'], ['place', 'places'], ['soil', 'soil'], ['earth', 'earths'], ['ground', 'grounds'], ['village', 'villages'], ['country', 'countries'], ['vicinity', 'vicinities']], 'properties': [], 'englishmain': ['\u27e8land\u27e9', '\u27e8place\u27e9', '\u27e8soil\u27e9', '\u27e8earth\u27e9', '\u27e8ground\u27e9', '\u27e8village\u27e9', '\u27e8country\u27e9', '\u27e8vicinity\u27e9 (in space or time)'], 'englishraw': '\u27e8land\u27e9, \u27e8place\u27e9, \u27e8soil\u27e9, \u27e8earth\u27e9, \u27e8ground\u27e9, \u27e8village\u27e9, \u27e8country\u27e9, \u27e8vicinity\u27e9 (in space or time)', 'base_case': 'land, place, soil, earth, ground, village, country, vicinity (in space or time)', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'ocean, sea', 'yupikword': 'imarpik', 'fsts': ['imarpig', 'imarpag'], 'fstsDisplay': 'imarpig-, imarpag-', 'key': 'imarpik,imarpak', 'englishtenses': [['ocean', 'oceans']], 'properties': [], 'englishmain': ['\u27e8ocean\u27e9, sea'], 'englishraw': '\u27e8ocean\u27e9, sea', 'base_case': 'ocean, sea', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'door, entranceway', 'yupikword': 'amiik', 'fsts': ['amiig'], 'fstsDisplay': 'amiig-', 'key': 'amiik', 'englishtenses': [['door', 'doors'], ['entranceway', 'entranceways']], 'properties': [], 'englishmain': ['\u27e8door\u27e9', '\u27e8entranceway\u27e9'], 'englishraw': '\u27e8door\u27e9, \u27e8entranceway\u27e9', 'base_case': 'door, entranceway', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': "window, formerly smokehole/skylight of traditional Yup'ik house", 'yupikword': 'egaleq', 'fsts': ['egaler'], 'fstsDisplay': 'egaler-', 'key': 'egaleq', 'englishtenses': [['window', 'windows'], ['smokehole/skylight', 'smokehole/skylights']], 'properties': [], 'englishmain': ['\u27e8window\u27e9', "formerly \u27e8smokehole/skylight\u27e9 of traditional Yup'ik house"], 'englishraw': "\u27e8window\u27e9, formerly \u27e8smokehole/skylight\u27e9 of traditional Yup'ik house", 'base_case': "window, formerly smokehole/skylight of traditional Yup'ik house", 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'spoon', 'yupikword': 'luuskaaq', 'fsts': ['luuskaar'], 'fstsDisplay': 'luuskaar-', 'key': 'luuskaaq', 'englishtenses': [['spoon', 'spoons']], 'properties': [], 'englishmain': ['\u27e8spoon\u27e9'], 'englishraw': '\u27e8spoon\u27e9', 'base_case': 'spoon', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'axe', 'yupikword': 'piqertuutaq', 'fsts': ['piqertuutar'], 'fstsDisplay': 'piqertuutar-', 'key': 'piqertuutaq', 'englishtenses': [['axe', 'axes']], 'properties': [], 'englishmain': ['\u27e8axe\u27e9'], 'englishraw': '\u27e8axe\u27e9', 'base_case': 'axe', 'usageIndex': 0, 'type': 'n'},
{'englishnorm': 'cutting knife', 'yupikword': 'nuussiq', 'fsts': ['nuussir'], 'fstsDisplay': 'nuussir-', 'key': 'nuussiq', 'englishtenses': [['knife', 'knives']], 'properties': [], 'englishmain': ['cutting \u27e8knife\u27e9'], 'englishraw': 'cutting \u27e8knife\u27e9', 'base_case': 'cutting knife', 'usageIndex': 0, 'type': 'n'},
]

export const popularVPostbasesSub = [

  {
    id: 0,
    // description: 'probably',
    allowable_next_ids: [1,0],
    expression:'–qaqe¹[V→V]',
  },
  {
    id: 1,
    // description: 'evidently',
    allowable_next_ids: [0,1],
    expression: '+peke|.vke[V→V]',
  },

  {
    id: 2,
    // description: 'no longer able to',
    expression: "+pege|.vke[V→V]",
    allowable_next_ids: [1,3,2],

  },


  // {
  //   id: 0,
  //   // description: 'probably',
  //   allowable_next_ids: [1,0],
  //   expression:'@~+yugnarqe¹[V→V]',
  // },
  // {
  //   id: 1,
  //   // description: 'evidently',
  //   allowable_next_ids: [0,1],
  //   expression: '–llini[V→V]',
  // },

  // {
  //   id: 2,
  //   // description: 'no longer able to',
  //   expression: "+(s)ciigali[V→V]",
  //   allowable_next_ids: [1,3,2],

  // },
  // {
  //   id: 3,
  //   // description: 'not able to',
  //   expression: '+(s)ciigate[V→V]',
  //   allowable_next_ids: [1,2,3]
  // },
  {
    id: 4,
    // description: 'is able to',
    expression: '@~+yugnga[V→V]',
    allowable_next_ids: [0,1,6,7,8,4]
  },

  {
    id: 11,
    // description: 'repeatedly',
    expression: "–lar[V→V]",
    allowable_next_ids: [1,11]
  },
  {
    id: 12,
    // description: 'doing it again',
    expression: '–nqigte[V→V]',
    allowable_next_ids: [1,12]
  },
  {
    id: 13,
    // description: 'almost',
    expression: '@~+yarpiar[V→V]',
    allowable_next_ids: [1,13]
  },
  {
    id: 14,
    // description: 'never',
    expression: '@~–yuite[V→V]',
    allowable_next_ids: [1,14]
  },
  {
    id: 15,
    // description: 'no longer',
    expression: '–nrir[V→V]',
    allowable_next_ids: [0,1,27,15]
  },
  {
    id: 16,
    // description: 'trying (unsuccessfully) to',
    expression: '@~+yaaqe[V→V]',
    allowable_next_ids: [0,1,17,19,16]
  },
  {
    id: 17,
    // description: 'trying despite difficulties to',
    expression: '–qcaar(ar)[V→V]',
    allowable_next_ids: [0,1,16,18,17]
  },
  {
    id: 18,
    // description: 'trying to',
    expression: '–ngnaqe[V→V]',
    allowable_next_ids: [0,1,16,17,18]
  },
  {
    id: 19,
    // description: 'excessively (too much)',
    expression: '–ssiyaag[V→V]',
    allowable_next_ids: [1,19]
  },
  {
    id: 20,
    // description: 'to be more or better at',
    expression: '–nru[V→V]',
    allowable_next_ids: [1,20]
  },
  {
    id: 21,
    // description: 'loves to',
    expression: '@~+yunqegg[V→V]',
    allowable_next_ids: [0,1,7,8,21]
  },
  {
    id: 22,
    // description: 'no longer wants to',
    expression: '@~+yuumiir(ar)te[V→V]',
    allowable_next_ids: [0,1,7,8,22]
  },
  {
    id: 23,
    // description: 'not care to',
    expression: '@~+yuumiite[V→V]',
    allowable_next_ids: [0,1,7,8,23]
  },
  {
    id: 24,
    // description: 'yearns to',
    expression: '@~+yuumir[V→V]',
    allowable_next_ids: [0,1,7,8,24]
  },
  {
    id: 25,
    // description: 'wants to',
    expression: '@~+yug[V→V]',
    allowable_next_ids: [0,1,7,8,25]
  },
  {
    id: 26,
    // description: 'enjoys doing',
    expression: '@~+yugar[V→V]',
    allowable_next_ids: [0,1,7,8,26]
  },
  {
    id: 27,
    // description: 'not',
    expression: '–nrite[V→V]',
    allowable_next_ids: [0,1,27]
  },

  {
    id: 28,
    // description: 'in the process of',
    expression: '@~+yartur[V→V]',
    allowable_next_ids: [0,1,2,3,4,5,6,7,8,9,10,19,28]
  },
  {
    id: 29,
    // description: 'definitely no longer going to',
    expression: '@~+yugnairute[V→V]',
    allowable_next_ids: [0,1,3,4,8,10,29], // only refers to the postbases, not the endings
  }
]
export const popularOptPostbases = [
  {
    id: 0,
    // description: 'please',
    expression:"\u2013qar[V\u2192V]",
    allowable_next_ids: [0]
  },
  {
    id: 1,
    // description: 'trying despite difficulties to',
    expression: '–qcaar(ar)[V→V]',
    allowable_next_ids: [1,0,2]
  },
  {
    id: 2, 
    // description: "first", 
    expression: "\u2013rraar[V\u2192V]", 
    allowable_next_ids: [2,0],
  }, 
  {
    id: 3, 
    // description: "quickly", 
    expression: "\u2013laag[V\u2192V]", 
    allowable_next_ids: [2,0,3],
  }, 
]
 

 
export const popularNPostbases = [
  {
    id: 0,
    // description: 'large',
    // englishModifier: (english) => { return 'large '+ english; },
    expression:'\u2013rpag|@vag[N\u2192N]',
    allowable_next_ids: [1,0]
  },
  {
    id: 1,
    expression:'\u2013cuar(ar*)[N\u2192N]',
    // description: 'small',
    // englishModifier: (english) => { return 'small '+ english; },
    // expression_end: '-cuar',
    // expression_postbase: '-cuar\\',
    // expression_conditional_end: '-kcuar',
    // expression_conditional_postbase: '-kcuar(ar)\\',
    // conditional_rule: '',
    // priority:4,
    // tense:'',
    allowable_next_ids: [0,1]
  },
  {
    id: 2,
    expression:'\u2013yagar*[N\u2192N]',
    // description: 'baby/little',
    // englishModifier: (english) => { return 'baby/little '+ english; },
    // expression_end: '-yagaq',
    // expression_postbase: '-yagar\\',
    // expression_conditional_end: '-yagaq',
    // expression_conditional_postbase: '-yagar\\',
    // conditional_rule: '',
    // priority:4,
    // tense:'',
    allowable_next_ids: [2]
  },
  {
    id: 3,
    expression:'\u2013kegtaar(ar*)[N\u2192N]',
    // description: 'good',
    // englishModifier: (english) => { return 'good '+ english; },
    // expression_end: '-kegtaar',
    // expression_postbase: '-kegtaar\\',
    // expression_conditional_end: '',
    // expression_conditional_postbase: '',
    // conditional_rule: '',
    // priority:4,
    // tense:'',
    allowable_next_ids: [3]
  },
  {
    id: 4,
    expression:'\u2013ller(ar*)[N\u2192N]',
    // description: 'shabby',
    // englishModifier: (english) => { return 'shabby '+ english; },
    // expression_end: '-2er',
    // expression_postbase: '-2er\\',
    // expression_conditional_end: '-2er',
    // expression_conditional_postbase: '-2er\\',
    // conditional_rule: '',
    // priority:4,
    // tense:'',
    allowable_next_ids: [4]
  },
  {
    id: 5,
    expression:'\u2013pig\u00b9[N\u2192N]',
    // description: 'genuine',
    // englishModifier: (english) => { return 'genuine '+ english; },
    // expression_end: '-piaq',
    // expression_postbase: '-piar\\',
    // expression_conditional_end: '-pik',
    // expression_conditional_postbase: '-pig\\',
    // conditional_rule: '',
    // priority:4,
    // tense:'past',
    allowable_next_ids: [5]
  },
  {
    id: 6,
    expression:'\u2013nguar[N\u2192N]',
    // description: 'fake',
    // englishModifier: (english) => { return 'fake '+ english; },
    // expression_end: '-(6)uaq',
    // expression_postbase: '-(6)uar\\',
    // expression_conditional_end: '',
    // expression_conditional_postbase: '',
    // conditional_rule: '',
    // priority:4,
    // tense:'',
    allowable_next_ids: [6]
  },
  // {
  //   id: 7,
  //   expression:'',
  //   // description: 'many Ns',
  //   // englishModifier: (english) => { return 'many of them'+ english},
  //   // expression_end: '-rugaq',
  //   // expression_postbase: '-rugar\\',
  //   // expression_conditional_end: '',
  //   // expression_conditional_postbase: '',
  //   // conditional_rule: '',
  //   // priority:2,
  //   // tense:'noun_end',
  //   allowable_next_ids: [7]
  // },
  {
    id: 8,
    expression:'\u2013rrar*[N\u2192N]',
    // description: 'just a little',
    // englishModifier: (english) => { return 'just a little'+ english},
    // expression_end: '-5aq',
    // expression_postbase: '-5ar\\',
    // expression_conditional_end: '',
    // expression_conditional_postbase: '',
    // conditional_rule: '',
    // priority:2,
    // tense:'noun_end',
    allowable_next_ids: [8]
  },
  // {
  //   id: 9,
  //   expression:'',
  //   description: 'N and other',
  //   englishModifier: (english) => { return 'and another - only applies to people or animals '+ english; },
  //   expression_end: ':(e)nkuk',
  //   expression_postbase: ':(e)nkug\\',
  //   expression_conditional_end: '',
  //   expression_conditional_postbase: '',
  //   conditional_rule: '',
  //   priority:2,
  //   tense:'noun_end',
  //   allowable_next_ids: [9]
  // },
  // {
  //   id: 10,
  //   expression:'',
  //   description: 'N and others',
  //   englishModifier: (english) => { return 'and others - only applies to people or animals '+ english; },
  //   expression_end: ':(e)nkut',
  //   expression_postbase: ':(e)nkur\\',
  //   expression_conditional_end: '',
  //   expression_conditional_postbase: '',
  //   conditional_rule: '',
  //   priority:2,
  //   tense:'noun_end',
  //   allowable_next_ids: [10]
  // },
  // {
  //   id: 11,
  //   expression:'+cur|+ssur[N\u2192V]',
  //   description: 'to hunt',
  //   // englishModifier: (english) => { return 'hunting '+ english; },
  //   // expression_postbase: '+cur\\',
  //   // expression_conditional_postbase: '+ssur\\',
  //   // conditional_rule: '',
  //   // priority:1,
  //   // tense:'',
  //   allowable_next_ids: [11]
  // },
  // {
  //   id: 12,
  //   expression:'\u2013\u2013li\u00b2[N\u2192V]',
  //   // description: 'to make',
  //   // englishModifier: (english) => { return 'making '+ english; },
  //   // expression_postbase: '-li\\',
  //   // expression_conditional_postbase: '',
  //   // conditional_rule: '',
  //   // priority:1,
  //   // tense:'',
  //   allowable_next_ids: [12]
  // },
  // {
  //   id: 13,
  //   expression:'\u2013\u2013liqe\u00b9[N\u2192V]',
  //   // description: 'to catch lots of',
  //   // englishModifier: (english) => { return 'catching lots of '+ english; },
  //   // expression_postbase: '-liqe\\',
  //   // expression_conditional_postbase: '',
  //   // conditional_rule: '',
  //   // priority:1,
  //   // tense:'',
  //   allowable_next_ids: [13]
  // },
  // {
  //   id: 14,
  //   expression:'\u2013\u2013lir[N\u2192V]',
  //   // description: 'to have lots of',
  //   // englishModifier: (english) => { return 'lots of '+ english; },
  //   // expression_postbase: '-lir\\',
  //   // expression_conditional_postbase: '',
  //   // conditional_rule: '',
  //   // priority:1,
  //   // tense:'',
  //   allowable_next_ids: [14]
  // },
  // {
  //   id: 15,
  //   expression:'\u2013\u2013liur[N\u2192V]',
  //   // description: 'to be occupied with',
  //   // englishModifier: (english) => { return 'occupied with '+ english; },
  //   // expression_postbase: '-liur\\',
  //   // expression_conditional_postbase: '',
  //   // conditional_rule: '',
  //   // priority:1,
  //   // tense:'',
  //   allowable_next_ids: [15]
  // },
  // {
  //   id: 16,
  //   expression:'\u2013nge[N\u2192V]',
  //   // description: 'to acquire',
  //   // englishModifier: (english) => { return 'acquiring '+ english; },
  //   // expression_postbase: '-6e\\',
  //   // expression_conditional_postbase: '',
  //   // conditional_rule: '',
  //   // priority:1,
  //   // tense:'',
  //   allowable_next_ids: [16]
  // },
  // {
  //   id: 17,
  //   expression:'\u2013ngqerr[N\u2192V]',
  //   // description: 'to have',
  //   // englishModifier: (english) => { return ''+ english; },
  //   // expression_postbase: '-ngqerr\\',
  //   // expression_conditional_postbase: '',
  //   // conditional_rule: '',
  //   // priority:1,
  //   // tense:'',
  //   allowable_next_ids: [17]
  // },
  // {
  //   id: 18,
  //   expression:'+taite\u00b9[N\u2192V]',
  //   // description: 'the place does not have',
  //   // englishModifier: (english) => { return '(location) does not have '+ english; },
  //   // expression_postbase: '+taite\\',
  //   // expression_conditional_postbase: '',
  //   // conditional_rule: '',
  //   // priority:1,
  //   // tense:'',
  //   allowable_next_ids: [18]
  // },
  // {
  //   id: 19,
  //   expression:'+tangqerr[N\u2192V]',
  //   // description: 'the place has',
  //   // englishModifier: (english) => { return '(location) has '+ english; },
  //   // expression_postbase: '+ta6qe5\\',
  //   // expression_conditional_postbase: '',
  //   // conditional_rule: '',
  //   // priority:1,
  //   // tense:'',
  //   allowable_next_ids: [19]
  // },
  // {
  //   id: 20,
  //   expression:'+tur\u00b2[N\u2192V]',
  //   // description: 'to eat',
  //   // englishModifier: (english) => { return 'eating '+ english; },
  //   // expression_postbase: '+tur\\',
  //   // expression_conditional_postbase: '',
  //   // conditional_rule: '',
  //   // priority:1,
  //   // tense:'',
  //   allowable_next_ids: [20]
  // },
  // {
  //   id: 21,
  //   expression:':~(ng)urte[N\u2192V]',
  //   // description: 'to become',
  //   // englishModifier: (english) => { return 'become '+ english; },
  //   // expression_postbase: '~:(6)urte\\',
  //   // expression_conditional_postbase: '',
  //   // conditional_rule: '',
  //   // priority:1,
  //   // tense:'',
  //   allowable_next_ids: [21]
  // }
]

export const popularVPostbasesNOTIME = [


  {
    id: 0,
    // description: 'probably',
    allowable_next_ids: [1,0],
    expression:'@~+yugnarqe¹[V→V]',
  },
  {
    id: 1,
    // description: 'evidently',
    allowable_next_ids: [0,1],
    expression: '–llini[V→V]',
  },

  {
    id: 2,
    // description: 'no longer able to',
    expression: "+(s)ciigali[V→V]",
    allowable_next_ids: [1,3,2],

  },
  {
    id: 3,
    // description: 'not able to',
    expression: '+(s)ciigate[V→V]',
    allowable_next_ids: [1,2,3]
  },
  {
    id: 4,
    // description: 'is able to',
    expression: '@~+yugnga[V→V]',
    allowable_next_ids: [0,1,6,7,8,4]
  },

  {
    id: 11,
    // description: 'repeatedly',
    expression: "–lar[V→V]",
    allowable_next_ids: [1,11]
  },
  {
    id: 12,
    // description: 'doing it again',
    expression: '–nqigte[V→V]',
    allowable_next_ids: [1,12]
  },
  {
    id: 13,
    // description: 'almost',
    expression: '@~+yarpiar[V→V]',
    allowable_next_ids: [1,13]
  },
  {
    id: 14,
    // description: 'never',
    expression: '@~–yuite[V→V]',
    allowable_next_ids: [1,14]
  },
  {
    id: 15,
    // description: 'no longer',
    expression: '–nrir[V→V]',
    allowable_next_ids: [0,1,27,15]
  },
  {
    id: 16,
    // description: 'trying (unsuccessfully) to',
    expression: '@~+yaaqe[V→V]',
    allowable_next_ids: [0,1,17,19,16]
  },
  {
    id: 17,
    // description: 'trying despite difficulties to',
    expression: '–qcaar(ar)[V→V]',
    allowable_next_ids: [0,1,16,18,17]
  },
  {
    id: 18,
    // description: 'trying to',
    expression: '–ngnaqe[V→V]',
    allowable_next_ids: [0,1,16,17,18]
  },
  {
    id: 19,
    // description: 'excessively (too much)',
    expression: '–ssiyaag[V→V]',
    allowable_next_ids: [1,19]
  },
  {
    id: 20,
    // description: 'to be more or better at',
    expression: '–nru[V→V]',
    allowable_next_ids: [1,20]
  },
  {
    id: 21,
    // description: 'loves to',
    expression: '@~+yunqegg[V→V]',
    allowable_next_ids: [0,1,7,8,21]
  },
  {
    id: 22,
    // description: 'no longer wants to',
    expression: '@~+yuumiir(ar)te[V→V]',
    allowable_next_ids: [0,1,7,8,22]
  },
  {
    id: 23,
    // description: 'not care to',
    expression: '@~+yuumiite[V→V]',
    allowable_next_ids: [0,1,7,8,23]
  },
  {
    id: 24,
    // description: 'yearns to',
    expression: '@~+yuumir[V→V]',
    allowable_next_ids: [0,1,7,8,24]
  },
  {
    id: 25,
    // description: 'wants to',
    expression: '@~+yug[V→V]',
    allowable_next_ids: [0,1,7,8,25]
  },
  {
    id: 26,
    // description: 'enjoys doing',
    expression: '@~+yugar[V→V]',
    allowable_next_ids: [0,1,7,8,26]
  },
  {
    id: 27,
    // description: 'not',
    expression: '–nrite[V→V]',
    allowable_next_ids: [0,1,27]
  },

  {
    id: 28,
    // description: 'in the process of',
    expression: '@~+yartur[V→V]',
    allowable_next_ids: [0,1,2,3,4,5,6,7,8,9,10,19,28]
  },
  {
    id: 29,
    // description: 'definitely no longer going to',
    expression: '@~+yugnairute[V→V]',
    allowable_next_ids: [0,1,3,4,8,10,29], // only refers to the postbases, not the endings
  }
];


export const popularVPostbasesPAST = [
  {
    id: 5,
    // description: 'past tense',
    expression: '–llru¹[V→V]',
    allowable_next_ids: [7,5,8,9]
  },
  {
    id: 6,
    // description: 'not yet',
    expression: "–ksaite[V→V]",
    allowable_next_ids: [0,1,7,6]
  },
];


export const popularVPostbasesFUTURE = [
  {
    id: 7,
    // description: 'future tense',
    expression: '+ciqe|@ciiqe[V→V]',
    allowable_next_ids: [0,1,5,10,7]
  },
  {
    id: 8,
    // description: 'will not',
    expression: '@~+ngaite[V→V]',
    allowable_next_ids: [0,1,7,10,8]
  },
  {
    id: 9,
    // description: 'will soon',
    expression: '@~+niarar[V→V]',
    allowable_next_ids: [0,1,5,6,7,10,9]
  },
  {
    id: 10,
    // description: 'about to',
    expression:'–qatar[V→V]',
    allowable_next_ids: [1,7,10]
  },
];



export const colorsList = [
  { 
    'mvv.s':'#852828',
    'mvv.o':'#C84141',
    'mvv.b':'#000000',
    // 'mvv.m':'#838383',
    'mvv.m':'#000000',
    'mvv.1':'#000000',
    'mvv.2':'#000000',
    'mvv.3':'#000000',
    'mvqWord':'#47995f',

    // 'past':'#dd9221',
    // 'future':'#dd9221',
    'past':'#000000',
    'future':'#000000',

    'mvns00.b':'#852828',
    'mvns00.pd':'#852828',

    'mvns10.ps':'#9c9c9c',
    'mvns20.ps':'#9c9c9c',

    // 'mvns00.ps':'#000000',
    // 'mvns10.b':'#000000',
    // 'mvns10.pd':'#000000',
    // 'mvns20.b':'#000000',
    // 'mvns20.pd':'#000000',

    // 'mvns10.b':'#852828',
    // 'mvns10.pd':'#852828',
    'mvns00.c':'#663782',    
    'mvns00.1':'#852828',
    'mvns00.2':'#852828',
    'mvns00.3':'#852828',

    'mvno00.b':'#C84141',
    'mvno00.pd':'#C84141', 
    'mvno10.ps':'#9c9c9c',
    'mvno20.ps':'#9c9c9c',

    'mvno00.c':'#663782',
    // 'mvno10.b':'#000000',
    // 'mvno20.b':'#000000',
    // 'mvno10.b':'#C84141',
    // 'mvno10.pd':'#C84141', 
    'mvno00.1':'#C84141',
    'mvno00.2':'#C84141',
    'mvno00.3':'#C84141',

    'cvv.b':'#000000',
    'cvv.s':'#287485',
    'cvv.o':'#565994',
    'cvv.m':'#c27db0',
    'cvv.1':'#000000',
    'cvv.2':'#000000',
    'cvv.3':'#000000',

    'cvns00.b':'#287485',
    'cvns00.pd':'#287485',

    'cvns10.ps':'#9c9c9c',
    'cvns20.ps':'#9c9c9c',

    'cvns00.c':'#663782',    
    // 'cvns10.b':'#000000',
    // 'cvns20.b':'#000000',
    // 'cvns10.pd':'#287485',
    'cvns00.1':'#287485',
    'cvns00.2':'#287485',
    'cvns00.3':'#287485',

    'cvno00.b':'#565994',
    'cvno00.pd':'#565994', 

    'cvno10.ps':'#9c9c9c',
    'cvno20.ps':'#9c9c9c',

    'cvno00.c':'#663782',
    // 'cvno10.b':'#000000',
    // 'cvno20.b':'#000000',
    // 'cvno10.b':'#565994',
    // 'cvno10.pd':'#565994', 
    'cvno00.1':'#565994',
    'cvno00.2':'#565994',
    'cvno00.3':'#565994',

    'svv.b':'#000000',
    'svv.o':'#565994',
    'svv.s':'#852828',
    'svv.e':'#565994',
    'svv.m':'#000000',
    'svv.1':'#000000',
    'svv.2':'#000000',
    'svv.3':'#000000',

    'svno00.b':'#565994',
    'svno00.pd':'#565994',

    'svno10.ps':'#9c9c9c',
    'svno20.ps':'#9c9c9c',

    'svno00.c':'#663782',
    // 'svno10.b':'#000000',
    // 'svno20.b':'#000000',
    // 'svno10.b':'#565994',
    // 'svno10.pd':'#565994', 
    'svno00.1':'#565994',
    'svno00.2':'#565994',
    'svno00.3':'#565994',

    'npn00.b':'#852828',
    'npn00.pd':'#852828',
    'npn00.ps':'#5c5c5c',
    'npn00.c':'#663782',    
    'npn00.1':'#852828',
    'npn00.2':'#852828',
    'npn00.3':'#852828',



    'mvnObliques000.b':'#000000',
    'mvnObliques000.pd':'#000000',
    'mvnObliques010.ps':'#9c9c9c',
    'mvnObliques000.c':'#663782',
    'mvnObliques000.1':'#000000',
    'mvnObliques000.2':'#000000',
    'mvnObliques000.3':'#000000',

    'mvnObliques100.b':'#000000',
    'mvnObliques100.pd':'#000000',
    'mvnObliques110.ps':'#9c9c9c',
    'mvnObliques100.c':'#663782',
    'mvnObliques100.1':'#000000',
    'mvnObliques100.2':'#000000',
    'mvnObliques100.3':'#000000',

    'cvnObliques000.b':'#000000',
    'cvnObliques000.pd':'#000000',
    'cvnObliques010.ps':'#9c9c9c',
    'cvnObliques000.c':'#663782',
    'cvnObliques000.1':'#000000',
    'cvnObliques000.2':'#000000',
    'cvnObliques000.3':'#000000',

    'cvnObliques100.b':'#000000',
    'cvnObliques100.pd':'#000000',
    'cvnObliques110.ps':'#9c9c9c',
    'cvnObliques100.c':'#663782',
    'cvnObliques100.1':'#000000',
    'cvnObliques100.2':'#000000',
    'cvnObliques100.3':'#000000',

    'svnObliques000.b':'#000000',
    'svnObliques000.pd':'#000000',
    'svnObliques010.ps':'#9c9c9c',
    'svnObliques000.c':'#663782',
    'svnObliques000.1':'#000000',
    'svnObliques000.2':'#000000',
    'svnObliques000.3':'#000000',

    'svnObliques100.b':'#000000',
    'svnObliques100.pd':'#000000',
    'svnObliques110.ps':'#9c9c9c',
    'svnObliques100.c':'#663782',
    'svnObliques100.1':'#000000',
    'svnObliques100.2':'#000000',
    'svnObliques100.3':'#000000',


    // #287485
    // #565994
  },

  {
    'npn00.c':'#663782',    
    'npn00.1':'#852828',
    'mvv.1b':'#d3741e',
    'mvv.1':'#000000',
    'mvnObliques000.c':'#663782',
    'mvqWord':'#47995f',
    "qaa":"#47995f",
    'past':'#000000',
    'future':'#000000',

    'mvns00.b':'#852828',
    'mvns00.ps':'#852828',
    "mvns00.pd":'#852828',
    'mvns00.c':'#852828',

    "1stperson":"#dd9221",
    "mvno00.1":'#c84141',
    'mvno00.b':'#c84141',
    'mvno00.ps':'#c84141',
    "mvno00.pd":'#c84141',
    'mvno00.c':'#c84141',

    'cvv.b':'#287485',
    'cvv.s':'#287485',
    'cvv.o':'#287485',
    'cvv.m':'#287485',
    'cvv.1':'#287485',
    'cvv.2':'#287485',
    'cvv.3':'#287485',

    'svv.b':'#287485',
    'svv.s':'#287485',
    'svv.o':'#287485',
    'svv.m':'#287485',
    'svv.1':'#287485',
    'svv.2':'#287485',
    'svv.3':'#287485',
    
  },
  
  { 
    'mvv.s':'#852828',
    'mvv.o':'#287485',
    'mvv.b':'#000000',

    'mvnObliques000.b':'#000000',
    'mvnObliques000.ps':'#000000',
    'mvnObliques000.pd':'#000000',
    'mvnObliques000.c':'#000000',
    'mvnObliques000.1':'#000000',
    'mvnObliques000.2':'#000000',
    'mvnObliques000.3':'#000000',
    'mvnObliques000.4':'#000000',
    'mvnObliques000.5':'#000000',

    'mvnObliques100.b':'#000000',
    'mvnObliques100.ps':'#000000',
    'mvnObliques100.pd':'#000000',
    'mvnObliques100.c':'#000000',
    'mvnObliques100.1':'#000000',
    'mvnObliques100.2':'#000000',
    'mvnObliques100.3':'#000000',
    'mvnObliques100.4':'#000000',
    'mvnObliques100.5':'#000000',

    'cvv.b':'#000000',
    'cvv.e':'#000000',
    'cvv.s':'#000000',
    'cvv.o':'#000000',
    'cvv.m':'#000000',
    'cvv.1':'#000000',
    'cvv.2':'#000000',
    'cvv.3':'#000000',
    'cvv.4':'#000000',
    'cvv.5':'#000000',

    'npn00.b':'#852828',
    'npn00.pd':'#852828',
    'npn00.ps':'#C84141',
    'npn00.1':'#000000',
    'npn00.2':'#000000',
    'npn00.3':'#000000',
    'npn00.4':'#000000',
    'npn00.5':'#000000',
    'npn00.c':'#000000',

    'npn10.b':'#C84141',
    'npn10.pd':'#C84141',

    'mvns00.b':'#852828',
    'mvns00.ps':'#C84141',
    'mvns00.pd':'#852828',        
    'mvns00.1':'#000000',
    'mvns00.2':'#000000',
    'mvns00.3':'#000000',
    'mvns00.4':'#000000',
    'mvns00.5':'#000000',
    'mvns00.e':'#000000',

    'mvno00.b':'#287485',
    'mvno00.pd':'#287485', 
    'mvno00.ps':'#565994',
    'mvno00.c':'#3e3e3e',
    'mvno10.b':'#287485',
    'mvno10.pd':'#287485', 
    'mvno00.1':'#000000',
    'mvno00.2':'#000000',
    'mvno00.3':'#000000',
    'mvno00.4':'#000000',
    'mvno00.5':'#000000',
    'mvno00.e':'#000000',
  },
  { 
    '1st-1':'purple',
    '1st-2':'purple',
    'mvv.b':'#000000',
    'mvv.e':'#852828',
    'mvv.s':'#852828',
    'mvv.o':'#C84141',
    'mvv.m':'#838383',
    'mvv.1':'#d3741e',
    'mvv.2':'#c062c3',
    'mvv.3':'#008000',
    'mvv.4':'#69b4b4',
    'mvv.5':'#e02323',
    'mvv.6':'#3455b5',

    'mvnObliques000.b':'#000000',
    'mvnObliques000.ps':'#c51818',
    'mvnObliques000.pd':'#d23636',
    'mvnObliques000.c':'#9c9c9c',
    'mvnObliques000.1':'#69b4b4',

    'mvnObliques100.b':'#000000',
    'mvnObliques100.ps':'#c51818',
    'mvnObliques100.pd':'#d23636',
    'mvnObliques100.c':'#9c9c9c',

    'cvv.b':'#000000',
    'cvv.e':'#3070AB',
    'cvv.s':'#3070AB',
    'cvv.o':'#618EB8',
    'cvv.m':'#75557e',

    'npn00.b':'#000000',
    'npn00.pd':'#d65c1e',
    'npn00.ps':'#d28036',
    'npn00.1':'#69b4b4',
    'npn00.2':'#e02323',
    'npn00.c':'#9c9c9c',


    'mvns00.b':'#852828',
    'mvns00.ps':'#c51818',
    'mvns00.pd':'#d23636',        
    'mvns00.1':'#b53434',
    'mvns00.2':'#578f7f',
    'mvns00.e':'#f29090',

    'mvno00.b':'#C84141',
    'mvno00.1':'#b53434',
    'mvno00.2':'#578f7f',
    'mvno00.e':'#f29090',
  },
  { 
    'mvv.b':'#000000',
    'mvv.e':'#852828',
    'mvv.s':'#852828',
    'mvv.o':'#C84141',
    'mvv.m':'#838383',
    'mvv.1':'#d3741e',
    'mvv.2':'#c062c3',
    'mvv.3':'#008000',
    'mvv.4':'#69b4b4',
    'mvv.5':'#e02323',
    'mvv.6':'#3455b5',

    'mvnObliques000.b':'#000000',
    'mvnObliques000.ps':'#c51818',
    'mvnObliques000.pd':'#d23636',
    'mvnObliques010.ps':'#c51818',
    'mvnObliques010.pd':'#d23636',
    'mvnObliques000.c':'#9c9c9c',
    'mvnObliques000.1':'#69b4b4',

    'mvnObliques100.b':'#000000',
    'mvnObliques100.ps':'#c51818',
    'mvnObliques100.pd':'#d23636',
    'mvnObliques100.c':'#9c9c9c',

    'cvv.b':'#000000',
    'cvv.e':'#3070AB',
    'cvv.s':'#3070AB',
    'cvv.o':'#618EB8',
    'cvv.m':'#75557e',

    'npn00.b':'#000000',
    'npn00.pd':'#d23636',
    'npn00.ps':'#c51818',
    'npn00.1':'#69b4b4',
    'npn00.2':'#e02323',
    'npn00.c':'#9c9c9c',


    'mvns00.b':'#852828',
    'mvns00.ps':'#c51818',
    'mvns00.pd':'#d23636',        
    'mvns00.1':'#b53434',
    'mvns00.2':'#578f7f',
    'mvns00.e':'#f29090',

    'mvno00.b':'#C84141',
    'mvno00.1':'#b53434',
    'mvno00.2':'#578f7f',
    'mvno00.e':'#f29090',
  },
]


export const retrieveMoodEnglish = {
  'Prec':{english:'before',fst:'@~+(t)vaileg-'},
  'Cnsq':{english:'because',fst:'@~:(ng)a-'},
  'Cont':{english:'whenever',fst:"+'(g)aqa-"},
  'Conc':{english:'although, even though, even if',fst:'@+ngr(ar)-'},
  'Cond':{english:'if, when in the future',fst:'@~-ku-'},
  'CtmpI':{english:'when in the past',fst:'-ller-'},
  'CtmpII':{english:'while',fst:'@:(ng)inaner-'},
}

export const nounoptions1 = [
  {id: 0, value: '00(3)', text:'the'},
  {id: 1, value: '11(3)', text:'my'},
  {id: 2, value: '21(3)', text:'your'},
  {id: 3, value: '31-1(3)', text:'his'},
  {id: 4, value: '31-2(3)', text:'her'},
  {id: 5, value: '31-3(3)', text:'its'},
  // {id: 6, value: '41(3)', text:'its own'},
  {id: 7, value: '12(3)', text:'our (two)'},
  {id: 8, value: '22(3)', text:'your (two)'},
  {id: 9, value: '32(3)', text:'their (two)'},
  // {id: 10, value: '42(3)', text:'their own (two)'},
  {id: 11, value: '13(3)', text:'our (3+)'},
  {id: 12, value: '23(3)', text:'your (3+)'},
  {id: 13, value: '33(3)', text:'their (3+)'},
  // {id: 14, value: '43(3)', text:'their own (3+)'},
];



export const nounoptionsmodalis = [
  {id: 0, value: '00(3)', text:'a, some'},
  {id: 1, value: '11(3)', text:'my'},
  {id: 2, value: '21(3)', text:'your'},
  {id: 3, value: '31-1(3)', text:'his'},
  {id: 4, value: '31-2(3)', text:'her'},
  {id: 5, value: '31-3(3)', text:'its'},
  // {id: 6, value: '41(3)', text:'its own'},
  {id: 7, value: '12(3)', text:'our (two)'},
  {id: 8, value: '22(3)', text:'your (two)'},
  {id: 9, value: '32(3)', text:'their (two)'},
  // {id: 10, value: '42(3)', text:'their own (two)'},
  {id: 11, value: '13(3)', text:'our (3+)'},
  {id: 12, value: '23(3)', text:'your (3+)'},
  {id: 13, value: '33(3)', text:'their (3+)'},
];



export const nounoptions2 = [
  {id: 0, value: '1', text:'one'},
  {id: 1, value: '2', text:'two'},
  {id: 2, value: '3', text:'3+'},
];



export const nounOptionsPossessorsNo4th = [
  {id: 0, value: '000', text:'the'},
  {id: 1, value: '110', text:'my'},
  {id: 2, value: '210', text:'your'},
  {id: 3, value: '311', text:'his'},
  {id: 4, value: '312', text:'her'},
  {id: 5, value: '313', text:'its'},
  // {id: 6, value: '41', text:'its own'},
  {id: 7, value: '120', text:'our (two)'},
  {id: 8, value: '220', text:'your (two)'},
  {id: 9, value: '320', text:'their (two)'},
  // {id: 10, value: '42', text:'their own (two)'},
  {id: 11, value: '130', text:'our (3+)'},
  {id: 12, value: '230', text:'your (3+)'},
  {id: 13, value: '330', text:'their (3+)'},
  // {id: 14, value: '43', text:'their own (3+)'},
];


export const nounOptionsMVPossessorsThe = [
  {id: 0, value: '000', text:'the'},
  {id: 1, value: '110', text:'my'},
  {id: 2, value: '210', text:'your'},
  {id: 3, value: '311', text:'his'},
  {id: 4, value: '312', text:'her'},
  {id: 5, value: '313', text:'its'},
  // {id: 6, value: '410', text: "mvsubject's"},
  {id: 7, value: '120', text:'our (two)'},
  {id: 8, value: '220', text:'your (two)'},
  {id: 9, value: '320', text:'their (two)'},
  // {id: 10, value: '420', text:'their own (two)'},
  {id: 11, value: '130', text:'our (3+)'},
  {id: 12, value: '230', text:'your (3+)'},
  {id: 13, value: '330', text:'their (3+)'},
  // {id: 14, value: '430', text:'their own (3+)'},
];

export const nounOptionsMVPossessors = [
  // {id: 0, value: '000', text:'the'},
  {id: 1, value: '110', text:'my'},
  {id: 2, value: '210', text:'your'},
  {id: 3, value: '311', text:'his'},
  {id: 4, value: '312', text:'her'},
  {id: 5, value: '313', text:'its'},
  // {id: 6, value: '410', text: "mvsubject's"},
  {id: 7, value: '120', text:'our (two)'},
  {id: 8, value: '220', text:'your (two)'},
  {id: 9, value: '320', text:'their (two)'},
  // {id: 10, value: '420', text:'their own (two)'},
  {id: 11, value: '130', text:'our (3+)'},
  {id: 12, value: '230', text:'your (3+)'},
  {id: 13, value: '330', text:'their (3+)'},
  // {id: 14, value: '430', text:'their own (3+)'},
];

// export const nounOptionsMVAblPossessors = [
//   {id: 0, value: '000', text:'a, some'},
//   {id: 1, value: '110', text:'my'},
//   {id: 2, value: '210', text:'your'},
//   {id: 3, value: '311', text:'his'},
//   {id: 4, value: '312', text:'her'},
//   {id: 5, value: '313', text:'its'},
//   // {id: 6, value: '410', text: "mvsubject's"},
//   {id: 7, value: '120', text:'our (two)'},
//   {id: 8, value: '220', text:'your (two)'},
//   {id: 9, value: '320', text:'their (two)'},
//   // {id: 10, value: '420', text:'their own (two)'},
//   {id: 11, value: '130', text:'our (3+)'},
//   {id: 12, value: '230', text:'your (3+)'},
//   {id: 13, value: '330', text:'their (3+)'},
//   // {id: 14, value: '430', text:'their own (3+)'},
// ];

// export const nounOptionsCVAblPossessors = [
//   // {id: 0, value: '000', text:'a, some'},
//   {id: 1, value: '110', text:'my'},
//   {id: 2, value: '210', text:'your'},
//   {id: 3, value: '311', text:'his'},
//   {id: 4, value: '312', text:'her'},
//   {id: 5, value: '313', text:'its'},
//   // {id: 6, value: '411', text:"cvsubject's"},
//   {id: 7, value: '120', text:'our (two)'},
//   {id: 8, value: '220', text:'your (two)'},
//   {id: 9, value: '320', text:'their (two)'},
//   // {id: 10, value: '420', text:'their own (two)'},
//   {id: 11, value: '130', text:'our (3+)'},
//   {id: 12, value: '230', text:'your (3+)'},
//   {id: 13, value: '330', text:'their (3+)'},
//   // {id: 14, value: '430', text:'their own (3+)'},
// ];

// export const nounOptionsCVPossessors = [
//   // {id: 0, value: '000', text:'the'},
//   {id: 1, value: '110', text:'my'},
//   {id: 2, value: '210', text:'your'},
//   {id: 3, value: '311', text:'his'},
//   {id: 4, value: '312', text:'her'},
//   {id: 5, value: '313', text:'its'},
//   // {id: 6, value: '411', text:"cvsubject's"},
//   {id: 7, value: '120', text:'our (two)'},
//   {id: 8, value: '220', text:'your (two)'},
//   {id: 9, value: '320', text:'their (two)'},
//   // {id: 10, value: '420', text:'their own (two)'},
//   {id: 11, value: '130', text:'our (3+)'},
//   {id: 12, value: '230', text:'your (3+)'},
//   {id: 13, value: '330', text:'their (3+)'},
//   // {id: 14, value: '430', text:'their own (3+)'},
// ];

// export const nounOptionsSVPossessors = [
//   {id: 0, value: '000', text:'the'},
//   {id: 1, value: '110', text:'my'},
//   {id: 2, value: '210', text:'your'},
//   {id: 3, value: '311', text:'his'},
//   {id: 4, value: '312', text:'her'},
//   {id: 5, value: '313', text:'its'},
//   // {id: 6, value: '412', text:"svsubject's"},
//   {id: 7, value: '120', text:'our (two)'},
//   {id: 8, value: '220', text:'your (two)'},
//   {id: 9, value: '320', text:'their (two)'},
//   // {id: 10, value: '420', text:'their own (two)'},
//   {id: 11, value: '130', text:'our (3+)'},
//   {id: 12, value: '230', text:'your (3+)'},
//   {id: 13, value: '330', text:'their (3+)'},
//   // {id: 14, value: '430', text:'their own (3+)'},
// ];


export const nounOptionsNumbers = [
  {id: 0, value: '1', text:'one'},
  {id: 1, value: '2', text:'two'},
  {id: 2, value: '3', text:'3+'},
];

export const mvSubjectOptionsEnglish = {
  '110':'I', 
  '210':'you', 
  '310':'it',
  '311':'he',
  '312':'she',
  '313':'it',
  '410':'subject',
  '120':'the two of us',
  '220':'the two of you',
  '320':'the two of them',
  '420':'their own (two)',
  '130':'we all (3+)',
  '230':'you all (3+)',
  '330':'they all (3+)',
  '430':'their own (3+)',
};

export const mvObjectOptionsEnglish = {
  '110':'me', 
  '210':'you', 
  '310':'it',
  '311':'him',
  '312':'her',
  '313':'it',
  '410':'subject',
  '120':'the two of us',
  '220':'the two of you',
  '320':'the two of them',
  '420':'their own (two)',
  '130':'us all (3+)',
  '230':'you all (3+)',
  '330':'them all (3+)',
  '430':'their own (3+)',
};
export const npnEnglish = {
  '1':'one', 
  '2':'two', 
  '3':'3+',
  '000':'the',
  '110':'my',
  '210':'your',
  '311':'his',
  '312':'her',
  '313':'its',
  '120':'our (two)',
  '220':'your (two)',
  '320':'their (two)',
  '130':'our (3+)',
  '230':'your (3+)',
  '330':'their (3+)',
};

export const npnEnglishself = {
  '1':'itself', 
  '2':'themselves', 
  '3':'themselves',
  '000':'itself',
  '110':'myself',
  '210':'yourself',
  '311':'himself',
  '312':'herself',
  '313':'itself',
  '120':'ourselves (two)',
  '220':'yourself (two)',
  '320':'themselves (two)',
  '130':'ourselves (3+)',
  '230':'yourselves (3+)',
  '330':'themselves (3+)',
};



export const mvSubject4thPersonCalls = {
  '311':'he',
  '312':'she',
  '313':'it',
  '320':'the two of them',
  '330':'they all (3+)',
}

export const mvObject4thPersonCalls = {
  '311':'him',
  '312':'her',
  '313':'it',
  '320':'the two of them',
  '330':'them all (3+)',
}

export const nObject4thPersonCalls = {
  '310':'its',
  '311':'his',
  '312':'her',
  '313':'its',
  '320':'their (2)',
  '321':'their (2)',
  '330':'their (3+)',
  '331':'their (3+)',

  // '410':'its',
  // '420':'their (2)',
  // '430':'their (3+)',
  // '411':'its',
  // '421':'their (2)',
  // '431':'their (3+)',


}

export const mvSubjectOptionsOnly2nd = [
  {id: 1, value: '210', text:'you', otext:'you'},
  {id: 7, value: '220', text:'you two', otext:'you two'},
  {id: 11, value: '230', text:'you all (3+)', otext:'you all (3+)'},
];

export const mvSubjectOptions = [
  {id: 0, value: '110', text:'I', otext:'me'},
  {id: 1, value: '210', text:'you', otext:'you'},
  {id: 2, value: '311', text:'he', otext:'him'},
  {id: 3, value: '312', text:'she', otext:'her'},
  {id: 4, value: '313', text:'it', otext:'it'},
  // {id: 999, value: '999', text:'add noun', otext:'it'},
  // {id: 5, value: '410', text:'subject', otext:'subject'},
  {id: 6, value: '120', text:'the two of us', otext:'the two of us'},
  {id: 7, value: '220', text:'the two of you', otext:'the two of you'},
  {id: 8, value: '320', text:'the two of them', otext:'the two of them'},
  // {id: 9, value: '420', text:'their own (two)', otext:'their own (two)'},
  {id: 10, value: '130', text:'we all (3+)', otext:'us all (3+)'},
  {id: 11, value: '230', text:'you all (3+)', otext:'you all (3+)'},
  {id: 12, value: '330', text:'they all (3+)', otext:'them all (3+)'},
  // {id: 13, value: '430', text:'their own (3+)', otext:'their own (3+)'},
];

export const mvObjectOptions = [
  {id: 0, value: '110', text:'me', ptext:'my'},
  {id: 1, value: '210', text:'you', ptext:'your'},
  {id: 2, value: '311', text:'him', ptext:'his'},
  {id: 3, value: '312', text:'her', ptext:'her'},
  {id: 4, value: '313', text:'it', ptext:'its'},
  // {id: 5, value: '410', text:'subject', ptext:'subject'},
  {id: 6, value: '120', text:'the two of us', ptext:'our (two)'},
  {id: 7, value: '220', text:'the two of you', ptext:'your (two)'},
  {id: 8, value: '320', text:'the two of them', ptext:'their (two)'},
  // {id: 9, value: '420', text:'their own (two)', ptext:'their own (two)'},
  {id: 10, value: '130', text:'us all (3+)', ptext:'our (3+)'},
  {id: 11, value: '230', text:'you all (3+)', ptext:'your (3+)'},
  {id: 12, value: '330', text:'them all (3+)', ptext:'their (3+)'},
  // {id: 13, value: '430', text:'their own (3+)', ptext:'their own (3+)'},
];

export const mvSubjectOptionsWho = [
  // {id: 0, value: '110', text:'I', otext:'me'},
  // {id: 1, value: '210', text:'you', otext:'you'},
  {id: 2, value: '311', text:'he', otext:'him'},
  {id: 3, value: '312', text:'she', otext:'her'},
  {id: 4, value: '313', text:'it', otext:'it'},
  // {id: 5, value: '410', text:'subject', otext:'subject'},
  // {id: 6, value: '120', text:'the two of us', otext:'the two of us'},
  // {id: 7, value: '220', text:'the two of you', otext:'the two of you'},
  {id: 8, value: '320', text:'the two of them', otext:'the two of them'},
  // {id: 9, value: '420', text:'their own (two)', otext:'their own (two)'},
  // {id: 10, value: '130', text:'we all (3+)', otext:'us all (3+)'},
  // {id: 11, value: '230', text:'you all (3+)', otext:'you all (3+)'},
  {id: 12, value: '330', text:'they all (3+)', otext:'them all (3+)'},
  // {id: 13, value: '430', text:'their own (3+)', otext:'their own (3+)'},
];

export const mvObjectOptionsWhom = [
  // {id: 0, value: '110', text:'whom (me)', ptext:'my'},
  // {id: 1, value: '210', text:'whom (you)', ptext:'your'},
  {id: 2, value: '311', text:'whom (him)', ptext:'his'},
  {id: 3, value: '312', text:'whom (her)', ptext:'her'},
  {id: 4, value: '313', text:'whom (it)', ptext:'its'},
  // {id: 5, value: '410', text:'whom (subject', ptext:'subject'},
  // {id: 6, value: '120', text:'whom (the two of us)', ptext:'our (two)'},
  // {id: 7, value: '220', text:'whom (the two of you)', ptext:'your (two)'},
  {id: 8, value: '320', text:'whom (the two of them)', ptext:'their (two)'},
  // {id: 9, value: '420', text:'whom (their own two)', ptext:'their own (two)'},
  // {id: 10, value: '130', text:'whom (us all 3+)', ptext:'our (3+)'},
  // {id: 11, value: '230', text:'whom (you all 3+)', ptext:'your (3+)'},
  {id: 12, value: '330', text:'whom (them all 3+)', ptext:'their (3+)'},
  // {id: 13, value: '430', text:'whom (their own 3+)', ptext:'their own (3+)'},
];

export const mvSubjectOptionsWhat = [
  // {id: 0, value: '110', text:'I', otext:'me'},
  // {id: 1, value: '210', text:'you', otext:'you'},
  // {id: 2, value: '311', text:'he', otext:'him'},
  // {id: 3, value: '312', text:'she', otext:'her'},
  {id: 4, value: '313', text:'it', otext:'it'},
  // {id: 5, value: '410', text:'subject', otext:'subject'},
  // {id: 6, value: '120', text:'the two of us', otext:'the two of us'},
  // {id: 7, value: '220', text:'the two of you', otext:'the two of you'},
  {id: 8, value: '320', text:'the two of them', otext:'the two of them'},
  // {id: 9, value: '420', text:'their own (two)', otext:'their own (two)'},
  // {id: 10, value: '130', text:'we all (3+)', otext:'us all (3+)'},
  // {id: 11, value: '230', text:'you all (3+)', otext:'you all (3+)'},
  {id: 12, value: '330', text:'they all (3+)', otext:'them all (3+)'},
  // {id: 13, value: '430', text:'their own (3+)', otext:'their own (3+)'},
];

export const mvObjectOptionsWhat = [
  {id: 0, value: '110', text:'what (me)', ptext:'my'},
  {id: 1, value: '210', text:'what (you)', ptext:'your'},
  // {id: 2, value: '311', text:'what (him)', ptext:'his'},
  // {id: 3, value: '312', text:'what (her)', ptext:'her'},
  {id: 4, value: '313', text:'what (it)', ptext:'its'},
  // {id: 5, value: '410', text:'whom (subject', ptext:'subject'},
  {id: 6, value: '120', text:'what (the two of us)', ptext:'our (two)'},
  {id: 7, value: '220', text:'what (the two of you)', ptext:'your (two)'},
  {id: 8, value: '320', text:'what (the two of them)', ptext:'their (two)'},
  // {id: 9, value: '420', text:'whom (their own two)', ptext:'their own (two)'},
  {id: 10, value: '130', text:'what (us all 3+)', ptext:'our (3+)'},
  {id: 11, value: '230', text:'what (you all 3+)', ptext:'your (3+)'},
  {id: 12, value: '330', text:'what (them all 3+)', ptext:'their (3+)'},
  // {id: 13, value: '430', text:'whom (their own 3+)', ptext:'their own (3+)'},
];

export const mvObjectOptionsWhomAbl = [
  // {id: 0, value: '110', text:'whom (me)', ptext:'my'},
  // {id: 1, value: '210', text:'whom (you)', ptext:'your'},
  {id: 2, value: '311', text:'whom (him)', ptext:'his'},
  {id: 3, value: '312', text:'whom (her)', ptext:'her'},
  {id: 4, value: '313', text:'whom (it)', ptext:'its'},
  // {id: 5, value: '410', text:'whom (subject', ptext:'subject'},
  // {id: 6, value: '120', text:'whom (the two of us)', ptext:'our (two)'},
  // {id: 7, value: '220', text:'whom (the two of you)', ptext:'your (two)'},
  {id: 8, value: '320', text:'whom (some 2 people)', ptext:'their (two)'},
  // {id: 9, value: '420', text:'whom (their own two)', ptext:'their own (two)'},
  // {id: 10, value: '130', text:'whom (us all 3+)', ptext:'our (3+)'},
  // {id: 11, value: '230', text:'whom (you all 3+)', ptext:'your (3+)'},
  {id: 12, value: '330', text:'whom (some 3+ people)', ptext:'their (3+)'},
  // {id: 13, value: '430', text:'whom (their own 3+)', ptext:'their own (3+)'},
];

export const mvObjectOptionsWhatAbl = [
  // {id: 0, value: '110', text:'what (me)', ptext:'my'},
  // {id: 1, value: '210', text:'what (you)', ptext:'your'},
  // {id: 2, value: '311', text:'what (him)', ptext:'his'},
  // {id: 3, value: '312', text:'what (her)', ptext:'her'},
  {id: 4, value: '313', text:'what (something)', ptext:'its'},
  // {id: 5, value: '410', text:'whom (subject', ptext:'subject'},
  // {id: 6, value: '120', text:'what (the two of us)', ptext:'our (two)'},
  // {id: 7, value: '220', text:'what (the two of you)', ptext:'your (two)'},
  {id: 8, value: '320', text:'what (some 2 things)', ptext:'their (two)'},
  // {id: 9, value: '420', text:'whom (their own two)', ptext:'their own (two)'},
  // {id: 10, value: '130', text:'what (us all 3+)', ptext:'our (3+)'},
  // {id: 11, value: '230', text:'what (you all 3+)', ptext:'your (3+)'},
  {id: 12, value: '330', text:'what (some 3+ things)', ptext:'their (3+)'},
  // {id: 13, value: '430', text:'whom (their own 3+)', ptext:'their own (3+)'},
];






export const options1 = [
  {id: 0, value: 's11(1)', text:'I', otext:'me'},
  {id: 1, value: 's21(1)', text:'you', otext:'you'},
  {id: 2, value: 's31-1(1)', text:'he', otext:'him'},
  {id: 3, value: 's31-2(1)', text:'she', otext:'her'},
  {id: 4, value: 's31-3(1)', text:'it', otext:'it'},
  // {id: 5, value: 's41(1)', text:'its own', otext:'its own'},
  {id: 6, value: 's12(1)', text:'the two of us', otext:'the two of us'},
  {id: 7, value: 's22(1)', text:'the two of you', otext:'the two of you'},
  {id: 8, value: 's32(1)', text:'the two of them', otext:'the two of them'},
  // {id: 9, value: 's42(1)', text:'their own (two)', otext:'their own (two)'},
  {id: 10, value: 's13(1)', text:'we all (3+)', otext:'us all (3+)'},
  {id: 11, value: 's23(1)', text:'you all (3+)', otext:'you all (3+)'},
  {id: 12, value: 's33(1)', text:'they all (3+)', otext:'them all (3+)'},
  // {id: 13, value: 's43(1)', text:'their own (3+)', otext:'their own (3+)'}
];

export const options2 = [
  {id: 0, value: 'o11(2)', text:'me', ptext:'my'},
  {id: 1, value: 'o21(2)', text:'you', ptext:'your'},
  {id: 2, value: 'o31-1(2)', text:'him', ptext:'his'},
  {id: 3, value: 'o31-2(2)', text:'her', ptext:'her'},
  {id: 4, value: 'o31-3(2)', text:'it', ptext:'its'},
  // {id: 5, value: 'o41(2)', text:'its own', ptext:'its own'},
  {id: 6, value: 'o12(2)', text:'the two of us', ptext:'our (two)'},
  {id: 7, value: 'o22(2)', text:'the two of you', ptext:'your (two)'},
  {id: 8, value: 'o32(2)', text:'the two of them', ptext:'their (two)'},
  // {id: 9, value: 'o42(2)', text:'their own (two)', ptext:'their own (two)'},
  {id: 10, value: 'o13(2)', text:'us all (3+)', ptext:'our (3+)'},
  {id: 11, value: 'o23(2)', text:'you all (3+)', ptext:'your (3+)'},
  {id: 12, value: 'o33(2)', text:'them all (3+)', ptext:'their (3+)'},
  // {id: 13, value: 'o43(2)', text:'their own (3+)', ptext:'their own (3+)'},
];


export const options3 = [
  {id: 0, value: 'o11(3)', text:'my'},
  {id: 1, value: 'o21(3)', text:'your'},
  {id: 2, value: 'o31-1(3)', text:'his'},
  {id: 3, value: 'o31-2(3)', text:'her'},
  {id: 4, value: 'o31-3(3)', text:'its'},
  // {id: 5, value: 'o41(2)', text:'its own'},
  {id: 6, value: 'o12(3)', text:'our (two)'},
  {id: 7, value: 'o22(3)', text:'your (two)'},
  {id: 8, value: 'o32(3)', text:'their (two)'},
  // {id: 9, value: 'o42(2)', text:'their own (two)'},
  {id: 10, value: 'o13(3)', text:'our (3+)'},
  {id: 11, value: 'o23(3)', text:'your (3+)'},
  {id: 12, value: 'o33(3)', text:'their (3+)'},
  // {id: 13, value: 'o43(2)', text:'their own (3+)', ptext:'their own (3+)'},
];

export const retrieveSubjectObject =
  {'11(1)':'I',
  '21(1)':'you',
  '31-1(1)':'he',
  '31-2(1)':'she',
  '31-3(1)':'it',
  '41(1)':'its own',
  '12(1)':'the two of us',
  '22(1)':'the two of you',
  '32(1)':'the two of them',
  '42(1)':'their own (two)',
  '13(1)':'we all (3+)',
  '23(1)':'you all (3+)',
  '33(1)':'they all (3+)',
  '43(1)':'their own (3+)',
  '11(2)':'me',
  '21(2)':'you',
  '31-1(2)':'him',
  '31-2(2)':'her',
  '31-3(2)':'it',
  '41(2)':'its own',
  '12(2)':'the two of us',
  '22(2)':'the two of you',
  '32(2)':'the two of them',
  '42(2)':'their own (two)',
  '13(2)':'us all (3+)',
  '23(2)':'you all (3+)',
  '33(2)':'them all (3+)',
  '43(2)':'their own (3+)',
  '11(3)':'my',
  '21(3)':'your',
  '31-1(3)':'his',
  '31-2(3)':'her',
  '31-3(3)':'its',
  '41(3)':'its own',
  '12(3)':'our (two)',
  '22(3)':'your (two)',
  '32(3)':'their (two)',
  '42(3)':'their own (two)',
  '13(3)':'our (3+)',
  '23(3)':'your (3+)',
  '33(3)':'their (3+)',
  '43(3)':'their own (3+)'}
;

export const retrieveReflexiveSubjectPronoun =
{
  'self':
  {
  's11(1)':'myself',
  's21(1)':'yourself',
  's31-1(1)':'himself',
  's31-2(1)':'herself',
  's31-3(1)':'itself',
  // '41(1)':'its own',
  's12(1)':'ourselves',
  's22(1)':'yourselves',
  's32(1)':'themselves',
  // '42(1)':'their own (two)',
  's13(1)':'ourselves',
  's23(1)':'yourselves',
  's33(1)':'themselves',
  },
  'poss':
  {
  's11(1)':'my',
  's21(1)':'your',
  's31-1(1)':'his',
  's31-2(1)':'her',
  's31-3(1)':'its',
  // '41(1)':'its own',
  's12(1)':'our',
  's22(1)':'your',
  's32(1)':'their',
  // '42(1)':'their own (two)',
  's13(1)':'our',
  's23(1)':'your',
  's33(1)':'their',
  },
  'regSub':
  {
  's11(1)':'I',
  's21(1)':'you',
  's31-1(1)':'he',
  's31-2(1)':'she',
  's31-3(1)':'it',
  // '41(1)':'its own',
  's12(1)':'we',
  's22(1)':'you two',
  's32(1)':'they',
  // '42(1)':'their own (two)',
  's13(1)':'we all',
  's23(1)':'you all',
  's33(1)':'they all',
  },
  'regObj':
  {
  's11(1)':'me',
  's21(1)':'you',
  's31-1(1)':'him',
  's31-2(1)':'her',
  's31-3(1)':'it',
  // '41(1)':'its own',
  's12(1)':'the two of us',
  's22(1)':'the two of you',
  's32(1)':'the two of them',
  // '42(1)':'their own (two)',
  's13(1)':'us all',
  's23(1)':'you all',
  's33(1)':'them all',
  },
};



// export const retrieveReflexiveSubjectPronounSelf =
//   {
//   's11(1)':'myself',
//   's21(1)':'yourself',
//   's31-1(1)':'himself',
//   's31-2(1)':'herself',
//   's31-3(1)':'itself',
//   // '41(1)':'its own',
//   's12(1)':'ourselves',
//   's22(1)':'yourselves',
//   's32(1)':'themselves',
//   // '42(1)':'their own (two)',
//   's13(1)':'ourselves',
//   's23(1)':'yourselves',
//   's33(1)':'themselves',
//   // '43(1)':'their own (3+)'
// }
// ;
export const NNpostbases = {
    "0": {
        "description": "little piece of", 
        "require": "singularize", 
        "pluralDefinition": "little pieces of", 
        "exp_display": "\u2013ar(ar*)", 
        "exp": "\u2013ar(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "little piece of"
    }, 
    "1": {
        "description": "with a small", 
        "require": "singularize", 
        "pluralDefinition": "with a small", 
        "exp_display": "\u2013cengar*", 
        "exp": "\u2013cengar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "with a small"
    }, 
    "2": {
        "description": "worthless", 
        "require": "", 
        "pluralDefinition": "worthless", 
        "exp_display": "\u2013ciller", 
        "exp": "\u2013ciller[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "worthless"
    }, 
    "3": {
        "description": "small", 
        "require": "", 
        "pluralDefinition": "small", 
        "exp_display": "\u2013cuar(ar*)", 
        "exp": "\u2013cuar(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "small"
    }, 
    "4": {
        "description": "unpleasing", 
        "require": "", 
        "pluralDefinition": "unpleasing", 
        "exp_display": "\u2013cug", 
        "exp": "\u2013cug[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "unpleasing"
    }, 
    "5": {
        "description": "cute little", 
        "require": "", 
        "pluralDefinition": "cute little", 
        "exp_display": "\u2013cungar", 
        "exp": "\u2013cungar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "cute little"
    }, 
    "6": {
        "description": "mere (and nothing more)", 
        "require": "", 
        "pluralDefinition": "mere (and nothing more)", 
        "exp_display": "%:(ng)inar*", 
        "exp": "%:(ng)inar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "mere (and nothing more)"
    }, 
    "8": {
        "description": "late (deceased)", 
        "require": "", 
        "pluralDefinition": "late (deceased)", 
        "exp_display": "%:(ng)i%:rute", 
        "exp": "%:(ng)i%:rute[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "late (deceased)"
    }, 
    "9": {
        "description": "little bit of", 
        "require": "", 
        "pluralDefinition": "little bits of", 
        "exp_display": "\u2013kainer", 
        "exp": "\u2013kainer[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "little bit of"
    }, 
    "10": {
        "description": "future", 
        "require": "", 
        "pluralDefinition": "future", 
        "exp_display": "+kar", 
        "exp": "+kar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "future"
    }, 
    "11": {
        "description": "small", 
        "require": "", 
        "pluralDefinition": "small", 
        "exp_display": "@\u2075kar(ar*)", 
        "exp": "@kar(ar*)1[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "small"
    }, 
    "12": {
        "description": "thing that looks like", 
        "require": "pluralize", 
        "pluralDefinition": "things that looks like", 
        "exp_display": "\u2013kcag", 
        "exp": "\u2013kcag[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "thing that looks like"
    }, 
    "13": {
        "description": "small", 
        "require": "", 
        "pluralDefinition": "small", 
        "exp_display": "\u2013kcuar(ar*)", 
        "exp": "\u2013kcuar(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "small"
    }, 
    "14": {
        "description": "good", 
        "require": "", 
        "pluralDefinition": "good", 
        "exp_display": "\u2013k\u0332egtaar(ar*)", 
        "exp": "\u2013kegtaar(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "good"
    }, 
    "15": {
        "description": "good", 
        "require": "", 
        "pluralDefinition": "good", 
        "exp_display": "\u2013kegtaar(ar*)", 
        "exp": "\u2013kegtaar(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "good"
    }, 
    "16": {
        "description": "very ugly", 
        "require": "", 
        "pluralDefinition": "very ugly", 
        "exp_display": "@\u2075\u2013ksagar", 
        "exp": "@\u2013ksagar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "very ugly"
    }, 
    "17": {
        "description": "small", 
        "require": "", 
        "pluralDefinition": "small", 
        "exp_display": "@\u2075ksuar(ar*)", 
        "exp": "@ksuar(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "small"
    }, 
    "18": {
        "description": "leftover", 
        "require": "", 
        "pluralDefinition": "leftover", 
        "exp_display": "+kuar", 
        "exp": "+kuar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "leftover"
    }, 
    "19": {
        "description": "of the same kind as", 
        "require": "pluralize", 
        "pluralDefinition": "of the same kind as", 
        "exp_display": "\u2013kucir", 
        "exp": "\u2013kucir[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "of the same kind as"
    }, 
    "20": {
        "description": "small amount of", 
        "require": "singularize", 
        "pluralDefinition": "small amounts of", 
        "exp_display": "\u2013kuiner(ar*)", 
        "exp": "\u2013kuiner(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "small amount of"
    }, 
    "21": {
        "description": "small amount of", 
        "require": "singularize", 
        "pluralDefinition": "small amounts of", 
        "exp_display": "\u2013kuinr(ar*)", 
        "exp": "\u2013kuinr(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "small amount of"
    }, 
    "22": {
        "description": "small amount of", 
        "require": "singularize", 
        "pluralDefinition": "small amounts of", 
        "exp_display": "\u2013kuiner", 
        "exp": "\u2013kuiner[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "small amount of"
    }, 
    "23": {
        "description": "thing to be used as one would with", 
        "require": "pluralize", 
        "pluralDefinition": "things to be used as one would with", 
        "exp_display": "\u2013k\u0332utar", 
        "exp": "\u2013kutar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "thing to be used as one would with"
    }, 
    "24": {
        "description": "thing to be used as one would with", 
        "require": "pluralize", 
        "pluralDefinition": "things to be used as one would with", 
        "exp_display": "\u2013kute", 
        "exp": "\u2013kute[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "thing to be used as one would with"
    }, 
    "25": {
        "description": "small bit of", 
        "require": "singularize", 
        "pluralDefinition": "small bits of", 
        "exp_display": "\u2013kuyug", 
        "exp": "\u2013kuyug[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "small bit of"
    }, 
    "26": {
        "description": "small bit of", 
        "require": "singularize", 
        "pluralDefinition": "small bits of", 
        "exp_display": "\u2013kuyugar", 
        "exp": "\u2013kuyugar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "small bit of"
    }, 
    "27": {
        "description": "with", 
        "require": "pluralize", 
        "pluralDefinition": "with", 
        "exp_display": "\u2013leg", 
        "exp": "\u2013leg[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "with"
    }, 
    "28": {
        "description": "sharer of", 
        "require": "pluralize", 
        "pluralDefinition": "sharers of", 
        "exp_display": "\u2013lgute", 
        "exp": "\u2013lgute[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "sharer of"
    }, 
    "29": {
        "description": "similar to", 
        "require": "pluralize", 
        "pluralDefinition": "similar to", 
        "exp_display": "+li", 
        "exp": "+li1[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "similar to"
    }, 
    "30": {
        "description": "similar to", 
        "require": "pluralize", 
        "pluralDefinition": "similar to", 
        "exp_display": "+lir", 
        "exp": "+lir[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "similar to"
    }, 
    "31": {
        "description": "made", 
        "require": "", 
        "pluralDefinition": "made", 
        "exp_display": "\u2013\u2013liar", 
        "exp": "\u2013\u2013liar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "made"
    }, 
    "32": {
        "description": "product of", 
        "require": "singularize", 
        "pluralDefinition": "products of", 
        "exp_display": "\u2013\u2013linrar*", 
        "exp": "\u2013\u2013linrar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "product of"
    }, 
    "33": {
        "description": "product of", 
        "require": "singularize", 
        "pluralDefinition": "products of", 
        "exp_display": "\u2013\u2013linr(ar*)", 
        "exp": "\u2013\u2013linr(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "product of"
    }, 
    "34": {
        "description": "no-good", 
        "require": "", 
        "pluralDefinition": "no-good", 
        "exp_display": "\u2013lkug", 
        "exp": "\u2013lkug[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "no-good"
    }, 
    "35": {
        "description": "(with reference to the past)", 
        "require": "", 
        "pluralDefinition": "", 
        "exp_display": "\u2013llar*", 
        "exp": "\u2013llar*[N\u2192N]", 
        "postDefinition": "(with reference to the past)", 
        "singularDefinition": ""
    }, 
    "36": {
        "description": "former", 
        "require": "", 
        "pluralDefinition": "former", 
        "exp_display": "\u2013ller", 
        "exp": "\u2013ller1[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "former"
    }, 
    "37": {
        "description": "shabby old", 
        "require": "", 
        "pluralDefinition": "shabby old", 
        "exp_display": "\u2013ller(ar*)", 
        "exp": "\u2013ller(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "shabby old"
    }, 
    "39": {
        "description": "bad", 
        "require": "", 
        "pluralDefinition": "bad", 
        "exp_display": "@\u2075\u2013llug", 
        "exp": "@\u2013llug[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "bad"
    }, 
    "40": {
        "description": "old broken piece of", 
        "require": "singularize", 
        "pluralDefinition": "old broken pieces of", 
        "exp_display": "\u2013lqur", 
        "exp": "\u2013lqur[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "old broken piece of"
    }, 
    "41": {
        "description": "good", 
        "require": "", 
        "pluralDefinition": "good", 
        "exp_display": "\u2013luatar", 
        "exp": "\u2013luatar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "good"
    }, 
    "42": {
        "description": "original", 
        "require": "", 
        "pluralDefinition": "original", 
        "exp_display": "\u2013lugpiar", 
        "exp": "\u2013lugpiar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "original"
    }, 
    "44": {
        "description": "thing held in ^one's^", 
        "require": "singularize", 
        "pluralDefinition": "things held in ^one's^", 
        "exp_display": "+mig", 
        "exp": "+mig[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "thing held in ^one's^"
    }, 
    "45": {
        "description": "thing held in ^one's^", 
        "require": "singularize", 
        "pluralDefinition": "things held in ^one's^", 
        "exp_display": "+miar", 
        "exp": "+miar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "thing held in ^one's^"
    }, 
    "46": {
        "description": "inhabitant of", 
        "require": "singularize", 
        "pluralDefinition": "inhabitants of", 
        "exp_display": "~+miu", 
        "exp": "~+miu[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "inhabitant of"
    }, 
    "47": {
        "description": "whose place is", 
        "require": "singularize", 
        "pluralDefinition": "whose place is", 
        "exp_display": "~+miutar*", 
        "exp": "~+miutar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "whose place is"
    }, 
    "49": {
        "description": "area of", 
        "require": "singularize", 
        "pluralDefinition": "area of", 
        "exp_display": "+ner", 
        "exp": "+ner4[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "area of"
    }, 
    "50": {
        "description": "new", 
        "require": "", 
        "pluralDefinition": "new", 
        "exp_display": "\u2013nerrar*", 
        "exp": "\u2013nerrar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "new"
    }, 
    "51": {
        "description": "new", 
        "require": "", 
        "pluralDefinition": "new", 
        "exp_display": "\u2013nerrar(ar*)", 
        "exp": "\u2013nerrar(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "new"
    }, 
    "52": {
        "description": "new", 
        "require": "", 
        "pluralDefinition": "new", 
        "exp_display": "\u2013nerar(ar*)", 
        "exp": "\u2013nerar(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "new"
    }, 
    "53": {
        "description": "good old (but perhaps decrepit)", 
        "require": "", 
        "pluralDefinition": "good old (but perhaps decrepit)", 
        "exp_display": "\u2013ngirta'rrlugar*", 
        "exp": "\u2013ngirta'rrlugar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "good old (but perhaps decrepit)"
    }, 
    "54": {
        "description": "poor quality", 
        "require": "", 
        "pluralDefinition": "poor quality", 
        "exp_display": "\u2013ngnagar", 
        "exp": "\u2013ngnagar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "poor quality"
    }, 
    "55": {
        "description": "secret", 
        "require": "", 
        "pluralDefinition": "secret", 
        "exp_display": "\u2013ngssaar(ar*)", 
        "exp": "\u2013ngssaar(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "secret"
    }, 
    "56": {
        "description": "inauthentic", 
        "require": "", 
        "pluralDefinition": "inauthentic", 
        "exp_display": "\u2013nguar", 
        "exp": "\u2013nguar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "inauthentic"
    }, 
    "57": {
        "description": "old (person)", 
        "require": "", 
        "pluralDefinition": "old (person)", 
        "exp_display": "\u2013ngyaar(ar*)", 
        "exp": "\u2013ngyaar(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "old (person)"
    }, 
    "58": {
        "description": "old (person)", 
        "require": "", 
        "pluralDefinition": "old (person)", 
        "exp_display": "\u2013ngiar(ar*)", 
        "exp": "\u2013ngiar(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "old (person)"
    }, 
    "60": {
        "description": "smell of", 
        "require": "singularize", 
        "pluralDefinition": "smells of", 
        "exp_display": "+nir", 
        "exp": "+nir2[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "smell of"
    }, 
    "61": {
        "description": "big", 
        "require": "", 
        "pluralDefinition": "big", 
        "exp_display": "\u2013paarrlug", 
        "exp": "\u2013paarrlug[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "big"
    }, 
    "62": {
        "description": "genuine", 
        "require": "", 
        "pluralDefinition": "genuine", 
        "exp_display": "\u2013pig", 
        "exp": "\u2013pig1[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "genuine"
    }, 
    "63": {
        "description": "genuine", 
        "require": "", 
        "pluralDefinition": "genuine", 
        "exp_display": "\u2013piar", 
        "exp": "\u2013piar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "genuine"
    }, 
    "64": {
        "description": "genuine", 
        "require": "", 
        "pluralDefinition": "genuine", 
        "exp_display": "\u2013pigar", 
        "exp": "\u2013pigar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "genuine"
    }, 
    "65": {
        "description": "mere", 
        "require": "", 
        "pluralDefinition": "mere", 
        "exp_display": "\u2013q\u0332ainar", 
        "exp": "\u2013qainar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "mere"
    }, 
    "69": {
        "description": "weak helpless", 
        "require": "", 
        "pluralDefinition": "weak helpless", 
        "exp_display": "\u2013q\u0332tar*", 
        "exp": "\u2013qtar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "weak helpless"
    }, 
    "70": {
        "description": "area far in the direction of", 
        "require": "singularize", 
        "pluralDefinition": "areas far in the direction of", 
        "exp_display": "\u2013q\u0332va", 
        "exp": "\u2013qva[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "area far in the direction of"
    }, 
    "71": {
        "description": "area far in the direction of", 
        "require": "singularize", 
        "pluralDefinition": "areas far in the direction of", 
        "exp_display": "\u2013q\u0332vaar*", 
        "exp": "\u2013qvaar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "area far in the direction of"
    }, 
    "72": {
        "description": "multitude of", 
        "require": "pluralize", 
        "pluralDefinition": "multitudes of", 
        "exp_display": "\u2013r\u0332'aya'ar", 
        "exp": "\u2013r'aya'ar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "multitude of"
    }, 
    "73": {
        "description": "great", 
        "require": "", 
        "pluralDefinition": "great", 
        "exp_display": "\u2013r\u0332paa(ar*)", 
        "exp": "\u2013rpaa(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "great"
    }, 
    "74": {
        "description": "large", 
        "require": "", 
        "pluralDefinition": "large", 
        "exp_display": "\u2013r\u0332pag|@\u00b2vag", 
        "exp": "\u2013rpag|@vag[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "large"
    }, 
    "75": {
        "description": "very large", 
        "require": "", 
        "pluralDefinition": "very large", 
        "exp_display": "\u2013r\u0332pallr(ar*)", 
        "exp": "\u2013rpallr(ar*)[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "very large"
    }, 
    "79": {
        "description": "little bit of", 
        "require": "singularize", 
        "pluralDefinition": "little bits of", 
        "exp_display": "\u2013r\u0332r\u0332ar*", 
        "exp": "\u2013rrar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "little bit of"
    }, 
    "80": {
        "description": "area with nothing but", 
        "require": "pluralize", 
        "pluralDefinition": "areas with nothing but", 
        "exp_display": "\u2013r\u0332r\u0332lainar*", 
        "exp": "\u2013rrlainar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "area with nothing but"
    }, 
    "81": {
        "description": "good old", 
        "require": "", 
        "pluralDefinition": "good old", 
        "exp_display": "\u2013r\u0332r\u0332lugar*", 
        "exp": "\u2013rrlugar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "good old"
    }, 
    "82": {
        "description": "that departed from a natural state (often undesirably)", 
        "require": "", 
        "pluralDefinition": "", 
        "exp_display": "\u2013r\u0332r\u0332lug", 
        "exp": "\u2013rrlug[N\u2192N]", 
        "postDefinition": "that departed from a natural state (often undesirably)", 
        "singularDefinition": ""
    }, 
    "83": {
        "description": "multitudes of", 
        "require": "pluralize", 
        "pluralDefinition": "multitudes of", 
        "exp_display": "\u2013r\u0332ugar*", 
        "exp": "\u2013rugar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "multitudes of"
    }, 
    "84": {
        "description": "poor dear", 
        "require": "", 
        "pluralDefinition": "poor dear", 
        "exp_display": "\u2013r\u0332(ur)lur*", 
        "exp": "\u2013r(ur)lur*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "poor dear"
    }, 
    "85": {
        "description": "old", 
        "require": "", 
        "pluralDefinition": "old", 
        "exp_display": "\u2013ssaarar", 
        "exp": "\u2013ssaarar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "old"
    }, 
    "86": {
        "description": "place having", 
        "require": "pluralize", 
        "pluralDefinition": "places having", 
        "exp_display": "+taleg", 
        "exp": "+taleg[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "place having"
    }, 
    "87": {
        "description": "thing pertaining to", 
        "require": "pluralize", 
        "pluralDefinition": "things pertaining to", 
        "exp_display": "+tar", 
        "exp": "+tar2[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "thing pertaining to"
    }, 
    "88": {
        "description": "caught (game animal)", 
        "require": "", 
        "pluralDefinition": "caught (game animals)", 
        "exp_display": "+tar", 
        "exp": "+tar3[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "caught (game animal)"
    }, 
    "90": {
        "description": "specifically", 
        "require": "", 
        "pluralDefinition": "", 
        "exp_display": "+tar", 
        "exp": "+tar5[N\u2192N]", 
        "postDefinition": "specifically", 
        "singularDefinition": ""
    }, 
    "91": {
        "description": "well endowed with", 
        "require": "pluralize", 
        "pluralDefinition": "well endowed with", 
        "exp_display": "+tuli", 
        "exp": "+tuli[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "well endowed with"
    }, 
    "92": {
        "description": "imitation", 
        "require": "", 
        "pluralDefinition": "imitation", 
        "exp_display": "+(ng)uar", 
        "exp": "+(ng)uar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "imitation"
    }, 
    "93": {
        "description": "supply of", 
        "require": "pluralize", 
        "pluralDefinition": "supplies of", 
        "exp_display": "%:(ng)ute", 
        "exp": "%:(ng)ute[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "supply of"
    }, 
    "94": {
        "description": "supply of", 
        "require": "pluralize", 
        "pluralDefinition": "supplies of", 
        "exp_display": "%:~(ng)ute", 
        "exp": "%:~(ng)ute[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "supply of"
    }, 
    "95": {
        "description": "empty container that held", 
        "require": "pluralize", 
        "pluralDefinition": "empty containers that held", 
        "exp_display": "%:(ng)uteller", 
        "exp": "%:(ng)uteller[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "empty container that held"
    }, 
    "96": {
        "description": "empty container that held", 
        "require": "pluralize", 
        "pluralDefinition": "empty containers that held", 
        "exp_display": "%:~(ng)uteller", 
        "exp": "%:~(ng)uteller[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "empty container that held"
    }, 
    "97": {
        "description": "big", 
        "require": "", 
        "pluralDefinition": "big", 
        "exp_display": "\u2013vaarrlug", 
        "exp": "\u2013vaarrlug[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "big"
    }, 
    "98": {
        "description": "shabby", 
        "require": "", 
        "pluralDefinition": "shabby", 
        "exp_display": "\u2013vialug", 
        "exp": "\u2013vialug[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "shabby"
    }, 
    "99": {
        "description": "container for", 
        "require": "pluralize", 
        "pluralDefinition": "containers for", 
        "exp_display": "@\u00b2~+viutar", 
        "exp": "@~+viutar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "container for"
    }, 
    "100": {
        "description": "baby or little", 
        "require": "", 
        "pluralDefinition": "baby or little", 
        "exp_display": "\u2013ya\u0121ar*", 
        "exp": "\u2013ya(g)ar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "baby or little"
    }, 
    "101": {
        "description": "baby or little", 
        "require": "", 
        "pluralDefinition": "baby or little", 
        "exp_display": "\u2013yagar*", 
        "exp": "\u2013yagar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "baby or little"
    }, 
    "102": {
        "description": "thing similar to", 
        "require": "pluralize", 
        "pluralDefinition": "things similar to", 
        "exp_display": "+yag", 
        "exp": "+yag[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "thing similar to"
    }, 
    "103": {
        "description": "way of or device dealing with", 
        "require": "pluralize", 
        "pluralDefinition": "ways of or devices dealing with", 
        "exp_display": "@\u02b8~+yarar", 
        "exp": "@~+yarar[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "way of or device dealing with"
    }, 
    "104": {
        "description": "little baby", 
        "require": "", 
        "pluralDefinition": "little baby", 
        "exp_display": "\u2013yaya\u0121ar*", 
        "exp": "\u2013yaya(g)ar*[N\u2192N]", 
        "postDefinition": "", 
        "singularDefinition": "little baby"
    }
}
export const VVpostbases = {
    "0": {
        "match_case": true, 
        "exp_display": "+a|+aar", 
        "description": "repeatedly", 
        "exp": "\u2013a|\u2013ar|\u2013aa|+a|+aar[V\u2192V]", 
        "postverb": "repeatedly"
    }, 
    "1": {
        "description": "repeatedly", 
        "ger_preverb": "repeatedly", 
        "is": true, 
        "inf_preverb": "repeatedly", 
        "past_preverb": "repeatedly", 
        "exp_display": "+`(g)aqe", 
        "gen_preverb": "repeatedly", 
        "exp": "+`(g)aqe[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "2": {
        "description": "just barely", 
        "ger_preverb": "just barely", 
        "is": true, 
        "inf_preverb": "just barely", 
        "past_preverb": "just barely", 
        "exp_display": "+`(g)ar(ar)", 
        "gen_preverb": "just barely", 
        "exp": "+`(g)ar(ar)[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "3": {
        "description": "suddenly", 
        "ger_preverb": "suddenly", 
        "is": true, 
        "inf_preverb": "suddenly", 
        "past_preverb": "suddenly", 
        "exp_display": "@+\u2013`(g)ar(ar)te", 
        "gen_preverb": "suddenly", 
        "exp": "@+(g)ar(ar)te1[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "5": {
        "description": "will eventually", 
        "ger_preverb": "will eventually", 
        "is": false, 
        "inf_preverb": "will eventually", 
        "past_preverb": "will eventually", 
        "exp_display": "+`(g)arkau", 
        "gen_preverb": "will eventually", 
        "exp": "+`(g)arkau[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "6": {
        "description": "now unable to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be now unable to", 
        "past_preverb": "", 
        "exp_display": "+`(g)arkaunrir", 
        "gen_preverb": "now unable to", 
        "exp": "+`(g)arkaunrir[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being able to now", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "7": {
        "description": "continuing (over a period of time) to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "continue (over a period of time) to", 
        "past_preverb": "", 
        "exp_display": "+aur(ar)", 
        "gen_preverb": "continuing (over a period of time) to", 
        "exp": "+aur(ar)[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "continuing (over a period of time) to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "8": {
        "description": "endeavoring to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "endeavor to", 
        "past_preverb": "", 
        "exp_display": "@\u2074~+caar(ar)", 
        "gen_preverb": "endeavoring to", 
        "exp": "@~+caar(ar)[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "endeavoring to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "13": {
        "description": "no longer able to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be no longer able to", 
        "past_preverb": "", 
        "exp_display": "+(s)ciigali", 
        "gen_preverb": "no longer able to", 
        "exp": "+(s)ciigali[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being no longer able to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "14": {
        "description": "no longer able to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be no longer able to", 
        "past_preverb": "", 
        "exp_display": "+(s)ciigalli", 
        "gen_preverb": "no longer able to", 
        "exp": "+(s)ciigalli[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being no longer able to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "15": {
        "description": "not able to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be not able to", 
        "past_preverb": "", 
        "exp_display": "+(s)ciigate\u00b0", 
        "gen_preverb": "not able to", 
        "exp": "+(s)ciigate[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being not able to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "18": {
        "description": "appears to have been", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": false, 
        "inf_preverb": "appear to have been", 
        "past_preverb": "appeared to have been", 
        "exp_display": "\u2013cilli", 
        "gen_preverb": "appears to have been", 
        "exp": "\u2013cilli[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "appearing to have been", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "19": {
        "description": "will", 
        "ger_preverb": "will", 
        "is": false, 
        "inf_preverb": "will", 
        "past_preverb": "will", 
        "exp_display": "+ciqe|@\u2075ciiqe", 
        "gen_preverb": "will", 
        "exp": "+ciqe|@ciiqe[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "20": {
        "description": "about to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be about to", 
        "past_preverb": "", 
        "exp_display": "+ciqiar|@\u2075ciiqiar", 
        "gen_preverb": "about to", 
        "exp": "+ciqiar|@ciiqiar[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being about to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "22": {
        "description": "", 
        "past_preverb_after": "", 
        "ger_preverb_after": "g", 
        "is": false, 
        "inf_preverb": "", 
        "past_preverb": "", 
        "exp_display": "@\u2075~+cir", 
        "gen_preverb": "", 
        "exp": "@~+cir1[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "", 
        "subj": "", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": ""
    }, 
    "24": {
        "description": "easily", 
        "past_preverb_after": "", 
        "ger_preverb_after": "i", 
        "is": false, 
        "inf_preverb": "be easily", 
        "past_preverb": "", 
        "exp_display": "+(s)ciryar", 
        "gen_preverb": "easily", 
        "exp": "+(s)ciryar[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being easy to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": ""
    }, 
    "27": {
        "description": "has the quality of", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": false, 
        "inf_preverb": "have the quality of", 
        "past_preverb": "had the quality of", 
        "exp_display": "+cite\u00b0", 
        "gen_preverb": "has the quality of", 
        "exp": "+cite2[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "having the quality of", 
        "subj": "it", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "31": {
        "match_case": true, 
        "exp_display": "\u2013curlag", 
        "description": "with unsatisfactory results", 
        "exp": "\u2013curlag[V\u2192V]", 
        "postverb": "with unsatisfactory results"
    }, 
    "34": {
        "match_case": true, 
        "exp_display": "@\u00b2~+(ng)iinar", 
        "description": "more and more", 
        "exp": "@~+(ng)iinar[V\u2192V]", 
        "postverb": "more and more"
    }, 
    "35": {
        "description": "suffering from the lack of", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "suffer from the lack of", 
        "past_preverb": "", 
        "exp_display": "%:(ng)illiqe", 
        "gen_preverb": "suffering from the lack of", 
        "exp": "%:(ng)illiqe[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "suffering from the lack of", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "36": {
        "description": "finally", 
        "ger_preverb": "finally", 
        "is": true, 
        "inf_preverb": "finally", 
        "past_preverb": "finally", 
        "exp_display": "\u2013inar", 
        "gen_preverb": "finally", 
        "exp": "\u2013inar[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "39": {
        "description": "lacks", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": false, 
        "inf_preverb": "lack", 
        "past_preverb": "lacked", 
        "exp_display": "%:(ng)ite\u00b0", 
        "gen_preverb": "lacks", 
        "exp": "%:(ng)ite1[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "lacking", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "44": {
        "match_case": true, 
        "exp_display": "+kanir", 
        "description": "more with greater intensity", 
        "exp": "+kanir[V\u2192V]", 
        "postverb": "more with greater intensity"
    }, 
    "45": {
        "match_case": true, 
        "exp_display": "+kanir(ar)", 
        "description": "more and more, with greater intensity", 
        "exp": "+kanir(ar)[V\u2192V]", 
        "postverb": "more and more, with greater intensity"
    }, 
    "46": {
        "description": "unable to (due to an inhibiting factor)", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be unable to (due to an inhibiting factor)", 
        "past_preverb": "", 
        "exp_display": "\u2013@\u2074k\u0332aunrir", 
        "gen_preverb": "unable to (due to an inhibiting factor)", 
        "exp": "\u2013@kaunrir[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being unable to (due to an inhibiting factor)", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "51": {
        "description": "suddenly (in motion)", 
        "ger_preverb": "suddenly (in motion)", 
        "is": true, 
        "inf_preverb": "suddenly (in motion)", 
        "past_preverb": "suddenly (in motion)", 
        "exp_display": "\u2013knig", 
        "gen_preverb": "suddenly (in motion)", 
        "exp": "\u2013knig[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "52": {
        "match_case": true, 
        "exp_display": "\u2013ksaar(ar)", 
        "description": "in a small and unnoticeable way", 
        "exp": "\u2013ksaar(ar)[V\u2192V]", 
        "postverb": "in a small and unnoticeable way"
    }, 
    "56": {
        "match_case": true, 
        "exp_display": "\u2013k\u0332suar(ar)", 
        "description": "in a small and not very noticeable way", 
        "exp": "\u2013ksuar(ar)[V\u2192V]", 
        "postverb": "in a small and not very noticeable way"
    }, 
    "57": {
        "match_case": true, 
        "exp_display": "\u2013ksuar(ar)", 
        "description": "in a small and not very noticeable way", 
        "exp": "\u2013ksuar(ar)[V\u2192V]", 
        "postverb": "in a small and not very noticeable way"
    }, 
    "58": {
        "description": "about to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be about to", 
        "past_preverb": "", 
        "exp_display": "\u2013kugte", 
        "gen_preverb": "about to", 
        "exp": "\u2013kugte[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being about to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "59": {
        "description": "planning to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "plan to", 
        "past_preverb": "", 
        "exp_display": "\u2013kuna", 
        "gen_preverb": "planning to", 
        "exp": "\u2013kuna[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "planning to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "60": {
        "description": "considering", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "consider", 
        "past_preverb": "", 
        "exp_display": "\u2013kunayaaqe", 
        "gen_preverb": "considering", 
        "exp": "\u2013kunayaaqe[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "considering", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "61": {
        "description": "probably", 
        "ger_preverb": "probably", 
        "is": false, 
        "inf_preverb": "probably", 
        "past_preverb": "probably", 
        "exp_display": "\u2013kutag", 
        "gen_preverb": "probably", 
        "exp": "\u2013kutag[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "62": {
        "description": "planning to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "plan to", 
        "past_preverb": "", 
        "exp_display": "\u2013kutar(ar)", 
        "gen_preverb": "planning to", 
        "exp": "\u2013kutar(ar)[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "planning to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "63": {
        "match_case": true, 
        "exp_display": "\u2013laag", 
        "description": "quickly", 
        "exp": "\u2013laag[V\u2192V]", 
        "postverb": "quickly"
    }, 
    "67": {
        "match_case": true, 
        "exp_display": "~+lar", 
        "description": "regularly", 
        "exp": "~+lar[V\u2192V]", 
        "postverb": "regularly"
    }, 
    "68": {
        "match_case": true, 
        "exp_display": "@\u02e1~+lar", 
        "description": "regularly", 
        "exp": "@~+lar[V\u2192V]", 
        "postverb": "regularly"
    }, 
    "69": {
        "match_case": true, 
        "exp_display": "\u2013lar", 
        "description": "regularly", 
        "exp": "\u2013lar[V\u2192V]", 
        "postverb": "regularly"
    }, 
    "70": {
        "description": "usually (though not at this time)", 
        "ger_preverb": "usually (though not at this time)", 
        "is": true, 
        "inf_preverb": "usually (though not at this time)", 
        "past_preverb": "usually (though not at this time)", 
        "exp_display": "~+laryaaqe", 
        "gen_preverb": "usually (though not at this time)", 
        "exp": "~+laryaaqe[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "71": {
        "description": "usually (though not at this time)", 
        "ger_preverb": "usually (though not at this time)", 
        "is": true, 
        "inf_preverb": "usually (though not at this time)", 
        "past_preverb": "usually (though not at this time)", 
        "exp_display": "@\u02e1~+laryaaqe", 
        "gen_preverb": "usually (though not at this time)", 
        "exp": "@~+laryaaqe[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "72": {
        "description": "usually (though not at this time)", 
        "ger_preverb": "usually (though not at this time)", 
        "is": true, 
        "inf_preverb": "usually (though not at this time)", 
        "past_preverb": "usually (though not at this time)", 
        "exp_display": "\u2013laryaaqe", 
        "gen_preverb": "usually (though not at this time)", 
        "exp": "\u2013laryaaqe[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "73": {
        "match_case": true, 
        "exp_display": "\u2013ler", 
        "description": "suddenly and willfully", 
        "exp": "\u2013ler[V\u2192V]", 
        "postverb": "suddenly and willfully"
    }, 
    "74": {
        "match_case": true, 
        "exp_display": "~+ler", 
        "description": "suddenly and willfully", 
        "exp": "~+ler[V\u2192V]", 
        "postverb": "suddenly and willfully"
    }, 
    "75": {
        "match_case": true, 
        "exp_display": "\u2013leryag", 
        "description": "abruptly", 
        "exp": "\u2013leryag[V\u2192V]", 
        "postverb": "abruptly"
    }, 
    "76": {
        "match_case": true, 
        "exp_display": "~+leryag", 
        "description": "abruptly", 
        "exp": "~+leryag[V\u2192V]", 
        "postverb": "abruptly"
    }, 
    "77": {
        "description": "always", 
        "ger_preverb": "always", 
        "is": true, 
        "inf_preverb": "always", 
        "past_preverb": "always", 
        "exp_display": "\u2013lgu", 
        "gen_preverb": "always", 
        "exp": "\u2013lgu[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "78": {
        "description": "stopped being able to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": false, 
        "inf_preverb": "have stopped being able to", 
        "past_preverb": "had stopped being able to", 
        "exp_display": "\u2013lguir", 
        "gen_preverb": "stopped being able to", 
        "exp": "\u2013lguir[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "having stopped being able to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "79": {
        "description": "no longer able to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be no longer able to", 
        "past_preverb": "", 
        "exp_display": "\u2013lguirute", 
        "gen_preverb": "no longer able to", 
        "exp": "\u2013lguirute[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being no longer able to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "80": {
        "description": "unable to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be unable to", 
        "past_preverb": "", 
        "exp_display": "\u2013lguite\u00b0", 
        "gen_preverb": "unable to", 
        "exp": "\u2013lguite[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being unable to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "83": {
        "description": "going to participate in", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "go participate in", 
        "past_preverb": "", 
        "exp_display": "\u2013\u2013liyar", 
        "gen_preverb": "going to participate in", 
        "exp": "\u2013\u2013liyar[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "going to participate in", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "84": {
        "description": "going to participate in", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "go participate in", 
        "past_preverb": "", 
        "exp_display": "\u2013liar", 
        "gen_preverb": "going to participate in", 
        "exp": "\u2013liar[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "going to participate in", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "86": {
        "description": "giving evidence of", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "give evidence of", 
        "past_preverb": "", 
        "exp_display": "\u2013lkia", 
        "gen_preverb": "giving evidence of", 
        "exp": "\u2013lkia[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "giving evidence of", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "88": {
        "match_case": true, 
        "exp_display": "\u2013llag", 
        "description": "suddenly and surprisingly", 
        "exp": "\u2013llag[V\u2192V]", 
        "postverb": "suddenly and surprisingly"
    }, 
    "89": {
        "description": "good at", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "be good at", 
        "past_preverb": "", 
        "exp_display": "\u2013llgu", 
        "gen_preverb": "good at", 
        "exp": "\u2013llgu[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being good at", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "90": {
        "description": "maybe", 
        "ger_preverb": "maybe", 
        "is": true, 
        "inf_preverb": "maybe", 
        "past_preverb": "maybe", 
        "exp_display": "\u2013lli", 
        "gen_preverb": "maybe", 
        "exp": "\u2013lli[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "91": {
        "match_case": true, 
        "exp_display": "\u2013llini", 
        "description": "evidently", 
        "exp": "\u2013llini[V\u2192V]", 
        "postverb": "evidently"
    }, 
    "96": {
        "match_case": true, 
        "exp_display": "\u2013llugtur", 
        "description": "quickly", 
        "exp": "\u2013llugtur[V\u2192V]", 
        "postverb": "quickly"
    }, 
    "97": {
        "description": "tired of", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "be tired of", 
        "past_preverb": "", 
        "exp_display": "\u2013lngu", 
        "gen_preverb": "tired of", 
        "exp": "\u2013lngu[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being tired of", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "99": {
        "match_case": true, 
        "exp_display": "\u2013luaqar", 
        "description": "well", 
        "exp": "\u2013luaqar[V\u2192V]", 
        "postverb": "well"
    }, 
    "101": {
        "match_case": true, 
        "exp_display": "%:(u|i)maar", 
        "description": "for a short duration or without making a big deal of it", 
        "exp": "%:(u|i)maar[V\u2192V]", 
        "postverb": "for a short duration or without making a big deal of it"
    }, 
    "102": {
        "match_case": true, 
        "exp_display": "%:(u|i)maar(ar)", 
        "description": "slowly", 
        "exp": "%:(u|i)maar(ar)[V\u2192V]", 
        "postverb": "slowly"
    }, 
    "104": {
        "match_case": true, 
        "exp_display": "\u2013mcaugar", 
        "description": "in a small way", 
        "exp": "\u2013mcaugar[V\u2192V]", 
        "postverb": "in a small way"
    }, 
    "105": {
        "match_case": true, 
        "exp_display": "\u2013mciur(ar)", 
        "description": "a little at a time", 
        "exp": "\u2013mciur(ar)[V\u2192V]", 
        "postverb": "a little at a time"
    }, 
    "106": {
        "match_case": true, 
        "exp_display": "\u2013mcuar(ar)", 
        "description": "a little", 
        "exp": "\u2013mcuar(ar)[V\u2192V]", 
        "postverb": "a little"
    }, 
    "107": {
        "match_case": true, 
        "exp_display": "\u2013mcugte", 
        "description": "to a small degree", 
        "exp": "\u2013mcugte[V\u2192V]", 
        "postverb": "to a small degree"
    }, 
    "108": {
        "match_case": true, 
        "exp_display": "\u2013mssugte", 
        "description": "to a small degree", 
        "exp": "\u2013mssugte[V\u2192V]", 
        "postverb": "to a small degree"
    }, 
    "109": {
        "match_case": true, 
        "exp_display": "\u2013mcugte", 
        "description": "to a small degree", 
        "exp": "\u2013mcugte[V\u2192V]", 
        "postverb": "to a small degree"
    }, 
    "110": {
        "match_case": true, 
        "exp_display": "@\u00b2~+mi", 
        "description": "also", 
        "exp": "@~+mi[V\u2192V]", 
        "postverb": "also"
    }, 
    "111": {
        "description": "probably also", 
        "ger_preverb": "probably also", 
        "is": true, 
        "inf_preverb": "probably also", 
        "past_preverb": "probably also", 
        "exp_display": "+milli", 
        "gen_preverb": "probably also", 
        "exp": "+milli[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "112": {
        "match_case": true, 
        "exp_display": "\u2013mli", 
        "description": "casually", 
        "exp": "\u2013mli[V\u2192V]", 
        "postverb": "casually"
    }, 
    "113": {
        "match_case": true, 
        "exp_display": "\u2013mssag", 
        "description": "in a small way", 
        "exp": "\u2013mssag[V\u2192V]", 
        "postverb": "in a small way"
    }, 
    "114": {
        "match_case": true, 
        "exp_display": "\u2013mssugte", 
        "description": "in a small way", 
        "exp": "\u2013mssugte[V\u2192V]", 
        "postverb": "in a small way"
    }, 
    "116": {
        "match_case": true, 
        "exp_display": "\u2013myugte", 
        "description": "in a small way", 
        "exp": "\u2013myugte[V\u2192V]", 
        "postverb": "in a small way"
    }, 
    "118": {
        "match_case": true, 
        "exp_display": "@\u00b9~+naciar", 
        "description": "late", 
        "exp": "@~+naciar[V\u2192V]", 
        "postverb": "late"
    }, 
    "121": {
        "description": "ceasing", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "cease", 
        "past_preverb": "", 
        "exp_display": "@\u00b9~+nanrir", 
        "gen_preverb": "ceasing", 
        "exp": "@~+nanrir[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "ceasing", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "122": {
        "description": "now feasible to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be now feasible to", 
        "past_preverb": "", 
        "exp_display": "@\u00b9~+naqsaaqe", 
        "gen_preverb": "now feasible to", 
        "exp": "@~+naqsaaqe[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being now feasible to", 
        "subj": "it", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "124": {
        "description": "time to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be time to", 
        "past_preverb": "", 
        "exp_display": "@\u00b9~+nari", 
        "gen_preverb": "time to", 
        "exp": "@~+nari[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being time to", 
        "subj": "it", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "127": {
        "description": "habitually", 
        "ger_preverb": "habitually", 
        "is": true, 
        "inf_preverb": "habitually", 
        "past_preverb": "habitually", 
        "exp_display": "@\u00b9~+naur", 
        "gen_preverb": "habitually", 
        "exp": "@~+naur[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "130": {
        "description": "habitually (only a little bit)", 
        "ger_preverb": "habitually (only a little bit)", 
        "is": true, 
        "inf_preverb": "habitually (only a little bit)", 
        "past_preverb": "habitually (only a little bit)", 
        "exp_display": "@\u00b9\u2013nerkite\u00b0", 
        "gen_preverb": "habitually (only a little bit)", 
        "exp": "@\u2013nerkite[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "134": {
        "description": "having trouble with ^his^", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "have trouble with ^his^", 
        "past_preverb": "", 
        "exp_display": "@\u00b9\u2013nerrlugte", 
        "gen_preverb": "having trouble with ^his^", 
        "exp": "@\u2013nerrlugte[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "having trouble with ^his^", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "135": {
        "description": "habitually (a lot)", 
        "ger_preverb": "habitually (a lot)", 
        "is": true, 
        "inf_preverb": "habitually (a lot)", 
        "past_preverb": "habitually (a lot)", 
        "exp_display": "@\u00b9\u2013nertu", 
        "gen_preverb": "habitually (a lot)", 
        "exp": "@\u2013nertu[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "137": {
        "description": "no longer going to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be no longer going to", 
        "past_preverb": "", 
        "exp_display": "@\u00b2~+ngair(ar)te", 
        "gen_preverb": "no longer going to", 
        "exp": "@~+ngair(ar)te[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being no longer going to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "138": {
        "description": "will never again", 
        "ger_preverb": "will never again", 
        "is": false, 
        "inf_preverb": "will never again", 
        "past_preverb": "will never again", 
        "exp_display": "@\u00b2~+ngairute", 
        "gen_preverb": "will never again", 
        "exp": "@~+ngairute[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "139": {
        "description": "will not", 
        "ger_preverb": "will not", 
        "is": false, 
        "inf_preverb": "will not", 
        "past_preverb": "will not", 
        "exp_display": "@\u00b2~+ngaite\u00b0", 
        "gen_preverb": "will not", 
        "exp": "@~+ngaite[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "141": {
        "description": "seems to be", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": false, 
        "inf_preverb": "seem to be", 
        "past_preverb": "seemed to be", 
        "exp_display": "@\u00b2~+ngate\u00b0", 
        "gen_preverb": "seems to be", 
        "exp": "@~+ngate[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "seeming to be", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "143": {
        "description": "beginning to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "begin to", 
        "past_preverb": "", 
        "exp_display": "\u2013nge", 
        "gen_preverb": "beginning to", 
        "exp": "\u2013nge[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "beginning to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "144": {
        "description": "inept at", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "be inept at", 
        "past_preverb": "", 
        "exp_display": "@\u00b2~+ngiate\u00b0", 
        "gen_preverb": "inept at", 
        "exp": "@~+ngiate[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being inept at", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "145": {
        "description": "adept at", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "be adept at", 
        "past_preverb": "", 
        "exp_display": "@\u00b2~+ngig", 
        "gen_preverb": "adept at", 
        "exp": "@~+ngig[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being adept at", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "146": {
        "description": "merely (with no attendant complications)", 
        "ger_preverb": "merely (with no attendant complications)", 
        "is": true, 
        "inf_preverb": "merely (with no attendant complications)", 
        "past_preverb": "merely (with no attendant complications)", 
        "exp_display": "@\u00b2~+nginar", 
        "gen_preverb": "merely (with no attendant complications)", 
        "exp": "@~+nginar[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "147": {
        "match_case": true, 
        "exp_display": "\u2013ngnagar", 
        "description": "in an irritating way", 
        "exp": "\u2013ngnagar[V\u2192V]", 
        "postverb": "in an irritating way"
    }, 
    "148": {
        "description": "trying to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "try to", 
        "past_preverb": "", 
        "exp_display": "\u2013ngnaqe", 
        "gen_preverb": "trying to", 
        "exp": "\u2013ngnaqe[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "trying to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "149": {
        "description": "trying unsuccessfully to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "try unsuccessfully to", 
        "past_preverb": "", 
        "exp_display": "\u2013ngnaqsaaqe", 
        "gen_preverb": "trying unsuccessfully to", 
        "exp": "\u2013ngnaqsaaqe[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "trying unsuccessfully to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "150": {
        "description": "trying hard to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "try hard to", 
        "past_preverb": "", 
        "exp_display": "\u2013ngnatug", 
        "gen_preverb": "trying hard to", 
        "exp": "\u2013ngnatug[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "trying hard to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "151": {
        "description": "in a state of", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "be in a state of", 
        "past_preverb": "", 
        "exp_display": "@\u2075\u2013ngqa", 
        "gen_preverb": "in a state of", 
        "exp": "@\u2013ngqa[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being in a state of", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "152": {
        "match_case": true, 
        "exp_display": "\u2013ngssaar(ar)", 
        "description": "secretively, unnoticeably", 
        "exp": "\u2013ngssaar(ar)[V\u2192V]", 
        "postverb": "secretively, unnoticeably"
    }, 
    "153": {
        "match_case": true, 
        "exp_display": "\u2013ngssag", 
        "description": "to no particular end", 
        "exp": "\u2013ngssag[V\u2192V]", 
        "postverb": "to no particular end"
    }, 
    "154": {
        "match_case": true, 
        "exp_display": "\u2013ngssi", 
        "description": "to no particular end", 
        "exp": "\u2013ngssi[V\u2192V]", 
        "postverb": "to no particular end"
    }, 
    "155": {
        "description": "pretending to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "pretend to", 
        "past_preverb": "", 
        "exp_display": "@\u00b2~\u2013nguar", 
        "gen_preverb": "pretending to", 
        "exp": "@~\u2013nguar[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "pretending to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "158": {
        "match_case": true, 
        "exp_display": "@\u00b9~+niar", 
        "description": "in the future", 
        "exp": "@~+niar[V\u2192V]", 
        "postverb": "in the future"
    }, 
    "159": {
        "description": "soon going to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "soon be going", 
        "past_preverb": "", 
        "exp_display": "@\u00b9~+niarar", 
        "gen_preverb": "soon going to", 
        "exp": "@~+niarar[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "soon being going", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "i"
    }, 
    "166": {
        "match_case": true, 
        "exp_display": "\u2013nqegcaar(ar)", 
        "description": "completely, thoroughly", 
        "exp": "\u2013nqegcaar(ar)[V\u2192V]", 
        "postverb": "completely, thoroughly"
    }, 
    "167": {
        "match_case": true, 
        "exp_display": "\u2013nqigte", 
        "description": "again", 
        "exp": "\u2013nqigte[V\u2192V]", 
        "postverb": "again"
    }, 
    "168": {
        "description": "not (having changed his mind)", 
        "ger_preverb": "not (having changed his mind)", 
        "is": true, 
        "inf_preverb": "not (having changed his mind)", 
        "past_preverb": "not (having changed his mind)", 
        "exp_display": "\u2013nricen\u0304ar", 
        "gen_preverb": "not (having changed his mind)", 
        "exp": "\u2013nricen\u0304ar[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "169": {
        "description": "keeping ^himself^ from", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "keep ^himself^ from", 
        "past_preverb": "", 
        "exp_display": "\u2013nrilkurte", 
        "gen_preverb": "keeping ^himself^ from", 
        "exp": "\u2013nrilkurte[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "keeping ^himself^ from", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "170": {
        "description": "no longer", 
        "ger_preverb": "no longer", 
        "is": true, 
        "inf_preverb": "no longer", 
        "past_preverb": "no longer", 
        "exp_display": "\u2013nrir", 
        "gen_preverb": "no longer", 
        "exp": "\u2013nrir[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "171": {
        "description": "almost", 
        "ger_preverb": "almost", 
        "is": true, 
        "inf_preverb": "almost", 
        "past_preverb": "almost", 
        "exp_display": "\u2013nritar(ar)", 
        "gen_preverb": "almost", 
        "exp": "\u2013nritar(ar)[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "172": {
        "description": "not", 
        "ger_preverb": "not", 
        "is": true, 
        "inf_preverb": "not", 
        "past_preverb": "not", 
        "exp_display": "\u2013nrite\u00b0", 
        "gen_preverb": "not", 
        "exp": "\u2013nrite[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "173": {
        "match_case": true, 
        "exp_display": "\u2013nru", 
        "description": "moreso", 
        "exp": "\u2013nru[V\u2192V]", 
        "postverb": "moreso"
    }, 
    "174": {
        "match_case": true, 
        "exp_display": "@\u2075+p|~vaalug", 
        "description": "for the first time", 
        "exp": "@+paalug|~vaalug[V\u2192V]", 
        "postverb": "for the first time"
    }, 
    "175": {
        "match_case": true, 
        "exp_display": "@\u2075+p|~vailug", 
        "description": "for the first time", 
        "exp": "@+pailug|~vailug[V\u2192V]", 
        "postverb": "for the first time"
    }, 
    "176": {
        "match_case": true, 
        "exp_display": "\u2013pacug", 
        "description": "poorly, dearly", 
        "exp": "\u2013pacug[V\u2192V]", 
        "postverb": "poorly, dearly"
    }, 
    "177": {
        "match_case": true, 
        "exp_display": "@\u2075+p|~vag", 
        "description": "so well", 
        "exp": "@+pag|~vag1[V\u2192V]", 
        "postverb": "so well"
    }, 
    "178": {
        "match_case": true, 
        "exp_display": "@\u2075+p|~vakar", 
        "description": "so much", 
        "exp": "@+pakar|~vakar[V\u2192V]", 
        "postverb": "so much"
    }, 
    "179": {
        "match_case": true, 
        "exp_display": "\u2013qpakar", 
        "description": "so much", 
        "exp": "\u2013qpakar[V\u2192V]", 
        "postverb": "so much"
    }, 
    "180": {
        "match_case": true, 
        "exp_display": "@\u2075+p|~vallag", 
        "description": "intensely", 
        "exp": "@+pallag|~vallag[V\u2192V]", 
        "postverb": "intensely"
    }, 
    "181": {
        "match_case": true, 
        "exp_display": "@\u2075+p|~vallug", 
        "description": "the most", 
        "exp": "@+pallug|~vallug[V\u2192V]", 
        "postverb": "the most"
    }, 
    "182": {
        "match_case": true, 
        "exp_display": "@\u2075+p|~vallur", 
        "description": "the most", 
        "exp": "@+pallur|~vallur[V\u2192V]", 
        "postverb": "the most"
    }, 
    "183": {
        "description": "not", 
        "ger_preverb": "not", 
        "is": true, 
        "inf_preverb": "not", 
        "past_preverb": "not", 
        "exp_display": "+p|.vke\u00b0", 
        "gen_preverb": "not", 
        "exp": "+peke|.vke[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "184": {
        "description": "not", 
        "ger_preverb": "not", 
        "is": true, 
        "inf_preverb": "not", 
        "past_preverb": "not", 
        "exp_display": "+p|.vge\u00b0", 
        "gen_preverb": "not", 
        "exp": "+pege|.vke[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "185": {
        "description": "actually (surprisingly)", 
        "ger_preverb": "actually (surprisingly)", 
        "is": true, 
        "inf_preverb": "actually (surprisingly)", 
        "past_preverb": "actually (surprisingly)", 
        "exp_display": "+pigainar", 
        "gen_preverb": "actually (surprisingly)", 
        "exp": "+pigainar[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "186": {
        "description": "actually (surprisingly)", 
        "ger_preverb": "actually (surprisingly)", 
        "is": true, 
        "inf_preverb": "actually (surprisingly)", 
        "past_preverb": "actually (surprisingly)", 
        "exp_display": "\u2013pigainar", 
        "gen_preverb": "actually (surprisingly)", 
        "exp": "\u2013pigainar[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "187": {
        "description": "really", 
        "ger_preverb": "really", 
        "is": true, 
        "inf_preverb": "really", 
        "past_preverb": "really", 
        "exp_display": "\u2013pig", 
        "gen_preverb": "really", 
        "exp": "\u2013pig[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "188": {
        "description": "really", 
        "ger_preverb": "really", 
        "is": true, 
        "inf_preverb": "really", 
        "past_preverb": "really", 
        "exp_display": "\u2013piar", 
        "gen_preverb": "really", 
        "exp": "\u2013piar[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "189": {
        "match_case": true, 
        "exp_display": "\u2013pigar", 
        "description": "very much so", 
        "exp": "\u2013pigar[V\u2192V]", 
        "postverb": "very much so"
    }, 
    "190": {
        "match_case": true, 
        "exp_display": "\u2013q\u0332aci", 
        "description": "in a minor way", 
        "exp": "\u2013qaci[V\u2192V]", 
        "postverb": "in a minor way"
    }, 
    "191": {
        "description": "merely", 
        "ger_preverb": "merely", 
        "is": true, 
        "inf_preverb": "merely", 
        "past_preverb": "merely", 
        "exp_display": "\u2013q\u0332ainar", 
        "gen_preverb": "merely", 
        "exp": "\u2013qainar[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "192": {
        "description": "ready to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be ready to", 
        "past_preverb": "", 
        "exp_display": "\u2013q\u0332ainaurte", 
        "gen_preverb": "ready to", 
        "exp": "\u2013qainaurte[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being ready to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "193": {
        "match_case": true, 
        "exp_display": "\u2013q\u0332apiar(ar)", 
        "description": "very much so", 
        "exp": "\u2013qapiar(ar)[V\u2192V]", 
        "postverb": "very much so"
    }, 
    "194": {
        "match_case": true, 
        "exp_display": "\u2013q\u0332apigte", 
        "description": "very much so", 
        "exp": "\u2013qapigte[V\u2192V]", 
        "postverb": "very much so"
    }, 
    "195": {
        "match_case": true, 
        "exp_display": "\u2013q\u0332araqe", 
        "description": "intermittently", 
        "exp": "\u2013qaqe1[V\u2192V]", 
        "postverb": "intermittently"
    }, 
    "196": {
        "match_case": true, 
        "exp_display": "@\u2075qaqe", 
        "description": "one after another", 
        "exp": "@qaqe2[V\u2192V]", 
        "postverb": "one after another"
    }, 
    "197": {
        "match_case": true, 
        "exp_display": "\u2013q\u0332aqu", 
        "description": "now and then", 
        "exp": "\u2013qaqu[V\u2192V]", 
        "postverb": "now and then"
    }, 
    "198": {
        "match_case": true, 
        "exp_display": "\u2013q\u0332aqur(ar)", 
        "description": "now and then", 
        "exp": "\u2013qaqur(ar)[V\u2192V]", 
        "postverb": "now and then"
    }, 
    "199": {
        "match_case": true, 
        "exp_display": "\u2013q\u0332ar", 
        "description": "briefly", 
        "exp": "\u2013qar[V\u2192V]", 
        "postverb": "briefly"
    }, 
    "201": {
        "description": "slowly starting to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "slowly start to", 
        "past_preverb": "", 
        "exp_display": "\u2013q\u0332ataar(ar)", 
        "gen_preverb": "slowly starting to", 
        "exp": "\u2013qataar(ar)[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "slowly starting to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "202": {
        "description": "about to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be about to", 
        "past_preverb": "", 
        "exp_display": "\u2013q\u0332atar", 
        "gen_preverb": "about to", 
        "exp": "\u2013qatar[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being about to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "203": {
        "description": "trying (despite difficulties) to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "try (despite difficulties) to", 
        "past_preverb": "", 
        "exp_display": "\u2013q\u0332caar(ar)", 
        "gen_preverb": "trying (despite difficulties) to", 
        "exp": "\u2013qcaar(ar)[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "trying (despite difficulties) to ", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "204": {
        "match_case": true, 
        "exp_display": "\u2013qerte", 
        "description": "suddenly, hurriedly", 
        "exp": "\u2013qerte[V\u2192V]", 
        "postverb": "suddenly, hurriedly"
    }, 
    "205": {
        "match_case": true, 
        "exp_display": "\u2013q\u0332etaar", 
        "description": "repeatedly at intervals", 
        "exp": "\u2013qetaar[V\u2192V]", 
        "postverb": "repeatedly at intervals"
    }, 
    "206": {
        "match_case": true, 
        "exp_display": "@\u2013qtaar", 
        "description": "repeatedly at intervals", 
        "exp": "@\u2013qtaar[V\u2192V]", 
        "postverb": "repeatedly at intervals"
    }, 
    "207": {
        "match_case": true, 
        "exp_display": "\u2013q\u0332tar", 
        "description": "weakly, helplessly, dearly", 
        "exp": "\u2013qtar[V\u2192V]", 
        "postverb": "weakly, helplessly, dearly"
    }, 
    "208": {
        "match_case": true, 
        "exp_display": "\u2013q\u0332tarar(ar)", 
        "description": "slowly and with difficulty because of disability", 
        "exp": "\u2013qtarar(ar)[V\u2192V]", 
        "postverb": "slowly and with difficulty because of disability"
    }, 
    "209": {
        "match_case": true, 
        "exp_display": "\u2013q\u0332u", 
        "description": "one after another", 
        "exp": "\u2013qu1[V\u2192V]", 
        "postverb": "one after another"
    }, 
    "210": {
        "match_case": true, 
        "exp_display": "@\u2075\u2013qur", 
        "description": "using repeated action to accomplish the act", 
        "exp": "@\u2013qur[V\u2192V]", 
        "postverb": "using repeated action to accomplish the act"
    }, 
    "211": {
        "match_case": true, 
        "exp_display": "\u2013r\u0332paga", 
        "description": "hard at intervals", 
        "exp": "\u2013rpaga[V\u2192V]", 
        "postverb": "hard at intervals"
    }, 
    "212": {
        "match_case": true, 
        "exp_display": "\u2013r\u0332pag", 
        "description": "hard", 
        "exp": "\u2013rpag[V\u2192V]", 
        "postverb": "hard"
    }, 
    "213": {
        "match_case": true, 
        "exp_display": "\u2013r\u0332pakar", 
        "description": "so much, for so long", 
        "exp": "\u2013rpakar[V\u2192V]", 
        "postverb": "so much, for so long"
    }, 
    "214": {
        "match_case": true, 
        "exp_display": "@\u2075\u2013rqe", 
        "description": "one after another", 
        "exp": "@\u2013rqe1[V\u2192V]", 
        "postverb": "one after another"
    }, 
    "217": {
        "match_case": true, 
        "exp_display": "\u2013r\u0332r\u0332ar", 
        "description": "just barely", 
        "exp": "\u2013rrar[V\u2192V]", 
        "postverb": "just barely"
    }, 
    "218": {
        "match_case": true, 
        "exp_display": "\u2013r\u0332r\u0332aar", 
        "description": "first", 
        "exp": "\u2013rraar[V\u2192V]", 
        "postverb": "first"
    }, 
    "219": {
        "description": "constantly", 
        "ger_preverb": "constantly", 
        "is": true, 
        "inf_preverb": "constantly", 
        "past_preverb": "constantly", 
        "exp_display": "\u2013r\u0332r\u0332lainar", 
        "gen_preverb": "constantly", 
        "exp": "\u2013rrlainar[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "220": {
        "match_case": true, 
        "exp_display": "\u2013r\u0332r\u0332luar(ar)", 
        "description": "a little bit", 
        "exp": "\u2013rrluar(ar)[V\u2192V]", 
        "postverb": "a little bit"
    }, 
    "221": {
        "description": "somewhat", 
        "ger_preverb": "somewhat", 
        "is": true, 
        "inf_preverb": "somewhat", 
        "past_preverb": "somewhat", 
        "exp_display": "\u2013r\u0332r\u0332lug", 
        "gen_preverb": "somewhat", 
        "exp": "\u2013rrlug[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "222": {
        "description": "somewhat", 
        "ger_preverb": "somewhat", 
        "is": true, 
        "inf_preverb": "somewhat", 
        "past_preverb": "somewhat", 
        "exp_display": "\u2013r\u0332r\u0332lugte", 
        "gen_preverb": "somewhat", 
        "exp": "\u2013rrlugte[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "223": {
        "match_case": true, 
        "exp_display": "\u2013r\u0332(ur)lur", 
        "description": "poorly, dearly", 
        "exp": "\u2013q(ur)lur[V\u2192V]", 
        "postverb": "poorly, dearly"
    }, 
    "224": {
        "match_case": true, 
        "exp_display": "\u2013r\u0332vaar", 
        "description": "very much so", 
        "exp": "\u2013rvaar[V\u2192V]", 
        "postverb": "very much so"
    }, 
    "225": {
        "match_case": true, 
        "exp_display": "\u2013r\u0332vag", 
        "description": "very much so", 
        "exp": "\u2013rvag[V\u2192V]", 
        "postverb": "very much so"
    }, 
    "226": {
        "description": "unable to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be unable to", 
        "past_preverb": "", 
        "exp_display": "\u2013sciigate\u00b0", 
        "gen_preverb": "unable to", 
        "exp": "\u2013sciigate[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being unable to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "231": {
        "description": "trying to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "try to", 
        "past_preverb": "", 
        "exp_display": "\u2013ssaag", 
        "gen_preverb": "trying to", 
        "exp": "\u2013ssaag1[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "trying to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "232": {
        "match_case": true, 
        "exp_display": "\u2013ssaag", 
        "description": "too much", 
        "exp": "\u2013ssaag3[V\u2192V]", 
        "postverb": "too much"
    }, 
    "233": {
        "match_case": true, 
        "exp_display": "\u2013ssiyaag", 
        "description": "too much", 
        "exp": "\u2013ssiyaag[V\u2192V]", 
        "postverb": "too much"
    }, 
    "235": {
        "match_case": true, 
        "exp_display": "@\u00b2+ta", 
        "description": "to a certain degree", 
        "exp": "@+ta2[V\u2192V]", 
        "postverb": "to a certain degree"
    }, 
    "236": {
        "match_case": true, 
        "exp_display": "+taagute", 
        "description": "back and forth", 
        "exp": "+taagute[V\u2192V]", 
        "postverb": "back and forth"
    }, 
    "237": {
        "description": "acting so as to try to make others feel that ^he^ is", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "act so as to try to make others feel that ^he^ is", 
        "past_preverb": "", 
        "exp_display": "@\u2074+taar", 
        "gen_preverb": "acting so as to try to make others feel that ^he^ is", 
        "exp": "@+taar1[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "acting so as to try to make others feel that ^he^ is", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "238": {
        "description": "tends to often", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": false, 
        "inf_preverb": "tend to often", 
        "past_preverb": "tended to often", 
        "exp_display": "+tar", 
        "gen_preverb": "tends to often", 
        "exp": "+tar[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "tending to often", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "245": {
        "match_case": true, 
        "exp_display": "+ter", 
        "description": "suddenly and willfully", 
        "exp": "+ter[V\u2192V]", 
        "postverb": "suddenly and willfully"
    }, 
    "246": {
        "match_case": true, 
        "exp_display": "\u2013tngurte", 
        "description": "unexpectedly", 
        "exp": "\u2013tngurte[V\u2192V]", 
        "postverb": "unexpectedly"
    }, 
    "247": {
        "match_case": true, 
        "exp_display": "\u2013tmurte", 
        "description": "unexpectedly", 
        "exp": "\u2013tmurte2[V\u2192V]", 
        "postverb": "unexpectedly"
    }, 
    "248": {
        "match_case": true, 
        "exp_display": "\u2013tu", 
        "description": "customarily", 
        "exp": "\u2013tu[V\u2192V]", 
        "postverb": "customarily"
    }, 
    "249": {
        "description": "always", 
        "ger_preverb": "always", 
        "is": true, 
        "inf_preverb": "always", 
        "past_preverb": "always", 
        "exp_display": "+tuinar", 
        "gen_preverb": "always", 
        "exp": "+tuinar[V\u2192V]", 
        "match_case": true, 
        "subj": "it"
    }, 
    "251": {
        "description": "proficiently able to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be proficiently able to", 
        "past_preverb": "", 
        "exp_display": "\u2013turnir", 
        "gen_preverb": "proficiently able to", 
        "exp": "\u2013turnir[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being proficiently able to", 
        "subj": "it", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "252": {
        "description": "pretending to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "pretend to", 
        "past_preverb": "", 
        "exp_display": "@\u00b2~+(ng)uar", 
        "gen_preverb": "pretending to", 
        "exp": "@~+(ng)uar[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "pretending to", 
        "subj": "it", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "253": {
        "description": "continuing to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "continue to", 
        "past_preverb": "", 
        "exp_display": "@\u02c1+`(g|t)ur(ar)", 
        "gen_preverb": "continuing to", 
        "exp": "@+`(g|t)ur(ar)[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "continuing to", 
        "subj": "it", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "254": {
        "description": "finally (after desiring to but not being able to)", 
        "ger_preverb": "finally (after desiring to but not being able to)", 
        "is": true, 
        "inf_preverb": "finally (after desiring to but not being able to)", 
        "past_preverb": "finally (after desiring to but not being able to)", 
        "exp_display": "@\u02c1+`(g|t)urainar", 
        "gen_preverb": "finally (after desiring to but not being able to)", 
        "exp": "@+`(g|t)urainar[V\u2192V]", 
        "match_case": true, 
        "subj": "it"
    }, 
    "255": {
        "description": "always", 
        "ger_preverb": "always", 
        "is": true, 
        "inf_preverb": "always", 
        "past_preverb": "always", 
        "exp_display": "@\u02c1+`(g|t)uralar", 
        "gen_preverb": "always", 
        "exp": "@+`(g|t)uralar[V\u2192V]", 
        "match_case": true, 
        "subj": "it"
    }, 
    "256": {
        "description": "always", 
        "ger_preverb": "always", 
        "is": true, 
        "inf_preverb": "always", 
        "past_preverb": "always", 
        "exp_display": "@\u02c1+`(g|t)ur(ar)lar", 
        "gen_preverb": "always", 
        "exp": "@+`(g|t)ur(ar)lar[V\u2192V]", 
        "match_case": true, 
        "subj": "it"
    }, 
    "257": {
        "description": "always", 
        "ger_preverb": "always", 
        "is": true, 
        "inf_preverb": "always", 
        "past_preverb": "always", 
        "exp_display": "@\u02c1+`(g|t)uratu", 
        "gen_preverb": "always", 
        "exp": "@+`(g|t)uratu[V\u2192V]", 
        "match_case": true, 
        "subj": "it"
    }, 
    "258": {
        "match_case": true, 
        "exp_display": "\u2013vguar(ar)", 
        "description": "a little bit", 
        "exp": "\u2013vguar(ar)[V\u2192V]", 
        "postverb": "a little bit"
    }, 
    "259": {
        "match_case": true, 
        "exp_display": "\u2013vialug", 
        "description": "clumsily", 
        "exp": "\u2013vialug[V\u2192V]", 
        "postverb": "clumsily"
    }, 
    "260": {
        "description": "leaves no room or place to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": false, 
        "inf_preverb": "leave no room or place to", 
        "past_preverb": "left no room or place to", 
        "exp_display": "\u2013viite", 
        "gen_preverb": "leaves no room or place to", 
        "exp": "\u2013viite[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "leaving no room or place to", 
        "subj": "it", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "262": {
        "match_case": true, 
        "exp_display": "\u2013vlaag", 
        "description": "insufficiently", 
        "exp": "\u2013vlaag[V\u2192V]", 
        "postverb": "insufficiently"
    }, 
    "263": {
        "match_case": true, 
        "exp_display": "\u2013vlugte", 
        "description": "sloppily", 
        "exp": "\u2013vlugte[V\u2192V]", 
        "postverb": "sloppily"
    }, 
    "264": {
        "match_case": true, 
        "exp_display": "\u2013vsiar", 
        "description": "even more to completion", 
        "exp": "\u2013vsiar[V\u2192V]", 
        "postverb": "even more to completion"
    }, 
    "265": {
        "match_case": true, 
        "exp_display": "\u2013vyiar", 
        "description": "even more to completion", 
        "exp": "\u2013vyiar[V\u2192V]", 
        "postverb": "even more to completion"
    }, 
    "266": {
        "match_case": true, 
        "exp_display": "\u2013vyirte", 
        "description": "around here and there", 
        "exp": "\u2013vyirte[V\u2192V]", 
        "postverb": "around here and there"
    }, 
    "267": {
        "match_case": true, 
        "exp_display": "@\u02b8~+yaaqe", 
        "description": "in vain (fruitlessly)", 
        "exp": "@~+yaaqe[V\u2192V]", 
        "postverb": "in vain (fruitlessly)"
    }, 
    "268": {
        "description": "very cutely or dearly", 
        "ger_preverb": "very cutely or dearly", 
        "is": true, 
        "inf_preverb": "very cutely or dearly", 
        "past_preverb": "very cutely or dearly", 
        "exp_display": "\u2013ya\u0121ar", 
        "gen_preverb": "very cutely or dearly", 
        "exp": "\u2013ya(g)ar[V\u2192V]", 
        "match_case": true, 
        "subj": "it"
    }, 
    "269": {
        "description": "very cutely or dearly", 
        "ger_preverb": "very cutely or dearly", 
        "is": true, 
        "inf_preverb": "very cutely or dearly", 
        "past_preverb": "very cutely or dearly", 
        "exp_display": "\u2013yagar", 
        "gen_preverb": "very cutely or dearly", 
        "exp": "\u2013yagar[V\u2192V]", 
        "match_case": true, 
        "subj": "it"
    }, 
    "271": {
        "match_case": true, 
        "exp_display": "@\u02b8~+yalqar", 
        "description": "without recompense", 
        "exp": "@~+yalqar[V\u2192V]", 
        "postverb": "without recompense"
    }, 
    "273": {
        "description": "finally", 
        "ger_preverb": "finally", 
        "is": true, 
        "inf_preverb": "finally", 
        "past_preverb": "finally", 
        "exp_display": "@\u02b8~+yaqlir", 
        "gen_preverb": "finally", 
        "exp": "@~+yaqlir[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "275": {
        "match_case": true, 
        "exp_display": "@\u02b8~+yarar", 
        "description": "early", 
        "exp": "@~+yarar[V\u2192V]", 
        "postverb": "early"
    }, 
    "276": {
        "match_case": true, 
        "exp_display": "@\u02b8~+yarar(ar)", 
        "description": "very early", 
        "exp": "@~+yarar(ar)[V\u2192V]", 
        "postverb": "very early"
    }, 
    "277": {
        "description": "almost", 
        "ger_preverb": "almost", 
        "is": true, 
        "inf_preverb": "almost", 
        "past_preverb": "almost", 
        "exp_display": "@\u02b8~+yarpiar", 
        "gen_preverb": "almost", 
        "exp": "@~+yarpiar[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "278": {
        "description": "almost", 
        "ger_preverb": "almost", 
        "is": true, 
        "inf_preverb": "almost", 
        "past_preverb": "almost", 
        "exp_display": "~+yarpigar", 
        "gen_preverb": "almost", 
        "exp": "~+yarpigar[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "279": {
        "description": "going to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "go", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yartur", 
        "gen_preverb": "going to", 
        "exp": "@~+yartur[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "going", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "i"
    }, 
    "280": {
        "description": "starting and continuing to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "start and continue to", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yaurciiqe", 
        "gen_preverb": "starting and continuing to", 
        "exp": "@~+yaurciiqe[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "starting and continuing to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "281": {
        "description": "now able to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be now able to", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yaurte", 
        "gen_preverb": "now able to", 
        "exp": "@~+yaurte[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being now able to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "282": {
        "description": "well able to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be well able to", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~\u2013yu", 
        "gen_preverb": "well able to", 
        "exp": "@~\u2013yu[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being well able to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "283": {
        "description": "", 
        "past_preverb_after": "", 
        "ger_preverb_after": "g", 
        "is": false, 
        "inf_preverb": "", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yuar", 
        "gen_preverb": "", 
        "exp": "@~+yuar[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "", 
        "subj": "", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": ""
    }, 
    "284": {
        "description": "wants to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": false, 
        "inf_preverb": "want to", 
        "past_preverb": "wanted to", 
        "exp_display": "@\u02b8~+yug", 
        "gen_preverb": "wants to", 
        "exp": "@~+yug[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "wanting to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "285": {
        "description": "enjoys ^his^", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": false, 
        "inf_preverb": "enjoy ^his^", 
        "past_preverb": "enjoyed ^his^", 
        "exp_display": "@\u02b8~+yugar", 
        "gen_preverb": "enjoys ^his^", 
        "exp": "@~+yugar[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "enjoying ^his^", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "286": {
        "match_case": true, 
        "exp_display": "@\u02b8~+yugcali", 
        "description": "heartily", 
        "exp": "@~+yugcali[V\u2192V]", 
        "postverb": "heartily"
    }, 
    "288": {
        "description": "definitely no longer going to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be definitely no longer going to", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yugnairute", 
        "gen_preverb": "definitely no longer going to", 
        "exp": "@~+yugnairute[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being definitely no longer going to", 
        "subj": "it", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "289": {
        "description": "definitely not going to ", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be definitely not going to ", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yugnaite\u00b0", 
        "gen_preverb": "definitely not going to ", 
        "exp": "@~+yugnaite1[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being definitely not going to ", 
        "subj": "it", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "291": {
        "description": "probably", 
        "ger_preverb": "probably", 
        "is": true, 
        "inf_preverb": "probably", 
        "past_preverb": "probably", 
        "exp_display": "@\u02b8~+yugnarqe", 
        "gen_preverb": "probably", 
        "exp": "@~+yugnarqe1[V\u2192V]", 
        "match_case": true, 
        "subj": "he"
    }, 
    "292": {
        "description": "such as to make one want to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be such as to make one want to", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yugnarqe", 
        "gen_preverb": "such as to make one want to", 
        "exp": "@~+yugnarqe2[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being such as to make one want to", 
        "subj": "it", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "293": {
        "description": "able to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be able to", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yugnga", 
        "gen_preverb": "able to", 
        "exp": "@~+yugnga[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being able to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "294": {
        "description": "wants (provided it is all right) to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": false, 
        "inf_preverb": "want (provided it is all right) to", 
        "past_preverb": "wanted (provided it was all right) to", 
        "exp_display": "@\u02b8~+yugyaaqe", 
        "gen_preverb": "wants (provided it is all right) to", 
        "exp": "@~+yugyaaqe[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "wanting (provided it is all right) to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "295": {
        "description": "no longer", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "be no longer", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~\u2013yuirute", 
        "gen_preverb": "no longer", 
        "exp": "@~\u2013yuirute[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being no longer", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "296": {
        "description": "never", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "be never", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~\u2013yuite\u00b0", 
        "gen_preverb": "never", 
        "exp": "@~\u2013yuite[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being never", 
        "subj": "he", 
        "inf_preverb_after": "g", 
        "gen_preverb_after": "g"
    }, 
    "297": {
        "description": "ready to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "be ready to", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yukaar(ar)", 
        "gen_preverb": "ready to", 
        "exp": "@~+yukaar(ar)[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "being ready to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "300": {
        "description": "the proper time to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~\u2013yunari", 
        "gen_preverb": "the proper time to", 
        "exp": "@~\u2013yunari[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "", 
        "subj": "it", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "301": {
        "description": "possible to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~\u2013yunarqe", 
        "gen_preverb": "possible to", 
        "exp": "@~\u2013yunarqe[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "", 
        "subj": "it", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "302": {
        "description": "loves", 
        "past_preverb_after": "g", 
        "ger_preverb_after": "g", 
        "is": false, 
        "inf_preverb": "", 
        "past_preverb": "loved", 
        "exp_display": "@\u02b8~+yunqegg", 
        "gen_preverb": "loves", 
        "exp": "@~+yunqegg[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "g"
    }, 
    "303": {
        "description": "continuing not to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yunrite\u00b0", 
        "gen_preverb": "continuing not to", 
        "exp": "@~+yunrite[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "304": {
        "description": "able to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "g", 
        "is": true, 
        "inf_preverb": "", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yuuma", 
        "gen_preverb": "able to", 
        "exp": "@~+yuuma[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "305": {
        "description": "no longer wants to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "g", 
        "is": false, 
        "inf_preverb": "", 
        "past_preverb": "no longer wanted to", 
        "exp_display": "@\u02b8~+yuumiir(ar)te", 
        "gen_preverb": "no longer wants to", 
        "exp": "@~+yuumiir(ar)te[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "306": {
        "description": "not care to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": false, 
        "inf_preverb": "not care to", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yuumiite\u00b0", 
        "gen_preverb": "not care to", 
        "exp": "@~+yuumiite[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "not caring to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }, 
    "307": {
        "description": "yearning to", 
        "past_preverb_after": "i", 
        "ger_preverb_after": "i", 
        "is": true, 
        "inf_preverb": "yearn to", 
        "past_preverb": "", 
        "exp_display": "@\u02b8~+yuumir", 
        "gen_preverb": "yearning to", 
        "exp": "@~+yuumir[V\u2192V]", 
        "match_case": false, 
        "ger_preverb": "yearning to", 
        "subj": "he", 
        "inf_preverb_after": "i", 
        "gen_preverb_after": "i"
    }
}

export const verbPostbases = {
  // '0':{
  //   // id: 0,
  //   description: 'is probably',
  //   englishModifier: (english) => { return 'probably '+ english; },
  //   expression: 'palliq',
  //   expression_conditional: '',
  //   conditional_rule: '',
  //   priority: 1,
  //   tense:'',
  //   allowable_next_ids: [1]
  // },
//   {
//     id: 1,
//     description: 'is evidently (without being observed)',
//     englishModifier: (english) => { return 'evidently '+ english; },
//     expression: '-2ini\\',
//     expression_conditional: '',
//     conditional_rule: '',
//     priority: 1,
//     tense:'',
//     allowable_next_ids: [0]
//   },
//   {
//     id: 2,
//     description: 'is no longer able to',
//     englishModifier: (english) => { return 'no longer able to '+ english; },
//     expression: '+(s)ciigali\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1,3]
//   },
//   {
//     id: 3,
//     description: 'is not able to',
//     englishModifier: (english) => { return 'not able to '+ english; },
//     expression: '+(s)ciigate\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1,2]
//   },

// notis = [1,2,6,7,10]
// future = [1,2]
// infinitive = [1,2,6,8,9,10,11]

// if not added second for notis, use does

  1:{
    // id: 4,
    description: 'will',
    englishModifier: (english) => { return 'will '+ english; },
    englishModifierInfinitive: (english) => { return 'will '+ english; },
    englishModifierGerund: (english) => { return 'will '+ english; },
    englishModifierPast: (english) => { return 'will '+ english; },
    expression: '+ciqe|@ciiqe[V→V]',
    // tense:'future',
    allowable_next_ids: [10, 11, 5, 6, 8, 7, 12, 9],
  },
  2:{
    // id: 4,
    description: 'will not',
    englishModifier: (english) => { return 'will not '+ english; },
    englishModifierInfinitive: (english) => { return 'will not '+ english; },
    englishModifierGerund: (english) => { return 'will not '+ english; },
    englishModifierPast: (english) => { return "won't "+ english; },
    expression: '@~+ngaite[V→V]',
    // tense:'future',
    allowable_next_ids: [6, 10, 11, 9, 12, 7, 8],
  },
  3:{
    // id: 4,
    description: 'probably',
    englishModifier: (english) => { return 'probably '+ english; },
    englishModifierInfinitive: (english) => { return 'probably '+ english; },
    englishModifierGerund: (english) => { return 'probably '+ english; },
    englishModifierPast: (english) => { return 'probably '+ english; },
    expression: '@~+yugnarqe2[V→V]',
    // tense:'',
    allowable_next_ids: [1, 2, 6, 4],
  },
  4:{
    // id: 4,
    description: 'not',
    englishModifier: (english) => { return 'not '+ english; },
    englishModifierInfinitive: (english) => { return 'not '+ english; },
    englishModifierGerund: (english) => { return 'not '+ english; },
    englishModifierPast: (english) => { return 'not '+ english; },
    expression: '–nrite[V→V]',
    // tense:'',
    allowable_next_ids: [6, 5],
  },
  5:{
    // id: 4,
    description: 'deliberately (purposefully)',
    englishModifier: (english) => { return 'deliberately (purposefully) '+ english; },
    englishModifierInfinitive: (english) => { return 'deliberately (purposefully) '+ english; },
    englishModifierGerund: (english) => { return 'deliberately (purposefully) '+ english; },
    englishModifierPast: (english) => { return 'deliberately (purposefully) '+ english; },
    expression: 'saaġi',
    // tense:'',
    allowable_next_ids: [4],
  },

  12:{
    // id: 4,
    description: 'always (regularly)',
    englishModifier: (english) => { return 'always (regularly) '+ english; },
    englishModifierInfinitive: (english) => { return 'always (regularly) '+ english; },
    englishModifierGerund: (english) => { return 'always (regularly) '+ english; },
    englishModifierPast: (english) => { return 'always (regularly) '+ english; },
    expression: '–lar[V→V]',
    // tense:'',
    allowable_next_ids: [6, 11]
  },

  6:{
    // id: 4,
    description: 'wants to',
    englishModifier: (english) => { return 'wanting to '+ english; },
    englishModifierInfinitive: (english) => { return 'want to '+ english; },
    englishModifierGerund: (english) => { return 'wanting to '+ english; },
    englishModifierPast: (english) => { return 'wanted to '+ english; },
    expression: '@~+yug[V→V]',
    // tense:'',
    allowable_next_ids: [11, 9],
  },

  11:{
    // id: 4,
    description: 'beginning to',
    englishModifier: (english) => { return 'beginning to '+ english; },
    englishModifierInfinitive: (english) => { return 'begin to '+ english; },
    englishModifierGerund: (english) => { return 'beginning to '+ english; },
    englishModifierPast: (english) => { return 'began to '+ english; },
    expression: 'rraqsi',
    // tense:'',
    allowable_next_ids: [6]
  },

  10:{
    // id: 4,
    description: 'likes',
    englishModifier: (english) => { return 'likes '+ english; },
    englishModifierInfinitive: (english) => { return 'like '+ english; },
    englishModifierGerund: (english) => { return 'liking '+ english; },
    englishModifierPast: (english) => { return 'liked '+ english; },
    expression: 'llatu',
    // tense:'',
    allowable_next_ids: []
  },

  7:{
    // id: 4,
    description: 'dislikes',
    englishModifier: (english) => { return 'dislikes '+ english; },
    englishModifierInfinitive: (english) => { return 'dislike '+ english; },
    englishModifierGerund: (english) => { return 'disliking '+ english; },
    englishModifierPast: (english) => { return 'disliked '+ english; },
    expression: 'sulait',
    // tense:'',
    allowable_next_ids: []
  },

  8:{
    // id: 4,
    description: 'not able to',
    englishModifier: (english) => { return 'unable to '+ english; },
    englishModifierInfinitive: (english) => { return 'be unable to '+ english; },
    englishModifierGerund: (english) => { return 'being unable to '+ english; },
    englishModifierPast: (english) => { return 'unable to '+ english; },
    expression: '+(s)ciigate[V→V]',
    // tense:'',
    allowable_next_ids: []
  },

  9:{
    // id: 4,
    description: 'able to',
    englishModifier: (english) => { return 'able to '+ english; },
    englishModifierInfinitive: (english) => { return 'be able to '+ english; },
    englishModifierGerund: (english) => { return 'being able to '+ english; },
    englishModifierPast: (english) => { return 'able to '+ english; },
    expression: '@~+yugnga[V→V]',
    // tense:'',
    allowable_next_ids: []
  },



//   {
//     id: 5,
//     description: 'past tense',
//     englishModifier: (english) => { return ''+ english; },
//     expression: '-2ru\\',
//     expression_conditional: '',
//     priority: 3,
//     conditional_rule: '',
//     tense:'past',
//     allowable_next_ids: [7]
//   },
//   {
//     id: 6,
//     description: 'not yet',
//     englishModifier: (english) => { return 'not yet '+ english; },
//     expression: '-ksaite\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7]
//   },
//   {
//     id: 7,
//     description: 'future tense',
//     englishModifier: (english) => { return ''+ english},
//     expression: '+ciqe\\',
//     expression_conditional: '@ciiqe\\',  // conditional te_ending
//     priority: 3,
//     conditional_rule: 'attaching_to_te',  // defined later and if satisfied display expression_conditional
//     tense:'future',
//     allowable_next_ids: [0,1,5,10]
//   },
//   {
//     id: 8,
//     description: 'will not',
//     englishModifier: (english) => { return 'not '+  english; },
//     expression: '@~+6aite\\',
//     expression_conditional: '',
//     priority: 3,
//     conditional_rule: '',
//     tense:'future',
//     allowable_next_ids: [0,1,7,10]
//   },
//   {
//     id: 9,
//     description: 'will soon',
//     englishModifier: (english) => { return 'soon '+ english; },
//     expression: '@~+niarar\\',
//     expression_conditional: '',
//     priority: 3,
//     conditional_rule: '',
//     tense:'future',
//     allowable_next_ids: [0,1,5,6,7,10]
//   },
//   {
//     id: 10,
//     description: 'about to',
//     englishModifier: (english) => { return 'about to '+ english; },
//     expression: '-qatar\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1,7]
//   },
//   {
//     id: 11,
//     description: 'repeatedly',
//     englishModifier: (english) => { return 'repeatedly '+ english; },
//     expression: '-lar\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 12,
//     description: 'doing it again',
//     englishModifier: (english) => { return '(again) '+ english; },
//     expression: '-nqigte\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 13,
//     description: 'almost',
//     englishModifier: (english) => { return 'almost '+ english; },
//     expression: '@~+yarpiar\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 14,
//     description: 'never',
//     englishModifier: (english) => { return 'never '+ english; },
//     expression: '@-~yuite\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 15,
//     description: 'no longer',
//     englishModifier: (english) => { return 'no longer '+ english; },
//     expression: '-nrir\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,27]
//   },
//   {
//     id: 16,
//     description: 'trying (unsuccessfully) to',
//     englishModifier: (english) => { return 'trying (unsuccessfully) to '+ english; },
//     englishModifierInfinitive: (english) => { return 'try (unsuccessfully) to '+ english; },
//     englishModifierGerund: (english) => { return 'trying (unsuccessfully) to '+ english; },
//     expression: '@~+yaaqe\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,17,19]
//   },
//   {
//     id: 17,
//     description: 'trying despite difficulties to',
//     englishModifier: (english) => { return 'trying despite difficulties to '+ english; },
//     englishModifierInfinitive: (english) => { return 'try despite difficulties to '+ english; },
//     englishModifierGerund: (english) => { return 'trying despite difficulties to '+ english; },
//     expression: '-qcaar(ar)\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,16,18]
//   },
//   {
//     id: 18,
//     description: 'trying to',
//     englishModifier: (english) => { return 'trying to '+ english; },
//     englishModifierInfinitive: (english) => { return 'try to '+ english; },
//     englishModifierGerund: (english) => { return 'trying to '+ english; },
//     expression: '-6naqe\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,16,17]
//   },
//   {
//     id: 19,
//     description: 'excessively (too much)',
//     englishModifier: (english) => { return 'excessively '+ english; },
//     expression: '-3iyaag\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 20,
//     description: 'to be more or better at',
//     englishModifier: (english) => { return '(being more or better at) '+ english; },
//     expression: '-nru\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 21,
//     description: 'loves to',
//     englishModifier: (english) => { return 'loves to '+ english; },
//     englishModifierInfinitive: (english) => { return 'love to '+ english; },
//     englishModifierGerund: (english) => { return 'loving to '+ english; },
//     expression: '@~+yunqe4\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 22,
//     description: 'no longer wants to',
//     englishModifier: (english) => { return 'no longer wants to '+ english; },
//     englishModifierInfinitive: (english) => { return 'no longer want to '+ english; },
//     englishModifierGerund: (english) => { return 'no longer wanting to '+ english; },
//     expression: '@~+yuumiir(ar)te\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 23,
//     description: 'not care to',
//     englishModifier: (english) => { return 'not care to '+ english; },
//     englishModifierInfinitive: (english) => { return 'not care to '+ english; },
//     englishModifierGerund: (english) => { return 'not caring to '+ english; },
//     expression: '@~+yuumiite\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 24,
//     description: 'yearns to',
//     englishModifier: (english) => { return 'yearns to '+ english; },
//     englishModifierInfinitive: (english) => { return 'yearn to '+ english; },
//     englishModifierGerund: (english) => { return 'yearning to '+ english; },
//     expression: '@~+yuumir\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 25,
//     description: 'wants to',
//     englishModifier: (english) => { return 'wants to '+ english; },
//     englishModifierInfinitive: (english) => { return 'want to '+ english; },
//     englishModifierGerund: (english) => { return 'wanting to '+ english; },
//     expression: '@~+yug\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 26,
//     description: 'enjoys doing',
//     englishModifier: (english) => { return 'enjoying '+ english; },
//     englishModifierInfinitive: (english) => { return 'enjoy '+ english; },
//     englishModifierGerund: (english) => { return 'enjoying '+ english; },
//     expression: '@~+yugar\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,7,8]
//   },
//   {
//     id: 27,
//     description: 'not',
//     englishModifier: (english) => { return 'not '+ english; },
//     expression: '-nrite\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1]
//   },
//   // {
//   //   id: 28,
//   //   description: 'to ask one to',
//   //   englishModifier: (english) => { return 'to ask one to '+ english; },
//   //   expression: 'sqe-\\',
//   //   expression_conditional: '',
//   //   conditional_rule: '',
//   //   tense:'',
//   //   allowable_next_ids: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29]
//   // },
//   {
//     id: 28,
//     description: 'in the process of',
//     englishModifier: (english) => { return 'in the process of '+ english; },
//     expression: '@~+yartur\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,2,3,4,5,6,7,8,9,10,19]
//   },
//   {
//     id: 29,
//     description: 'definitely no longer going to',
//     englishModifier: (english) => { return 'definitely no longer going to '+ english; },
//     expression: '@~+yugnairute\\',
//     expression_conditional: '',
//     priority: 1,
//     conditional_rule: '',
//     tense:'',
//     allowable_next_ids: [0,1,3,4,8,10], // only refers to the postbases, not the endings
//   }
};
export const nounPostbases = {


  13:{
    // id: 4,
    description: 'good',
    englishModifier: (english) => { return 'good '+ english; },
    englishModifierPlural: (english) => { return 'good '+ english; },

    expression: '–kegtaar(ar*)[N→N]',
    // tense:'future',
    allowable_next_ids: [17,18,19,20,21,22,23,24,25],
  },
  14:{
    // id: 4,
    description: 'big',
    englishModifier: (english) => { return 'big '+ english; },
    englishModifierPlural: (english) => { return 'big '+ english; },
    expression: 'qpak',
    // tense:'future',
    allowable_next_ids: [17,18,19,20,21,22,23,24,25],
  },
  15:{
    // id: 4,
    description: 'bad',
    englishModifier: (english) => { return 'bad '+ english; },
    englishModifierPlural: (english) => { return 'bad '+ english; },
    expression: 'pałłuk',
    // tense:'',
    allowable_next_ids: [17,18,19,20,21,22,23,24,25],
  },
  16:{
    // id: 4,
    description: 'small',
    englishModifier: (english) => { return 'small '+ english; },
    englishModifierPlural: (english) => { return 'small '+ english; },
    expression: 'ŋuluk',
    // tense:'',
    allowable_next_ids: [17,18,19,20,21,22,23,24,25],
  },
  17:{
    // id: 4,
    description: 'it is a N',
    englishModifier: (english) => { return 'a '+ english; },
    englishModifierPlural: (english) => { return ''+ english; },
    expression: 'u',
    // tense:'',
    allowable_next_ids: [13,14,15,16],
  },
  18:{
    // id: 4,
    description: 'it is making N',
    englishModifier: (english) => { return 'making a '+ english; },
    englishModifierPlural: (english) => { return 'making a '+ english; },
    expression: 'liuq',
    // tense:'',
    allowable_next_ids: [13,14,15,16],
  },
  19:{
    // id: 4,
    description: 'it is eating or using N',
    englishModifier: (english) => { return 'eating or using a '+ english; },
    englishModifierPlural: (english) => { return 'eating or using a '+ english; },
    expression: 'tuq',
    // tense:'',
    allowable_next_ids: [13,14,15,16],
  },
  20:{
    // id: 4,
    description: 'it has a N',
    englishModifier: (english) => { return 'has a '+ english; },
    englishModifierPlural: (english) => { return 'have a '+ english; },
    expression: 'qaq',
    // tense:'',
    allowable_next_ids: [13,14,15,16],
  },
  21:{
    // id: 4,
    description: 'it has a small quantity of N',
    englishModifier: (english) => { return 'has a small quantity of '+ english; },
    englishModifierPlural: (english) => { return 'have a small quantity of '+ english; },
    expression: 'kit',
    // tense:'',
    allowable_next_ids: [13,14,15,16],
  },
  22:{
    // id: 4,
    description: 'it lacks N',
    englishModifier: (english) => { return 'lacks a '+ english; },
    englishModifierPlural: (english) => { return 'lack a '+ english; },
    expression: 'it',
    // tense:'',
    allowable_next_ids: [13,14,15,16],
  },
  23:{
    // id: 4,
    description: 'it is located at the N',
    englishModifier: (english) => { return 'located at the '+ english; },
    englishModifierPlural: (english) => { return 'located at the '+ english; },
    expression: '+N+Loc+Sg>miit',
    // tense:'',
    allowable_next_ids: [13,14,15,16],
  },
  24:{
    // id: 4,
    description: 'it is coming from the N',
    englishModifier: (english) => { return 'coming from the '+ english; },
    englishModifierPlural: (english) => { return 'coming from the '+ english; },
    expression: '+N+Abl+Sg>miñŋaq',
    // tense:'',
    allowable_next_ids: [13,14,15,16],
  },
  25:{
    // id: 4,
    description: 'it is going to the N',
    englishModifier: (english) => { return 'going to the '+ english; },
    englishModifierPlural: (english) => { return 'going to the '+ english; },
    expression: '+N+Trm+Sg>muk',
    // tense:'',
    allowable_next_ids: [13,14,15,16],
  },
//   {
//     id: 0,
//     description: 'large',
//     englishModifier: (english) => { return 'large '+ english; },
//     expression_end: '-rpak',
//     expression_postbase: '-rpag\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: [1]
//   },
//   {
//     id: 1,
//     description: 'small',
//     englishModifier: (english) => { return 'small '+ english; },
//     expression_end: '-cuar',
//     expression_postbase: '-cuar\\',
//     expression_conditional_end: '-kcuar',
//     expression_conditional_postbase: '-kcuar(ar)\\',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: [0]
//   },
//   {
//     id: 2,
//     description: 'baby/little',
//     englishModifier: (english) => { return 'baby/little '+ english; },
//     expression_end: '-yagaq',
//     expression_postbase: '-yagar\\',
//     expression_conditional_end: '-yagaq',
//     expression_conditional_postbase: '-yagar\\',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 3,
//     description: 'good',
//     englishModifier: (english) => { return 'good '+ english; },
//     expression_end: '-kegtaar',
//     expression_postbase: '-kegtaar\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 4,
//     description: 'shabby',
//     englishModifier: (english) => { return 'shabby '+ english; },
//     expression_end: '-2er',
//     expression_postbase: '-2er\\',
//     expression_conditional_end: '-2er',
//     expression_conditional_postbase: '-2er\\',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 5,
//     description: 'genuine',
//     englishModifier: (english) => { return 'genuine '+ english; },
//     expression_end: '-piaq',
//     expression_postbase: '-piar\\',
//     expression_conditional_end: '-pik',
//     expression_conditional_postbase: '-pig\\',
//     conditional_rule: '',
//     priority:4,
//     tense:'past',
//     allowable_next_ids: []
//   },
//   {
//     id: 6,
//     description: 'fake',
//     englishModifier: (english) => { return 'fake '+ english; },
//     expression_end: '-(6)uaq',
//     expression_postbase: '-(6)uar\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:4,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 7,
//     description: 'many Ns',
//     englishModifier: (english) => { return 'many of them'+ english},
//     expression_end: '-rugaq',
//     expression_postbase: '-rugar\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:2,
//     tense:'noun_end',
//     allowable_next_ids: []
//   },
//   {
//     id: 8,
//     description: 'just a little',
//     englishModifier: (english) => { return 'just a little'+ english},
//     expression_end: '-5aq',
//     expression_postbase: '-5ar\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:2,
//     tense:'noun_end',
//     allowable_next_ids: []
//   },
//   {
//     id: 9,
//     description: 'N and other',
//     englishModifier: (english) => { return 'and another - only applies to people or animals '+ english; },
//     expression_end: ':(e)nkuk',
//     expression_postbase: ':(e)nkug\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:2,
//     tense:'noun_end',
//     allowable_next_ids: []
//   },
//   {
//     id: 10,
//     description: 'N and others',
//     englishModifier: (english) => { return 'and others - only applies to people or animals '+ english; },
//     expression_end: ':(e)nkut',
//     expression_postbase: ':(e)nkur\\',
//     expression_conditional_end: '',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:2,
//     tense:'noun_end',
//     allowable_next_ids: []
//   },
//   {
//     id: 11,
//     description: 'to hunt',
//     englishModifier: (english) => { return 'hunting '+ english; },
//     expression_postbase: '+cur\\',
//     expression_conditional_postbase: '+ssur\\',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 12,
//     description: 'to make',
//     englishModifier: (english) => { return 'making '+ english; },
//     expression_postbase: '-li\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 13,
//     description: 'to catch lots of',
//     englishModifier: (english) => { return 'catching lots of '+ english; },
//     expression_postbase: '-liqe\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 14,
//     description: 'to have lots of',
//     englishModifier: (english) => { return 'lots of '+ english; },
//     expression_postbase: '-lir\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 15,
//     description: 'to be occupied with',
//     englishModifier: (english) => { return 'occupied with '+ english; },
//     expression_postbase: '-liur\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 16,
//     description: 'to acquire',
//     englishModifier: (english) => { return 'acquiring '+ english; },
//     expression_postbase: '-6e\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 17,
//     description: 'to have',
//     englishModifier: (english) => { return ''+ english; },
//     expression_postbase: '-ngqerr\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 18,
//     description: 'the place does not have',
//     englishModifier: (english) => { return '(location) does not have '+ english; },
//     expression_postbase: '+taite\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 19,
//     description: 'the place has',
//     englishModifier: (english) => { return '(location) has '+ english; },
//     expression_postbase: '+ta6qe5\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 20,
//     description: 'to eat',
//     englishModifier: (english) => { return 'eating '+ english; },
//     expression_postbase: '+tur\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   },
//   {
//     id: 21,
//     description: 'to become',
//     englishModifier: (english) => { return 'become '+ english; },
//     expression_postbase: '~:(6)urte\\',
//     expression_conditional_postbase: '',
//     conditional_rule: '',
//     priority:1,
//     tense:'',
//     allowable_next_ids: []
//   }
};



// WEBPACK FOOTER //
// ./src/components/constants/newconstants.js